export const countries = [
  {
    code: "US",
    states: [
      {
        name: "Alaska",
        abbreviation: "AK",
        counties: [
          {
            name: "ALEUTIANS EAST",
            abbreviation: null,
            code: null,
          },
          {
            name: "ALEUTIANS WEST",
            abbreviation: null,
            code: null,
          },
          {
            name: "ANCHORAGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BETHEL",
            abbreviation: null,
            code: null,
          },
          {
            name: "BRISTOL BAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHUGACH",
            abbreviation: null,
            code: null,
          },
          {
            name: "COPPER RIVER",
            abbreviation: null,
            code: null,
          },
          {
            name: "DENALI",
            abbreviation: null,
            code: null,
          },
          {
            name: "DILLINGHAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "FAIRBANKS NORTH STAR",
            abbreviation: null,
            code: null,
          },
          {
            name: "HAINES",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOONAH-ANGOON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JUNEAU",
            abbreviation: null,
            code: null,
          },
          {
            name: "KENAI PENINSULA",
            abbreviation: null,
            code: null,
          },
          {
            name: "KETCHIKAN GATEWAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "KODIAK ISLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "KUSILVAK",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAKE AND PENINSULA",
            abbreviation: null,
            code: null,
          },
          {
            name: "MATANUSKA-SUSITNA",
            abbreviation: null,
            code: null,
          },
          {
            name: "NOME",
            abbreviation: null,
            code: null,
          },
          {
            name: "NORTH SLOPE",
            abbreviation: null,
            code: null,
          },
          {
            name: "NORTHWEST ARCTIC",
            abbreviation: null,
            code: null,
          },
          {
            name: "PETERSBURG",
            abbreviation: null,
            code: null,
          },
          {
            name: "PRINCE OF WALES-HYDER",
            abbreviation: null,
            code: null,
          },
          {
            name: "SITKA",
            abbreviation: null,
            code: null,
          },
          {
            name: "SKAGWAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "SOUTHEAST FAIRBANKS",
            abbreviation: null,
            code: null,
          },
          {
            name: "WRANGELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "YAKUTAT",
            abbreviation: null,
            code: null,
          },
          {
            name: "YUKON-KOYUKUK",
            abbreviation: null,
            code: null,
          },
          {
            name: "VALDEZ\u2013CORDOVA",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Alabama",
        abbreviation: "AL",
        counties: [
          {
            name: "AUTAUGA",
            abbreviation: null,
            code: null,
          },
          {
            name: "BALDWIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "BARBOUR",
            abbreviation: null,
            code: null,
          },
          {
            name: "BIBB",
            abbreviation: null,
            code: null,
          },
          {
            name: "BLOUNT",
            abbreviation: null,
            code: null,
          },
          {
            name: "BULLOCK",
            abbreviation: null,
            code: null,
          },
          {
            name: "BUTLER",
            abbreviation: null,
            code: null,
          },
          {
            name: "CALHOUN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHAMBERS",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHEROKEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHILTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHOCTAW",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLARKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLEBURNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "COFFEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "COLBERT",
            abbreviation: null,
            code: null,
          },
          {
            name: "CONECUH",
            abbreviation: null,
            code: null,
          },
          {
            name: "COOSA",
            abbreviation: null,
            code: null,
          },
          {
            name: "COVINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CRENSHAW",
            abbreviation: null,
            code: null,
          },
          {
            name: "CULLMAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "DALE",
            abbreviation: null,
            code: null,
          },
          {
            name: "DALLAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "DEKALB",
            abbreviation: null,
            code: null,
          },
          {
            name: "ELMORE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ESCAMBIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "ETOWAH",
            abbreviation: null,
            code: null,
          },
          {
            name: "FAYETTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRANKLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "GENEVA",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREENE",
            abbreviation: null,
            code: null,
          },
          {
            name: "HALE",
            abbreviation: null,
            code: null,
          },
          {
            name: "HENRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOUSTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JACKSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAMAR",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAUDERDALE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAWRENCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LIMESTONE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LOWNDES",
            abbreviation: null,
            code: null,
          },
          {
            name: "MACON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MADISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARENGO",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARION",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARSHALL",
            abbreviation: null,
            code: null,
          },
          {
            name: "MOBILE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONROE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONTGOMERY",
            abbreviation: null,
            code: null,
          },
          {
            name: "MORGAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "PERRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "PICKENS",
            abbreviation: null,
            code: null,
          },
          {
            name: "PIKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "RANDOLPH",
            abbreviation: null,
            code: null,
          },
          {
            name: "RUSSELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHELBY",
            abbreviation: null,
            code: null,
          },
          {
            name: "ST CLAIR",
            abbreviation: null,
            code: null,
          },
          {
            name: "SUMTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "TALLADEGA",
            abbreviation: null,
            code: null,
          },
          {
            name: "TALLAPOOSA",
            abbreviation: null,
            code: null,
          },
          {
            name: "TUSCALOOSA",
            abbreviation: null,
            code: null,
          },
          {
            name: "WALKER",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WILCOX",
            abbreviation: null,
            code: null,
          },
          {
            name: "WINSTON",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Arkansas",
        abbreviation: "AR",
        counties: [
          {
            name: "ARKANSAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "ASHLEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "BAXTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "BENTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "BOONE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BRADLEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CALHOUN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARROLL",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHICOT",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLARK",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLEBURNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLEVELAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "COLUMBIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "CONWAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CRAIGHEAD",
            abbreviation: null,
            code: null,
          },
          {
            name: "CRAWFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "CRITTENDEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CROSS",
            abbreviation: null,
            code: null,
          },
          {
            name: "DALLAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "DESHA",
            abbreviation: null,
            code: null,
          },
          {
            name: "DREW",
            abbreviation: null,
            code: null,
          },
          {
            name: "FAULKNER",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRANKLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "FULTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "GARLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRANT",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREENE",
            abbreviation: null,
            code: null,
          },
          {
            name: "HEMPSTEAD",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOT SPRING",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOWARD",
            abbreviation: null,
            code: null,
          },
          {
            name: "INDEPENDENCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "IZARD",
            abbreviation: null,
            code: null,
          },
          {
            name: "JACKSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JOHNSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAFAYETTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAWRENCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINCOLN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LITTLE RIVER",
            abbreviation: null,
            code: null,
          },
          {
            name: "LOGAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LONOKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MADISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARION",
            abbreviation: null,
            code: null,
          },
          {
            name: "MILLER",
            abbreviation: null,
            code: null,
          },
          {
            name: "MISSISSIPPI",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONROE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONTGOMERY",
            abbreviation: null,
            code: null,
          },
          {
            name: "NEVADA",
            abbreviation: null,
            code: null,
          },
          {
            name: "NEWTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "OUACHITA",
            abbreviation: null,
            code: null,
          },
          {
            name: "PERRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "PHILLIPS",
            abbreviation: null,
            code: null,
          },
          {
            name: "PIKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "POINSETT",
            abbreviation: null,
            code: null,
          },
          {
            name: "POLK",
            abbreviation: null,
            code: null,
          },
          {
            name: "POPE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PRAIRIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PULASKI",
            abbreviation: null,
            code: null,
          },
          {
            name: "RANDOLPH",
            abbreviation: null,
            code: null,
          },
          {
            name: "SALINE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SCOTT",
            abbreviation: null,
            code: null,
          },
          {
            name: "SEARCY",
            abbreviation: null,
            code: null,
          },
          {
            name: "SEBASTIAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "SEVIER",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHARP",
            abbreviation: null,
            code: null,
          },
          {
            name: "ST FRANCIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "STONE",
            abbreviation: null,
            code: null,
          },
          {
            name: "UNION",
            abbreviation: null,
            code: null,
          },
          {
            name: "VAN BUREN",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WHITE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WOODRUFF",
            abbreviation: null,
            code: null,
          },
          {
            name: "YELL",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Arizona",
        abbreviation: "AZ",
        counties: [
          {
            name: "APACHE",
            abbreviation: null,
            code: null,
          },
          {
            name: "COCHISE",
            abbreviation: null,
            code: null,
          },
          {
            name: "COCONINO",
            abbreviation: null,
            code: null,
          },
          {
            name: "GILA",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRAHAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREENLEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LA PAZ",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARICOPA",
            abbreviation: null,
            code: null,
          },
          {
            name: "MOHAVE",
            abbreviation: null,
            code: null,
          },
          {
            name: "NAVAJO",
            abbreviation: null,
            code: null,
          },
          {
            name: "PIMA",
            abbreviation: null,
            code: null,
          },
          {
            name: "PINAL",
            abbreviation: null,
            code: null,
          },
          {
            name: "SANTA CRUZ",
            abbreviation: null,
            code: null,
          },
          {
            name: "YAVAPAI",
            abbreviation: null,
            code: null,
          },
          {
            name: "YUMA",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "California",
        abbreviation: "CA",
        counties: [
          {
            name: "ALAMEDA",
            abbreviation: null,
            code: null,
          },
          {
            name: "ALPINE",
            abbreviation: null,
            code: null,
          },
          {
            name: "AMADOR",
            abbreviation: null,
            code: null,
          },
          {
            name: "BUTTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CALAVERAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "COLUSA",
            abbreviation: null,
            code: null,
          },
          {
            name: "CONTRA COSTA",
            abbreviation: null,
            code: null,
          },
          {
            name: "DEL NORTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "EL DORADO",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRESNO",
            abbreviation: null,
            code: null,
          },
          {
            name: "GLENN",
            abbreviation: null,
            code: null,
          },
          {
            name: "HUMBOLDT",
            abbreviation: null,
            code: null,
          },
          {
            name: "IMPERIAL",
            abbreviation: null,
            code: null,
          },
          {
            name: "INYO",
            abbreviation: null,
            code: null,
          },
          {
            name: "KERN",
            abbreviation: null,
            code: null,
          },
          {
            name: "KINGS",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LASSEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LOS ANGELES",
            abbreviation: null,
            code: null,
          },
          {
            name: "MADERA",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARIPOSA",
            abbreviation: null,
            code: null,
          },
          {
            name: "MENDOCINO",
            abbreviation: null,
            code: null,
          },
          {
            name: "MERCED",
            abbreviation: null,
            code: null,
          },
          {
            name: "MODOC",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONO",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONTEREY",
            abbreviation: null,
            code: null,
          },
          {
            name: "NAPA",
            abbreviation: null,
            code: null,
          },
          {
            name: "NEVADA",
            abbreviation: null,
            code: null,
          },
          {
            name: "ORANGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PLACER",
            abbreviation: null,
            code: null,
          },
          {
            name: "PLUMAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "RIVERSIDE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SACRAMENTO",
            abbreviation: null,
            code: null,
          },
          {
            name: "SAN BENITO",
            abbreviation: null,
            code: null,
          },
          {
            name: "SAN BERNARDINO",
            abbreviation: null,
            code: null,
          },
          {
            name: "SAN DIEGO",
            abbreviation: null,
            code: null,
          },
          {
            name: "SAN FRANCISCO",
            abbreviation: null,
            code: null,
          },
          {
            name: "SAN JOAQUIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "SAN LUIS OBISPO",
            abbreviation: null,
            code: null,
          },
          {
            name: "SAN MATEO",
            abbreviation: null,
            code: null,
          },
          {
            name: "SANTA BARBARA",
            abbreviation: null,
            code: null,
          },
          {
            name: "SANTA CLARA",
            abbreviation: null,
            code: null,
          },
          {
            name: "SANTA CRUZ",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHASTA",
            abbreviation: null,
            code: null,
          },
          {
            name: "SIERRA",
            abbreviation: null,
            code: null,
          },
          {
            name: "SISKIYOU",
            abbreviation: null,
            code: null,
          },
          {
            name: "SOLANO",
            abbreviation: null,
            code: null,
          },
          {
            name: "SONOMA",
            abbreviation: null,
            code: null,
          },
          {
            name: "STANISLAUS",
            abbreviation: null,
            code: null,
          },
          {
            name: "SUTTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "TEHAMA",
            abbreviation: null,
            code: null,
          },
          {
            name: "TRINITY",
            abbreviation: null,
            code: null,
          },
          {
            name: "TULARE",
            abbreviation: null,
            code: null,
          },
          {
            name: "TUOLUMNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "VENTURA",
            abbreviation: null,
            code: null,
          },
          {
            name: "YOLO",
            abbreviation: null,
            code: null,
          },
          {
            name: "YUBA",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Colorado",
        abbreviation: "CO",
        counties: [
          {
            name: "ADAMS",
            abbreviation: null,
            code: null,
          },
          {
            name: "ALAMOSA",
            abbreviation: null,
            code: null,
          },
          {
            name: "ARAPAHOE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ARCHULETA",
            abbreviation: null,
            code: null,
          },
          {
            name: "BACA",
            abbreviation: null,
            code: null,
          },
          {
            name: "BENT",
            abbreviation: null,
            code: null,
          },
          {
            name: "BOULDER",
            abbreviation: null,
            code: null,
          },
          {
            name: "BROOMFIELD",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHAFFEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHEYENNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLEAR CREEK",
            abbreviation: null,
            code: null,
          },
          {
            name: "CONEJOS",
            abbreviation: null,
            code: null,
          },
          {
            name: "COSTILLA",
            abbreviation: null,
            code: null,
          },
          {
            name: "CROWLEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CUSTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "DELTA",
            abbreviation: null,
            code: null,
          },
          {
            name: "DENVER",
            abbreviation: null,
            code: null,
          },
          {
            name: "DOLORES",
            abbreviation: null,
            code: null,
          },
          {
            name: "DOUGLAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "EAGLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "EL PASO",
            abbreviation: null,
            code: null,
          },
          {
            name: "ELBERT",
            abbreviation: null,
            code: null,
          },
          {
            name: "FREMONT",
            abbreviation: null,
            code: null,
          },
          {
            name: "GARFIELD",
            abbreviation: null,
            code: null,
          },
          {
            name: "GILPIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "GUNNISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HINSDALE",
            abbreviation: null,
            code: null,
          },
          {
            name: "HUERFANO",
            abbreviation: null,
            code: null,
          },
          {
            name: "JACKSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "KIOWA",
            abbreviation: null,
            code: null,
          },
          {
            name: "KIT CARSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "LA PLATA",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LARIMER",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAS ANIMAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINCOLN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LOGAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MESA",
            abbreviation: null,
            code: null,
          },
          {
            name: "MINERAL",
            abbreviation: null,
            code: null,
          },
          {
            name: "MOFFAT",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONTEZUMA",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONTROSE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MORGAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "OTERO",
            abbreviation: null,
            code: null,
          },
          {
            name: "OURAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "PARK",
            abbreviation: null,
            code: null,
          },
          {
            name: "PHILLIPS",
            abbreviation: null,
            code: null,
          },
          {
            name: "PITKIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "PROWERS",
            abbreviation: null,
            code: null,
          },
          {
            name: "PUEBLO",
            abbreviation: null,
            code: null,
          },
          {
            name: "RIO BLANCO",
            abbreviation: null,
            code: null,
          },
          {
            name: "RIO GRANDE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROUTT",
            abbreviation: null,
            code: null,
          },
          {
            name: "SAGUACHE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SAN JUAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "SAN MIGUEL",
            abbreviation: null,
            code: null,
          },
          {
            name: "SEDGWICK",
            abbreviation: null,
            code: null,
          },
          {
            name: "SUMMIT",
            abbreviation: null,
            code: null,
          },
          {
            name: "TELLER",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WELD",
            abbreviation: null,
            code: null,
          },
          {
            name: "YUMA",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Connecticut",
        abbreviation: "CT",
        counties: [
          {
            name: "FAIRFIELD",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARTFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "LITCHFIELD",
            abbreviation: null,
            code: null,
          },
          {
            name: "MIDDLESEX",
            abbreviation: null,
            code: null,
          },
          {
            name: "NEW HAVEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "NEW LONDON",
            abbreviation: null,
            code: null,
          },
          {
            name: "TOLLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "WINDHAM",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "District of Columbia",
        abbreviation: "DC",
        counties: [
          {
            name: "DISTRICT OF COLUMBIA",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Delaware",
        abbreviation: "DE",
        counties: [
          {
            name: "KENT",
            abbreviation: null,
            code: null,
          },
          {
            name: "NEW CASTLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SUSSEX",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Florida",
        abbreviation: "FL",
        counties: [
          {
            name: "ALACHUA",
            abbreviation: null,
            code: null,
          },
          {
            name: "BAKER",
            abbreviation: null,
            code: null,
          },
          {
            name: "BAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "BRADFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "BREVARD",
            abbreviation: null,
            code: null,
          },
          {
            name: "BROWARD",
            abbreviation: null,
            code: null,
          },
          {
            name: "CALHOUN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHARLOTTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CITRUS",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "COLLIER",
            abbreviation: null,
            code: null,
          },
          {
            name: "COLUMBIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "DESOTO",
            abbreviation: null,
            code: null,
          },
          {
            name: "DIXIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "DUVAL",
            abbreviation: null,
            code: null,
          },
          {
            name: "ESCAMBIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "FLAGLER",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRANKLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "GADSDEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "GILCHRIST",
            abbreviation: null,
            code: null,
          },
          {
            name: "GLADES",
            abbreviation: null,
            code: null,
          },
          {
            name: "GULF",
            abbreviation: null,
            code: null,
          },
          {
            name: "HAMILTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARDEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "HENDRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "HERNANDO",
            abbreviation: null,
            code: null,
          },
          {
            name: "HIGHLANDS",
            abbreviation: null,
            code: null,
          },
          {
            name: "HILLSBOROUGH",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOLMES",
            abbreviation: null,
            code: null,
          },
          {
            name: "INDIAN RIVER",
            abbreviation: null,
            code: null,
          },
          {
            name: "JACKSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAFAYETTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEON",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEVY",
            abbreviation: null,
            code: null,
          },
          {
            name: "LIBERTY",
            abbreviation: null,
            code: null,
          },
          {
            name: "MADISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MANATEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARION",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARTIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MIAMI-DADE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONROE",
            abbreviation: null,
            code: null,
          },
          {
            name: "NASSAU",
            abbreviation: null,
            code: null,
          },
          {
            name: "OKALOOSA",
            abbreviation: null,
            code: null,
          },
          {
            name: "OKEECHOBEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ORANGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "OSCEOLA",
            abbreviation: null,
            code: null,
          },
          {
            name: "PALM BEACH",
            abbreviation: null,
            code: null,
          },
          {
            name: "PASCO",
            abbreviation: null,
            code: null,
          },
          {
            name: "PINELLAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "POLK",
            abbreviation: null,
            code: null,
          },
          {
            name: "PUTNAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "SANTA ROSA",
            abbreviation: null,
            code: null,
          },
          {
            name: "SARASOTA",
            abbreviation: null,
            code: null,
          },
          {
            name: "SEMINOLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ST JOHNS",
            abbreviation: null,
            code: null,
          },
          {
            name: "ST LUCIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SUMTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "SUWANNEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "TAYLOR",
            abbreviation: null,
            code: null,
          },
          {
            name: "UNION",
            abbreviation: null,
            code: null,
          },
          {
            name: "VOLUSIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "WAKULLA",
            abbreviation: null,
            code: null,
          },
          {
            name: "WALTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Georgia",
        abbreviation: "GA",
        counties: [
          {
            name: "APPLING",
            abbreviation: null,
            code: null,
          },
          {
            name: "ATKINSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "BACON",
            abbreviation: null,
            code: null,
          },
          {
            name: "BAKER",
            abbreviation: null,
            code: null,
          },
          {
            name: "BALDWIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "BANKS",
            abbreviation: null,
            code: null,
          },
          {
            name: "BARROW",
            abbreviation: null,
            code: null,
          },
          {
            name: "BARTOW",
            abbreviation: null,
            code: null,
          },
          {
            name: "BEN HILL",
            abbreviation: null,
            code: null,
          },
          {
            name: "BERRIEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "BIBB",
            abbreviation: null,
            code: null,
          },
          {
            name: "BLECKLEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "BRANTLEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "BROOKS",
            abbreviation: null,
            code: null,
          },
          {
            name: "BRYAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "BULLOCH",
            abbreviation: null,
            code: null,
          },
          {
            name: "BURKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BUTTS",
            abbreviation: null,
            code: null,
          },
          {
            name: "CALHOUN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CAMDEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CANDLER",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARROLL",
            abbreviation: null,
            code: null,
          },
          {
            name: "CATOOSA",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHARLTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHATHAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHATTAHOOCHEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHATTOOGA",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHEROKEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLARKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLAYTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLINCH",
            abbreviation: null,
            code: null,
          },
          {
            name: "COBB",
            abbreviation: null,
            code: null,
          },
          {
            name: "COFFEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "COLQUITT",
            abbreviation: null,
            code: null,
          },
          {
            name: "COLUMBIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "COOK",
            abbreviation: null,
            code: null,
          },
          {
            name: "COWETA",
            abbreviation: null,
            code: null,
          },
          {
            name: "CRAWFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "CRISP",
            abbreviation: null,
            code: null,
          },
          {
            name: "DADE",
            abbreviation: null,
            code: null,
          },
          {
            name: "DAWSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "DECATUR",
            abbreviation: null,
            code: null,
          },
          {
            name: "DEKALB",
            abbreviation: null,
            code: null,
          },
          {
            name: "DODGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "DOOLY",
            abbreviation: null,
            code: null,
          },
          {
            name: "DOUGHERTY",
            abbreviation: null,
            code: null,
          },
          {
            name: "DOUGLAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "EARLY",
            abbreviation: null,
            code: null,
          },
          {
            name: "ECHOLS",
            abbreviation: null,
            code: null,
          },
          {
            name: "EFFINGHAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "ELBERT",
            abbreviation: null,
            code: null,
          },
          {
            name: "EMANUEL",
            abbreviation: null,
            code: null,
          },
          {
            name: "EVANS",
            abbreviation: null,
            code: null,
          },
          {
            name: "FANNIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "FAYETTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "FLOYD",
            abbreviation: null,
            code: null,
          },
          {
            name: "FORSYTH",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRANKLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "FULTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "GILMER",
            abbreviation: null,
            code: null,
          },
          {
            name: "GLASCOCK",
            abbreviation: null,
            code: null,
          },
          {
            name: "GLYNN",
            abbreviation: null,
            code: null,
          },
          {
            name: "GORDON",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRADY",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREENE",
            abbreviation: null,
            code: null,
          },
          {
            name: "GWINNETT",
            abbreviation: null,
            code: null,
          },
          {
            name: "HABERSHAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "HALL",
            abbreviation: null,
            code: null,
          },
          {
            name: "HANCOCK",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARALSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARRIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "HART",
            abbreviation: null,
            code: null,
          },
          {
            name: "HEARD",
            abbreviation: null,
            code: null,
          },
          {
            name: "HENRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOUSTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "IRWIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "JACKSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JASPER",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFF DAVIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JENKINS",
            abbreviation: null,
            code: null,
          },
          {
            name: "JOHNSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JONES",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAMAR",
            abbreviation: null,
            code: null,
          },
          {
            name: "LANIER",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAURENS",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LIBERTY",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINCOLN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LONG",
            abbreviation: null,
            code: null,
          },
          {
            name: "LOWNDES",
            abbreviation: null,
            code: null,
          },
          {
            name: "LUMPKIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MACON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MADISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARION",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCDUFFIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCINTOSH",
            abbreviation: null,
            code: null,
          },
          {
            name: "MERIWETHER",
            abbreviation: null,
            code: null,
          },
          {
            name: "MILLER",
            abbreviation: null,
            code: null,
          },
          {
            name: "MITCHELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONROE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONTGOMERY",
            abbreviation: null,
            code: null,
          },
          {
            name: "MORGAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MURRAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "MUSCOGEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "NEWTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "OCONEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "OGLETHORPE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PAULDING",
            abbreviation: null,
            code: null,
          },
          {
            name: "PEACH",
            abbreviation: null,
            code: null,
          },
          {
            name: "PICKENS",
            abbreviation: null,
            code: null,
          },
          {
            name: "PIERCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PIKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "POLK",
            abbreviation: null,
            code: null,
          },
          {
            name: "PULASKI",
            abbreviation: null,
            code: null,
          },
          {
            name: "PUTNAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "QUITMAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "RABUN",
            abbreviation: null,
            code: null,
          },
          {
            name: "RANDOLPH",
            abbreviation: null,
            code: null,
          },
          {
            name: "RICHMOND",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROCKDALE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SCHLEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "SCREVEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "SEMINOLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SPALDING",
            abbreviation: null,
            code: null,
          },
          {
            name: "STEPHENS",
            abbreviation: null,
            code: null,
          },
          {
            name: "STEWART",
            abbreviation: null,
            code: null,
          },
          {
            name: "SUMTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "TALBOT",
            abbreviation: null,
            code: null,
          },
          {
            name: "TALIAFERRO",
            abbreviation: null,
            code: null,
          },
          {
            name: "TATTNALL",
            abbreviation: null,
            code: null,
          },
          {
            name: "TAYLOR",
            abbreviation: null,
            code: null,
          },
          {
            name: "TELFAIR",
            abbreviation: null,
            code: null,
          },
          {
            name: "TERRELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "THOMAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "TIFT",
            abbreviation: null,
            code: null,
          },
          {
            name: "TOOMBS",
            abbreviation: null,
            code: null,
          },
          {
            name: "TOWNS",
            abbreviation: null,
            code: null,
          },
          {
            name: "TREUTLEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "TROUP",
            abbreviation: null,
            code: null,
          },
          {
            name: "TURNER",
            abbreviation: null,
            code: null,
          },
          {
            name: "TWIGGS",
            abbreviation: null,
            code: null,
          },
          {
            name: "UNION",
            abbreviation: null,
            code: null,
          },
          {
            name: "UPSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WALKER",
            abbreviation: null,
            code: null,
          },
          {
            name: "WALTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WARE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WARREN",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WAYNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WEBSTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "WHEELER",
            abbreviation: null,
            code: null,
          },
          {
            name: "WHITE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WHITFIELD",
            abbreviation: null,
            code: null,
          },
          {
            name: "WILCOX",
            abbreviation: null,
            code: null,
          },
          {
            name: "WILKES",
            abbreviation: null,
            code: null,
          },
          {
            name: "WILKINSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WORTH",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Hawaii",
        abbreviation: "HI",
        counties: [
          {
            name: "HAWAII",
            abbreviation: null,
            code: null,
          },
          {
            name: "HONOLULU",
            abbreviation: null,
            code: null,
          },
          {
            name: "KALAWAO",
            abbreviation: null,
            code: null,
          },
          {
            name: "KAUAI",
            abbreviation: null,
            code: null,
          },
          {
            name: "MAUI",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Iowa",
        abbreviation: "IA",
        counties: [
          {
            name: "ADAIR",
            abbreviation: null,
            code: null,
          },
          {
            name: "ADAMS",
            abbreviation: null,
            code: null,
          },
          {
            name: "ALLAMAKEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "APPANOOSE",
            abbreviation: null,
            code: null,
          },
          {
            name: "AUDUBON",
            abbreviation: null,
            code: null,
          },
          {
            name: "BENTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "BLACK HAWK",
            abbreviation: null,
            code: null,
          },
          {
            name: "BOONE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BREMER",
            abbreviation: null,
            code: null,
          },
          {
            name: "BUCHANAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "BUENA VISTA",
            abbreviation: null,
            code: null,
          },
          {
            name: "BUTLER",
            abbreviation: null,
            code: null,
          },
          {
            name: "CALHOUN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARROLL",
            abbreviation: null,
            code: null,
          },
          {
            name: "CASS",
            abbreviation: null,
            code: null,
          },
          {
            name: "CEDAR",
            abbreviation: null,
            code: null,
          },
          {
            name: "CERRO GORDO",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHEROKEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHICKASAW",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLARKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLAYTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLINTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CRAWFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "DALLAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "DAVIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "DECATUR",
            abbreviation: null,
            code: null,
          },
          {
            name: "DELAWARE",
            abbreviation: null,
            code: null,
          },
          {
            name: "DES MOINES",
            abbreviation: null,
            code: null,
          },
          {
            name: "DICKINSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "DUBUQUE",
            abbreviation: null,
            code: null,
          },
          {
            name: "EMMET",
            abbreviation: null,
            code: null,
          },
          {
            name: "FAYETTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "FLOYD",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRANKLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "FREMONT",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREENE",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRUNDY",
            abbreviation: null,
            code: null,
          },
          {
            name: "GUTHRIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "HAMILTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HANCOCK",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARDIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARRISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HENRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOWARD",
            abbreviation: null,
            code: null,
          },
          {
            name: "HUMBOLDT",
            abbreviation: null,
            code: null,
          },
          {
            name: "IDA",
            abbreviation: null,
            code: null,
          },
          {
            name: "IOWA",
            abbreviation: null,
            code: null,
          },
          {
            name: "JACKSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JASPER",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JOHNSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JONES",
            abbreviation: null,
            code: null,
          },
          {
            name: "KEOKUK",
            abbreviation: null,
            code: null,
          },
          {
            name: "KOSSUTH",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LOUISA",
            abbreviation: null,
            code: null,
          },
          {
            name: "LUCAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "LYON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MADISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MAHASKA",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARION",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARSHALL",
            abbreviation: null,
            code: null,
          },
          {
            name: "MILLS",
            abbreviation: null,
            code: null,
          },
          {
            name: "MITCHELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONONA",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONROE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONTGOMERY",
            abbreviation: null,
            code: null,
          },
          {
            name: "MUSCATINE",
            abbreviation: null,
            code: null,
          },
          {
            name: "O'BRIEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "OSCEOLA",
            abbreviation: null,
            code: null,
          },
          {
            name: "PAGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PALO ALTO",
            abbreviation: null,
            code: null,
          },
          {
            name: "PLYMOUTH",
            abbreviation: null,
            code: null,
          },
          {
            name: "POCAHONTAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "POLK",
            abbreviation: null,
            code: null,
          },
          {
            name: "POTTAWATTAMIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "POWESHIEK",
            abbreviation: null,
            code: null,
          },
          {
            name: "RINGGOLD",
            abbreviation: null,
            code: null,
          },
          {
            name: "SAC",
            abbreviation: null,
            code: null,
          },
          {
            name: "SCOTT",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHELBY",
            abbreviation: null,
            code: null,
          },
          {
            name: "SIOUX",
            abbreviation: null,
            code: null,
          },
          {
            name: "STORY",
            abbreviation: null,
            code: null,
          },
          {
            name: "TAMA",
            abbreviation: null,
            code: null,
          },
          {
            name: "TAYLOR",
            abbreviation: null,
            code: null,
          },
          {
            name: "UNION",
            abbreviation: null,
            code: null,
          },
          {
            name: "VAN BUREN",
            abbreviation: null,
            code: null,
          },
          {
            name: "WAPELLO",
            abbreviation: null,
            code: null,
          },
          {
            name: "WARREN",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WAYNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WEBSTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "WINNEBAGO",
            abbreviation: null,
            code: null,
          },
          {
            name: "WINNESHIEK",
            abbreviation: null,
            code: null,
          },
          {
            name: "WOODBURY",
            abbreviation: null,
            code: null,
          },
          {
            name: "WORTH",
            abbreviation: null,
            code: null,
          },
          {
            name: "WRIGHT",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Idaho",
        abbreviation: "ID",
        counties: [
          {
            name: "ADA",
            abbreviation: null,
            code: null,
          },
          {
            name: "ADAMS",
            abbreviation: null,
            code: null,
          },
          {
            name: "BANNOCK",
            abbreviation: null,
            code: null,
          },
          {
            name: "BEAR LAKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BENEWAH",
            abbreviation: null,
            code: null,
          },
          {
            name: "BINGHAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "BLAINE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BOISE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BONNER",
            abbreviation: null,
            code: null,
          },
          {
            name: "BONNEVILLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BOUNDARY",
            abbreviation: null,
            code: null,
          },
          {
            name: "BUTTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CAMAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "CANYON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARIBOU",
            abbreviation: null,
            code: null,
          },
          {
            name: "CASSIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLARK",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLEARWATER",
            abbreviation: null,
            code: null,
          },
          {
            name: "CUSTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "ELMORE",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRANKLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "FREMONT",
            abbreviation: null,
            code: null,
          },
          {
            name: "GEM",
            abbreviation: null,
            code: null,
          },
          {
            name: "GOODING",
            abbreviation: null,
            code: null,
          },
          {
            name: "IDAHO",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEROME",
            abbreviation: null,
            code: null,
          },
          {
            name: "KOOTENAI",
            abbreviation: null,
            code: null,
          },
          {
            name: "LATAH",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEMHI",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEWIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINCOLN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MADISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MINIDOKA",
            abbreviation: null,
            code: null,
          },
          {
            name: "NEZ PERCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ONEIDA",
            abbreviation: null,
            code: null,
          },
          {
            name: "OWYHEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PAYETTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "POWER",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHOSHONE",
            abbreviation: null,
            code: null,
          },
          {
            name: "TETON",
            abbreviation: null,
            code: null,
          },
          {
            name: "TWIN FALLS",
            abbreviation: null,
            code: null,
          },
          {
            name: "VALLEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Illinois",
        abbreviation: "IL",
        counties: [
          {
            name: "ADAMS",
            abbreviation: null,
            code: null,
          },
          {
            name: "ALEXANDER",
            abbreviation: null,
            code: null,
          },
          {
            name: "BOND",
            abbreviation: null,
            code: null,
          },
          {
            name: "BOONE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BROWN",
            abbreviation: null,
            code: null,
          },
          {
            name: "BUREAU",
            abbreviation: null,
            code: null,
          },
          {
            name: "CALHOUN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARROLL",
            abbreviation: null,
            code: null,
          },
          {
            name: "CASS",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHAMPAIGN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHRISTIAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLARK",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLINTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "COLES",
            abbreviation: null,
            code: null,
          },
          {
            name: "COOK",
            abbreviation: null,
            code: null,
          },
          {
            name: "CRAWFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "CUMBERLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "DEWITT",
            abbreviation: null,
            code: null,
          },
          {
            name: "DEKALB",
            abbreviation: null,
            code: null,
          },
          {
            name: "DOUGLAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "DUPAGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "EDGAR",
            abbreviation: null,
            code: null,
          },
          {
            name: "EDWARDS",
            abbreviation: null,
            code: null,
          },
          {
            name: "EFFINGHAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "FAYETTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "FORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRANKLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "FULTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "GALLATIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREENE",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRUNDY",
            abbreviation: null,
            code: null,
          },
          {
            name: "HAMILTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HANCOCK",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARDIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "HENDERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HENRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "IROQUOIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "JACKSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JASPER",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JERSEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "JO DAVIESS",
            abbreviation: null,
            code: null,
          },
          {
            name: "JOHNSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "KANE",
            abbreviation: null,
            code: null,
          },
          {
            name: "KANKAKEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "KENDALL",
            abbreviation: null,
            code: null,
          },
          {
            name: "KNOX",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LASALLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAWRENCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LIVINGSTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "LOGAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MACON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MACOUPIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MADISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARION",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARSHALL",
            abbreviation: null,
            code: null,
          },
          {
            name: "MASON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MASSAC",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCDONOUGH",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCHENRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCLEAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MENARD",
            abbreviation: null,
            code: null,
          },
          {
            name: "MERCER",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONROE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONTGOMERY",
            abbreviation: null,
            code: null,
          },
          {
            name: "MORGAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MOULTRIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "OGLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PEORIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "PERRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "PIATT",
            abbreviation: null,
            code: null,
          },
          {
            name: "PIKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "POPE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PULASKI",
            abbreviation: null,
            code: null,
          },
          {
            name: "PUTNAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "RANDOLPH",
            abbreviation: null,
            code: null,
          },
          {
            name: "RICHLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROCK ISLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "SALINE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SANGAMON",
            abbreviation: null,
            code: null,
          },
          {
            name: "SCHUYLER",
            abbreviation: null,
            code: null,
          },
          {
            name: "SCOTT",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHELBY",
            abbreviation: null,
            code: null,
          },
          {
            name: "ST CLAIR",
            abbreviation: null,
            code: null,
          },
          {
            name: "STARK",
            abbreviation: null,
            code: null,
          },
          {
            name: "STEPHENSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "TAZEWELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "UNION",
            abbreviation: null,
            code: null,
          },
          {
            name: "VERMILION",
            abbreviation: null,
            code: null,
          },
          {
            name: "WABASH",
            abbreviation: null,
            code: null,
          },
          {
            name: "WARREN",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WAYNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WHITE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WHITESIDE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WILL",
            abbreviation: null,
            code: null,
          },
          {
            name: "WILLIAMSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WINNEBAGO",
            abbreviation: null,
            code: null,
          },
          {
            name: "WOODFORD",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Indiana",
        abbreviation: "IN",
        counties: [
          {
            name: "ADAMS",
            abbreviation: null,
            code: null,
          },
          {
            name: "ALLEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "BARTHOLOMEW",
            abbreviation: null,
            code: null,
          },
          {
            name: "BENTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "BLACKFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "BOONE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BROWN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARROLL",
            abbreviation: null,
            code: null,
          },
          {
            name: "CASS",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLARK",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLINTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CRAWFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "DAVIESS",
            abbreviation: null,
            code: null,
          },
          {
            name: "DEARBORN",
            abbreviation: null,
            code: null,
          },
          {
            name: "DECATUR",
            abbreviation: null,
            code: null,
          },
          {
            name: "DEKALB",
            abbreviation: null,
            code: null,
          },
          {
            name: "DELAWARE",
            abbreviation: null,
            code: null,
          },
          {
            name: "DUBOIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "ELKHART",
            abbreviation: null,
            code: null,
          },
          {
            name: "FAYETTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "FLOYD",
            abbreviation: null,
            code: null,
          },
          {
            name: "FOUNTAIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRANKLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "FULTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "GIBSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRANT",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREENE",
            abbreviation: null,
            code: null,
          },
          {
            name: "HAMILTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HANCOCK",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARRISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HENDRICKS",
            abbreviation: null,
            code: null,
          },
          {
            name: "HENRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOWARD",
            abbreviation: null,
            code: null,
          },
          {
            name: "HUNTINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JACKSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JASPER",
            abbreviation: null,
            code: null,
          },
          {
            name: "JAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JENNINGS",
            abbreviation: null,
            code: null,
          },
          {
            name: "JOHNSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "KNOX",
            abbreviation: null,
            code: null,
          },
          {
            name: "KOSCIUSKO",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAGRANGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAPORTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAWRENCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MADISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARION",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARSHALL",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARTIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MIAMI",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONROE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONTGOMERY",
            abbreviation: null,
            code: null,
          },
          {
            name: "MORGAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "NEWTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "NOBLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "OHIO",
            abbreviation: null,
            code: null,
          },
          {
            name: "ORANGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "OWEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "PARKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PERRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "PIKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PORTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "POSEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "PULASKI",
            abbreviation: null,
            code: null,
          },
          {
            name: "PUTNAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "RANDOLPH",
            abbreviation: null,
            code: null,
          },
          {
            name: "RIPLEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "RUSH",
            abbreviation: null,
            code: null,
          },
          {
            name: "SCOTT",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHELBY",
            abbreviation: null,
            code: null,
          },
          {
            name: "SPENCER",
            abbreviation: null,
            code: null,
          },
          {
            name: "ST JOSEPH",
            abbreviation: null,
            code: null,
          },
          {
            name: "STARKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "STEUBEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "SULLIVAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "SWITZERLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "TIPPECANOE",
            abbreviation: null,
            code: null,
          },
          {
            name: "TIPTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "UNION",
            abbreviation: null,
            code: null,
          },
          {
            name: "VANDERBURGH",
            abbreviation: null,
            code: null,
          },
          {
            name: "VERMILLION",
            abbreviation: null,
            code: null,
          },
          {
            name: "VIGO",
            abbreviation: null,
            code: null,
          },
          {
            name: "WABASH",
            abbreviation: null,
            code: null,
          },
          {
            name: "WARREN",
            abbreviation: null,
            code: null,
          },
          {
            name: "WARRICK",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WAYNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WELLS",
            abbreviation: null,
            code: null,
          },
          {
            name: "WHITE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WHITLEY",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Kansas",
        abbreviation: "KS",
        counties: [
          {
            name: "ALLEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "ANDERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "ATCHISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "BARBER",
            abbreviation: null,
            code: null,
          },
          {
            name: "BARTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "BOURBON",
            abbreviation: null,
            code: null,
          },
          {
            name: "BROWN",
            abbreviation: null,
            code: null,
          },
          {
            name: "BUTLER",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHASE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHAUTAUQUA",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHEROKEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHEYENNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLARK",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLOUD",
            abbreviation: null,
            code: null,
          },
          {
            name: "COFFEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "COMANCHE",
            abbreviation: null,
            code: null,
          },
          {
            name: "COWLEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CRAWFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "DECATUR",
            abbreviation: null,
            code: null,
          },
          {
            name: "DICKINSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "DONIPHAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "DOUGLAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "EDWARDS",
            abbreviation: null,
            code: null,
          },
          {
            name: "ELK",
            abbreviation: null,
            code: null,
          },
          {
            name: "ELLIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "ELLSWORTH",
            abbreviation: null,
            code: null,
          },
          {
            name: "FINNEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "FORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRANKLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "GEARY",
            abbreviation: null,
            code: null,
          },
          {
            name: "GOVE",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRAHAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRANT",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREELEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREENWOOD",
            abbreviation: null,
            code: null,
          },
          {
            name: "HAMILTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARPER",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARVEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "HASKELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "HODGEMAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "JACKSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEWELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "JOHNSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "KEARNY",
            abbreviation: null,
            code: null,
          },
          {
            name: "KINGMAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "KIOWA",
            abbreviation: null,
            code: null,
          },
          {
            name: "LABETTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LANE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEAVENWORTH",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINCOLN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LOGAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LYON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARION",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARSHALL",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCPHERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MEADE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MIAMI",
            abbreviation: null,
            code: null,
          },
          {
            name: "MITCHELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONTGOMERY",
            abbreviation: null,
            code: null,
          },
          {
            name: "MORRIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "MORTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "NEMAHA",
            abbreviation: null,
            code: null,
          },
          {
            name: "NEOSHO",
            abbreviation: null,
            code: null,
          },
          {
            name: "NESS",
            abbreviation: null,
            code: null,
          },
          {
            name: "NORTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "OSAGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "OSBORNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "OTTAWA",
            abbreviation: null,
            code: null,
          },
          {
            name: "PAWNEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PHILLIPS",
            abbreviation: null,
            code: null,
          },
          {
            name: "POTTAWATOMIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PRATT",
            abbreviation: null,
            code: null,
          },
          {
            name: "RAWLINS",
            abbreviation: null,
            code: null,
          },
          {
            name: "RENO",
            abbreviation: null,
            code: null,
          },
          {
            name: "REPUBLIC",
            abbreviation: null,
            code: null,
          },
          {
            name: "RICE",
            abbreviation: null,
            code: null,
          },
          {
            name: "RILEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROOKS",
            abbreviation: null,
            code: null,
          },
          {
            name: "RUSH",
            abbreviation: null,
            code: null,
          },
          {
            name: "RUSSELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "SALINE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SCOTT",
            abbreviation: null,
            code: null,
          },
          {
            name: "SEDGWICK",
            abbreviation: null,
            code: null,
          },
          {
            name: "SEWARD",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHAWNEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHERIDAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHERMAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "SMITH",
            abbreviation: null,
            code: null,
          },
          {
            name: "STAFFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "STANTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "STEVENS",
            abbreviation: null,
            code: null,
          },
          {
            name: "SUMNER",
            abbreviation: null,
            code: null,
          },
          {
            name: "THOMAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "TREGO",
            abbreviation: null,
            code: null,
          },
          {
            name: "WABAUNSEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WALLACE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WICHITA",
            abbreviation: null,
            code: null,
          },
          {
            name: "WILSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WOODSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WYANDOTTE",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Kentucky",
        abbreviation: "KY",
        counties: [
          {
            name: "ADAIR",
            abbreviation: null,
            code: null,
          },
          {
            name: "ALLEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "ANDERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "BALLARD",
            abbreviation: null,
            code: null,
          },
          {
            name: "BARREN",
            abbreviation: null,
            code: null,
          },
          {
            name: "BATH",
            abbreviation: null,
            code: null,
          },
          {
            name: "BELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "BOONE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BOURBON",
            abbreviation: null,
            code: null,
          },
          {
            name: "BOYD",
            abbreviation: null,
            code: null,
          },
          {
            name: "BOYLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BRACKEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "BREATHITT",
            abbreviation: null,
            code: null,
          },
          {
            name: "BRECKINRIDGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BULLITT",
            abbreviation: null,
            code: null,
          },
          {
            name: "BUTLER",
            abbreviation: null,
            code: null,
          },
          {
            name: "CALDWELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "CALLOWAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CAMPBELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARLISLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARROLL",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "CASEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHRISTIAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLARK",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLINTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CRITTENDEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CUMBERLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "DAVIESS",
            abbreviation: null,
            code: null,
          },
          {
            name: "EDMONSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "ELLIOTT",
            abbreviation: null,
            code: null,
          },
          {
            name: "ESTILL",
            abbreviation: null,
            code: null,
          },
          {
            name: "FAYETTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "FLEMING",
            abbreviation: null,
            code: null,
          },
          {
            name: "FLOYD",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRANKLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "FULTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "GALLATIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "GARRARD",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRANT",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRAVES",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRAYSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREENUP",
            abbreviation: null,
            code: null,
          },
          {
            name: "HANCOCK",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARDIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARLAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARRISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HART",
            abbreviation: null,
            code: null,
          },
          {
            name: "HENDERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HENRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "HICKMAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOPKINS",
            abbreviation: null,
            code: null,
          },
          {
            name: "JACKSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JESSAMINE",
            abbreviation: null,
            code: null,
          },
          {
            name: "JOHNSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "KENTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "KNOTT",
            abbreviation: null,
            code: null,
          },
          {
            name: "KNOX",
            abbreviation: null,
            code: null,
          },
          {
            name: "LARUE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAUREL",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAWRENCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LESLIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LETCHER",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEWIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINCOLN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LIVINGSTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "LOGAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LYON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MADISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MAGOFFIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARION",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARSHALL",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARTIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MASON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCCRACKEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCCREARY",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCLEAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MEADE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MENIFEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MERCER",
            abbreviation: null,
            code: null,
          },
          {
            name: "METCALFE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONROE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONTGOMERY",
            abbreviation: null,
            code: null,
          },
          {
            name: "MORGAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MUHLENBERG",
            abbreviation: null,
            code: null,
          },
          {
            name: "NELSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "NICHOLAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "OHIO",
            abbreviation: null,
            code: null,
          },
          {
            name: "OLDHAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "OWEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "OWSLEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "PENDLETON",
            abbreviation: null,
            code: null,
          },
          {
            name: "PERRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "PIKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "POWELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "PULASKI",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROBERTSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROCKCASTLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROWAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "RUSSELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "SCOTT",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHELBY",
            abbreviation: null,
            code: null,
          },
          {
            name: "SIMPSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "SPENCER",
            abbreviation: null,
            code: null,
          },
          {
            name: "TAYLOR",
            abbreviation: null,
            code: null,
          },
          {
            name: "TODD",
            abbreviation: null,
            code: null,
          },
          {
            name: "TRIGG",
            abbreviation: null,
            code: null,
          },
          {
            name: "TRIMBLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "UNION",
            abbreviation: null,
            code: null,
          },
          {
            name: "WARREN",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WAYNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WEBSTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "WHITLEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "WOLFE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WOODFORD",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Louisiana",
        abbreviation: "LA",
        counties: [
          {
            name: "ACADIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "ALLEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "ASCENSION",
            abbreviation: null,
            code: null,
          },
          {
            name: "ASSUMPTION",
            abbreviation: null,
            code: null,
          },
          {
            name: "AVOYELLES",
            abbreviation: null,
            code: null,
          },
          {
            name: "BEAUREGARD",
            abbreviation: null,
            code: null,
          },
          {
            name: "BIENVILLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BOSSIER",
            abbreviation: null,
            code: null,
          },
          {
            name: "CADDO",
            abbreviation: null,
            code: null,
          },
          {
            name: "CALCASIEU",
            abbreviation: null,
            code: null,
          },
          {
            name: "CALDWELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "CAMERON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CATAHOULA",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLAIBORNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CONCORDIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "DE SOTO",
            abbreviation: null,
            code: null,
          },
          {
            name: "EAST BATON ROUGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "EAST CARROLL",
            abbreviation: null,
            code: null,
          },
          {
            name: "EAST FELICIANA",
            abbreviation: null,
            code: null,
          },
          {
            name: "EVANGELINE",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRANKLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRANT",
            abbreviation: null,
            code: null,
          },
          {
            name: "IBERIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "IBERVILLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "JACKSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON DAVIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAFAYETTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAFOURCHE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LASALLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINCOLN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LIVINGSTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MADISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MOREHOUSE",
            abbreviation: null,
            code: null,
          },
          {
            name: "NATCHITOCHES",
            abbreviation: null,
            code: null,
          },
          {
            name: "ORLEANS",
            abbreviation: null,
            code: null,
          },
          {
            name: "OUACHITA",
            abbreviation: null,
            code: null,
          },
          {
            name: "PLAQUEMINES",
            abbreviation: null,
            code: null,
          },
          {
            name: "POINTE COUPEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "RAPIDES",
            abbreviation: null,
            code: null,
          },
          {
            name: "RED RIVER",
            abbreviation: null,
            code: null,
          },
          {
            name: "RICHLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "SABINE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ST BERNARD",
            abbreviation: null,
            code: null,
          },
          {
            name: "ST CHARLES",
            abbreviation: null,
            code: null,
          },
          {
            name: "ST HELENA",
            abbreviation: null,
            code: null,
          },
          {
            name: "ST JAMES",
            abbreviation: null,
            code: null,
          },
          {
            name: "ST JOHN THE BAPTIST",
            abbreviation: null,
            code: null,
          },
          {
            name: "ST LANDRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "ST MARTIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "ST MARY",
            abbreviation: null,
            code: null,
          },
          {
            name: "ST TAMMANY",
            abbreviation: null,
            code: null,
          },
          {
            name: "TANGIPAHOA",
            abbreviation: null,
            code: null,
          },
          {
            name: "TENSAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "TERREBONNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "UNION",
            abbreviation: null,
            code: null,
          },
          {
            name: "VERMILION",
            abbreviation: null,
            code: null,
          },
          {
            name: "VERNON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WEBSTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "WEST BATON ROUGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WEST CARROLL",
            abbreviation: null,
            code: null,
          },
          {
            name: "WEST FELICIANA",
            abbreviation: null,
            code: null,
          },
          {
            name: "WINN",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Massachusetts",
        abbreviation: "MA",
        counties: [
          {
            name: "BARNSTABLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BERKSHIRE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BRISTOL",
            abbreviation: null,
            code: null,
          },
          {
            name: "DUKES",
            abbreviation: null,
            code: null,
          },
          {
            name: "ESSEX",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRANKLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "HAMPDEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "HAMPSHIRE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MIDDLESEX",
            abbreviation: null,
            code: null,
          },
          {
            name: "NANTUCKET",
            abbreviation: null,
            code: null,
          },
          {
            name: "NORFOLK",
            abbreviation: null,
            code: null,
          },
          {
            name: "PLYMOUTH",
            abbreviation: null,
            code: null,
          },
          {
            name: "SUFFOLK",
            abbreviation: null,
            code: null,
          },
          {
            name: "WORCESTER",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Maryland",
        abbreviation: "MD",
        counties: [
          {
            name: "ALLEGANY",
            abbreviation: null,
            code: null,
          },
          {
            name: "ANNE ARUNDEL",
            abbreviation: null,
            code: null,
          },
          {
            name: "BALTIMORE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BALTIMORE CITY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CALVERT",
            abbreviation: null,
            code: null,
          },
          {
            name: "CAROLINE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARROLL",
            abbreviation: null,
            code: null,
          },
          {
            name: "CECIL",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHARLES",
            abbreviation: null,
            code: null,
          },
          {
            name: "DORCHESTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "FREDERICK",
            abbreviation: null,
            code: null,
          },
          {
            name: "GARRETT",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOWARD",
            abbreviation: null,
            code: null,
          },
          {
            name: "KENT",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONTGOMERY",
            abbreviation: null,
            code: null,
          },
          {
            name: "PRINCE GEORGE'S",
            abbreviation: null,
            code: null,
          },
          {
            name: "QUEEN ANNE'S",
            abbreviation: null,
            code: null,
          },
          {
            name: "SOMERSET",
            abbreviation: null,
            code: null,
          },
          {
            name: "ST MARY'S",
            abbreviation: null,
            code: null,
          },
          {
            name: "TALBOT",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WICOMICO",
            abbreviation: null,
            code: null,
          },
          {
            name: "WORCESTER",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Maine",
        abbreviation: "ME",
        counties: [
          {
            name: "ANDROSCOGGIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "AROOSTOOK",
            abbreviation: null,
            code: null,
          },
          {
            name: "CUMBERLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRANKLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "HANCOCK",
            abbreviation: null,
            code: null,
          },
          {
            name: "KENNEBEC",
            abbreviation: null,
            code: null,
          },
          {
            name: "KNOX",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINCOLN",
            abbreviation: null,
            code: null,
          },
          {
            name: "OXFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "PENOBSCOT",
            abbreviation: null,
            code: null,
          },
          {
            name: "PISCATAQUIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "SAGADAHOC",
            abbreviation: null,
            code: null,
          },
          {
            name: "SOMERSET",
            abbreviation: null,
            code: null,
          },
          {
            name: "WALDO",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "YORK",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Michigan",
        abbreviation: "MI",
        counties: [
          {
            name: "ALCONA",
            abbreviation: null,
            code: null,
          },
          {
            name: "ALGER",
            abbreviation: null,
            code: null,
          },
          {
            name: "ALLEGAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "ALPENA",
            abbreviation: null,
            code: null,
          },
          {
            name: "ANTRIM",
            abbreviation: null,
            code: null,
          },
          {
            name: "ARENAC",
            abbreviation: null,
            code: null,
          },
          {
            name: "BARAGA",
            abbreviation: null,
            code: null,
          },
          {
            name: "BARRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "BAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "BENZIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BERRIEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "BRANCH",
            abbreviation: null,
            code: null,
          },
          {
            name: "CALHOUN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CASS",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHARLEVOIX",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHEBOYGAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHIPPEWA",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLARE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLINTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CRAWFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "DELTA",
            abbreviation: null,
            code: null,
          },
          {
            name: "DICKINSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "EATON",
            abbreviation: null,
            code: null,
          },
          {
            name: "EMMET",
            abbreviation: null,
            code: null,
          },
          {
            name: "GENESEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "GLADWIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "GOGEBIC",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRAND TRAVERSE",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRATIOT",
            abbreviation: null,
            code: null,
          },
          {
            name: "HILLSDALE",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOUGHTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HURON",
            abbreviation: null,
            code: null,
          },
          {
            name: "INGHAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "IONIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "IOSCO",
            abbreviation: null,
            code: null,
          },
          {
            name: "IRON",
            abbreviation: null,
            code: null,
          },
          {
            name: "ISABELLA",
            abbreviation: null,
            code: null,
          },
          {
            name: "JACKSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "KALAMAZOO",
            abbreviation: null,
            code: null,
          },
          {
            name: "KALKASKA",
            abbreviation: null,
            code: null,
          },
          {
            name: "KENT",
            abbreviation: null,
            code: null,
          },
          {
            name: "KEWEENAW",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAPEER",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEELANAU",
            abbreviation: null,
            code: null,
          },
          {
            name: "LENAWEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LIVINGSTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "LUCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MACKINAC",
            abbreviation: null,
            code: null,
          },
          {
            name: "MACOMB",
            abbreviation: null,
            code: null,
          },
          {
            name: "MANISTEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARQUETTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MASON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MECOSTA",
            abbreviation: null,
            code: null,
          },
          {
            name: "MENOMINEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MIDLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "MISSAUKEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONROE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONTCALM",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONTMORENCY",
            abbreviation: null,
            code: null,
          },
          {
            name: "MUSKEGON",
            abbreviation: null,
            code: null,
          },
          {
            name: "NEWAYGO",
            abbreviation: null,
            code: null,
          },
          {
            name: "OAKLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "OCEANA",
            abbreviation: null,
            code: null,
          },
          {
            name: "OGEMAW",
            abbreviation: null,
            code: null,
          },
          {
            name: "ONTONAGON",
            abbreviation: null,
            code: null,
          },
          {
            name: "OSCEOLA",
            abbreviation: null,
            code: null,
          },
          {
            name: "OSCODA",
            abbreviation: null,
            code: null,
          },
          {
            name: "OTSEGO",
            abbreviation: null,
            code: null,
          },
          {
            name: "OTTAWA",
            abbreviation: null,
            code: null,
          },
          {
            name: "PRESQUE ISLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROSCOMMON",
            abbreviation: null,
            code: null,
          },
          {
            name: "SAGINAW",
            abbreviation: null,
            code: null,
          },
          {
            name: "SANILAC",
            abbreviation: null,
            code: null,
          },
          {
            name: "SCHOOLCRAFT",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHIAWASSEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ST CLAIR",
            abbreviation: null,
            code: null,
          },
          {
            name: "ST JOSEPH",
            abbreviation: null,
            code: null,
          },
          {
            name: "TUSCOLA",
            abbreviation: null,
            code: null,
          },
          {
            name: "VAN BUREN",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHTENAW",
            abbreviation: null,
            code: null,
          },
          {
            name: "WAYNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WEXFORD",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Minnesota",
        abbreviation: "MN",
        counties: [
          {
            name: "AITKIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "ANOKA",
            abbreviation: null,
            code: null,
          },
          {
            name: "BECKER",
            abbreviation: null,
            code: null,
          },
          {
            name: "BELTRAMI",
            abbreviation: null,
            code: null,
          },
          {
            name: "BENTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "BIG STONE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BLUE EARTH",
            abbreviation: null,
            code: null,
          },
          {
            name: "BROWN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARLTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARVER",
            abbreviation: null,
            code: null,
          },
          {
            name: "CASS",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHIPPEWA",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHISAGO",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLEARWATER",
            abbreviation: null,
            code: null,
          },
          {
            name: "COOK",
            abbreviation: null,
            code: null,
          },
          {
            name: "COTTONWOOD",
            abbreviation: null,
            code: null,
          },
          {
            name: "CROW WING",
            abbreviation: null,
            code: null,
          },
          {
            name: "DAKOTA",
            abbreviation: null,
            code: null,
          },
          {
            name: "DODGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "DOUGLAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "FARIBAULT",
            abbreviation: null,
            code: null,
          },
          {
            name: "FILLMORE",
            abbreviation: null,
            code: null,
          },
          {
            name: "FREEBORN",
            abbreviation: null,
            code: null,
          },
          {
            name: "GOODHUE",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRANT",
            abbreviation: null,
            code: null,
          },
          {
            name: "HENNEPIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOUSTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HUBBARD",
            abbreviation: null,
            code: null,
          },
          {
            name: "ISANTI",
            abbreviation: null,
            code: null,
          },
          {
            name: "ITASCA",
            abbreviation: null,
            code: null,
          },
          {
            name: "JACKSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "KANABEC",
            abbreviation: null,
            code: null,
          },
          {
            name: "KANDIYOHI",
            abbreviation: null,
            code: null,
          },
          {
            name: "KITTSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "KOOCHICHING",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAC QUI PARLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAKE OF THE WOODS",
            abbreviation: null,
            code: null,
          },
          {
            name: "LE SUEUR",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINCOLN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LYON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MAHNOMEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARSHALL",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARTIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCLEOD",
            abbreviation: null,
            code: null,
          },
          {
            name: "MEEKER",
            abbreviation: null,
            code: null,
          },
          {
            name: "MILLE LACS",
            abbreviation: null,
            code: null,
          },
          {
            name: "MORRISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MOWER",
            abbreviation: null,
            code: null,
          },
          {
            name: "MURRAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "NICOLLET",
            abbreviation: null,
            code: null,
          },
          {
            name: "NOBLES",
            abbreviation: null,
            code: null,
          },
          {
            name: "NORMAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "OLMSTED",
            abbreviation: null,
            code: null,
          },
          {
            name: "OTTER TAIL",
            abbreviation: null,
            code: null,
          },
          {
            name: "PENNINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "PINE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PIPESTONE",
            abbreviation: null,
            code: null,
          },
          {
            name: "POLK",
            abbreviation: null,
            code: null,
          },
          {
            name: "POPE",
            abbreviation: null,
            code: null,
          },
          {
            name: "RAMSEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "RED LAKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "REDWOOD",
            abbreviation: null,
            code: null,
          },
          {
            name: "RENVILLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "RICE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROCK",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROSEAU",
            abbreviation: null,
            code: null,
          },
          {
            name: "SCOTT",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHERBURNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SIBLEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "ST LOUIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "STEARNS",
            abbreviation: null,
            code: null,
          },
          {
            name: "STEELE",
            abbreviation: null,
            code: null,
          },
          {
            name: "STEVENS",
            abbreviation: null,
            code: null,
          },
          {
            name: "SWIFT",
            abbreviation: null,
            code: null,
          },
          {
            name: "TODD",
            abbreviation: null,
            code: null,
          },
          {
            name: "TRAVERSE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WABASHA",
            abbreviation: null,
            code: null,
          },
          {
            name: "WADENA",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASECA",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WATONWAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "WILKIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "WINONA",
            abbreviation: null,
            code: null,
          },
          {
            name: "WRIGHT",
            abbreviation: null,
            code: null,
          },
          {
            name: "YELLOW MEDICINE",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Missouri",
        abbreviation: "MO",
        counties: [
          {
            name: "ADAIR",
            abbreviation: null,
            code: null,
          },
          {
            name: "ANDREW",
            abbreviation: null,
            code: null,
          },
          {
            name: "ATCHISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "AUDRAIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "BARRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "BARTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "BATES",
            abbreviation: null,
            code: null,
          },
          {
            name: "BENTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "BOLLINGER",
            abbreviation: null,
            code: null,
          },
          {
            name: "BOONE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BUCHANAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "BUTLER",
            abbreviation: null,
            code: null,
          },
          {
            name: "CALDWELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "CALLAWAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CAMDEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CAPE GIRARDEAU",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARROLL",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "CASS",
            abbreviation: null,
            code: null,
          },
          {
            name: "CEDAR",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHARITON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHRISTIAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLARK",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLINTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "COLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "COOPER",
            abbreviation: null,
            code: null,
          },
          {
            name: "CRAWFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "DADE",
            abbreviation: null,
            code: null,
          },
          {
            name: "DALLAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "DAVIESS",
            abbreviation: null,
            code: null,
          },
          {
            name: "DEKALB",
            abbreviation: null,
            code: null,
          },
          {
            name: "DENT",
            abbreviation: null,
            code: null,
          },
          {
            name: "DOUGLAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "DUNKLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRANKLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "GASCONADE",
            abbreviation: null,
            code: null,
          },
          {
            name: "GENTRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREENE",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRUNDY",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARRISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HENRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "HICKORY",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOLT",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOWARD",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOWELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "IRON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JACKSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JASPER",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JOHNSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "KNOX",
            abbreviation: null,
            code: null,
          },
          {
            name: "LACLEDE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAFAYETTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAWRENCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEWIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINCOLN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LIVINGSTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MACON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MADISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARIES",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARION",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCDONALD",
            abbreviation: null,
            code: null,
          },
          {
            name: "MERCER",
            abbreviation: null,
            code: null,
          },
          {
            name: "MILLER",
            abbreviation: null,
            code: null,
          },
          {
            name: "MISSISSIPPI",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONITEAU",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONROE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONTGOMERY",
            abbreviation: null,
            code: null,
          },
          {
            name: "MORGAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "NEW MADRID",
            abbreviation: null,
            code: null,
          },
          {
            name: "NEWTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "NODAWAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "OREGON",
            abbreviation: null,
            code: null,
          },
          {
            name: "OSAGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "OZARK",
            abbreviation: null,
            code: null,
          },
          {
            name: "PEMISCOT",
            abbreviation: null,
            code: null,
          },
          {
            name: "PERRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "PETTIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "PHELPS",
            abbreviation: null,
            code: null,
          },
          {
            name: "PIKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PLATTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "POLK",
            abbreviation: null,
            code: null,
          },
          {
            name: "PULASKI",
            abbreviation: null,
            code: null,
          },
          {
            name: "PUTNAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "RALLS",
            abbreviation: null,
            code: null,
          },
          {
            name: "RANDOLPH",
            abbreviation: null,
            code: null,
          },
          {
            name: "RAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "REYNOLDS",
            abbreviation: null,
            code: null,
          },
          {
            name: "RIPLEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "SALINE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SCHUYLER",
            abbreviation: null,
            code: null,
          },
          {
            name: "SCOTLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "SCOTT",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHANNON",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHELBY",
            abbreviation: null,
            code: null,
          },
          {
            name: "ST CHARLES",
            abbreviation: null,
            code: null,
          },
          {
            name: "ST CLAIR",
            abbreviation: null,
            code: null,
          },
          {
            name: "ST FRANCOIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "ST LOUIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "ST LOUIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "STE GENEVIEVE",
            abbreviation: null,
            code: null,
          },
          {
            name: "STODDARD",
            abbreviation: null,
            code: null,
          },
          {
            name: "STONE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SULLIVAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "TANEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "TEXAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "VERNON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WARREN",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WAYNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WEBSTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "WORTH",
            abbreviation: null,
            code: null,
          },
          {
            name: "WRIGHT",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Mississippi",
        abbreviation: "MS",
        counties: [
          {
            name: "ADAMS",
            abbreviation: null,
            code: null,
          },
          {
            name: "ALCORN",
            abbreviation: null,
            code: null,
          },
          {
            name: "AMITE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ATTALA",
            abbreviation: null,
            code: null,
          },
          {
            name: "BENTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "BOLIVAR",
            abbreviation: null,
            code: null,
          },
          {
            name: "CALHOUN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARROLL",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHICKASAW",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHOCTAW",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLAIBORNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLARKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "COAHOMA",
            abbreviation: null,
            code: null,
          },
          {
            name: "COPIAH",
            abbreviation: null,
            code: null,
          },
          {
            name: "COVINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "DESOTO",
            abbreviation: null,
            code: null,
          },
          {
            name: "FORREST",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRANKLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "GEORGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREENE",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRENADA",
            abbreviation: null,
            code: null,
          },
          {
            name: "HANCOCK",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARRISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HINDS",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOLMES",
            abbreviation: null,
            code: null,
          },
          {
            name: "HUMPHREYS",
            abbreviation: null,
            code: null,
          },
          {
            name: "ISSAQUENA",
            abbreviation: null,
            code: null,
          },
          {
            name: "ITAWAMBA",
            abbreviation: null,
            code: null,
          },
          {
            name: "JACKSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JASPER",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON DAVIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "JONES",
            abbreviation: null,
            code: null,
          },
          {
            name: "KEMPER",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAFAYETTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAMAR",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAUDERDALE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAWRENCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEAKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEFLORE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINCOLN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LOWNDES",
            abbreviation: null,
            code: null,
          },
          {
            name: "MADISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARION",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARSHALL",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONROE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONTGOMERY",
            abbreviation: null,
            code: null,
          },
          {
            name: "NESHOBA",
            abbreviation: null,
            code: null,
          },
          {
            name: "NEWTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "NOXUBEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "OKTIBBEHA",
            abbreviation: null,
            code: null,
          },
          {
            name: "PANOLA",
            abbreviation: null,
            code: null,
          },
          {
            name: "PEARL RIVER",
            abbreviation: null,
            code: null,
          },
          {
            name: "PERRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "PIKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PONTOTOC",
            abbreviation: null,
            code: null,
          },
          {
            name: "PRENTISS",
            abbreviation: null,
            code: null,
          },
          {
            name: "QUITMAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "RANKIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "SCOTT",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHARKEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "SIMPSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "SMITH",
            abbreviation: null,
            code: null,
          },
          {
            name: "STONE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SUNFLOWER",
            abbreviation: null,
            code: null,
          },
          {
            name: "TALLAHATCHIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "TATE",
            abbreviation: null,
            code: null,
          },
          {
            name: "TIPPAH",
            abbreviation: null,
            code: null,
          },
          {
            name: "TISHOMINGO",
            abbreviation: null,
            code: null,
          },
          {
            name: "TUNICA",
            abbreviation: null,
            code: null,
          },
          {
            name: "UNION",
            abbreviation: null,
            code: null,
          },
          {
            name: "WALTHALL",
            abbreviation: null,
            code: null,
          },
          {
            name: "WARREN",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WAYNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WEBSTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "WILKINSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WINSTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "YALOBUSHA",
            abbreviation: null,
            code: null,
          },
          {
            name: "YAZOO",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Montana",
        abbreviation: "MT",
        counties: [
          {
            name: "BEAVERHEAD",
            abbreviation: null,
            code: null,
          },
          {
            name: "BIG HORN",
            abbreviation: null,
            code: null,
          },
          {
            name: "BLAINE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BROADWATER",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARBON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "CASCADE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHOUTEAU",
            abbreviation: null,
            code: null,
          },
          {
            name: "CUSTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "DANIELS",
            abbreviation: null,
            code: null,
          },
          {
            name: "DAWSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "DEER LODGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "FALLON",
            abbreviation: null,
            code: null,
          },
          {
            name: "FERGUS",
            abbreviation: null,
            code: null,
          },
          {
            name: "FLATHEAD",
            abbreviation: null,
            code: null,
          },
          {
            name: "GALLATIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "GARFIELD",
            abbreviation: null,
            code: null,
          },
          {
            name: "GLACIER",
            abbreviation: null,
            code: null,
          },
          {
            name: "GOLDEN VALLEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRANITE",
            abbreviation: null,
            code: null,
          },
          {
            name: "HILL",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JUDITH BASIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEWIS AND CLARK",
            abbreviation: null,
            code: null,
          },
          {
            name: "LIBERTY",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINCOLN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MADISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCCONE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MEAGHER",
            abbreviation: null,
            code: null,
          },
          {
            name: "MINERAL",
            abbreviation: null,
            code: null,
          },
          {
            name: "MISSOULA",
            abbreviation: null,
            code: null,
          },
          {
            name: "MUSSELSHELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "PARK",
            abbreviation: null,
            code: null,
          },
          {
            name: "PETROLEUM",
            abbreviation: null,
            code: null,
          },
          {
            name: "PHILLIPS",
            abbreviation: null,
            code: null,
          },
          {
            name: "PONDERA",
            abbreviation: null,
            code: null,
          },
          {
            name: "POWDER RIVER",
            abbreviation: null,
            code: null,
          },
          {
            name: "POWELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "PRAIRIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "RAVALLI",
            abbreviation: null,
            code: null,
          },
          {
            name: "RICHLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROOSEVELT",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROSEBUD",
            abbreviation: null,
            code: null,
          },
          {
            name: "SANDERS",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHERIDAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "SILVER BOW",
            abbreviation: null,
            code: null,
          },
          {
            name: "STILLWATER",
            abbreviation: null,
            code: null,
          },
          {
            name: "SWEET GRASS",
            abbreviation: null,
            code: null,
          },
          {
            name: "TETON",
            abbreviation: null,
            code: null,
          },
          {
            name: "TOOLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "TREASURE",
            abbreviation: null,
            code: null,
          },
          {
            name: "VALLEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "WHEATLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "WIBAUX",
            abbreviation: null,
            code: null,
          },
          {
            name: "YELLOWSTONE",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "North Carolina",
        abbreviation: "NC",
        counties: [
          {
            name: "ALAMANCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ALEXANDER",
            abbreviation: null,
            code: null,
          },
          {
            name: "ALLEGHANY",
            abbreviation: null,
            code: null,
          },
          {
            name: "ANSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "ASHE",
            abbreviation: null,
            code: null,
          },
          {
            name: "AVERY",
            abbreviation: null,
            code: null,
          },
          {
            name: "BEAUFORT",
            abbreviation: null,
            code: null,
          },
          {
            name: "BERTIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BLADEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "BRUNSWICK",
            abbreviation: null,
            code: null,
          },
          {
            name: "BUNCOMBE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BURKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CABARRUS",
            abbreviation: null,
            code: null,
          },
          {
            name: "CALDWELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "CAMDEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARTERET",
            abbreviation: null,
            code: null,
          },
          {
            name: "CASWELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "CATAWBA",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHATHAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHEROKEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHOWAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLEVELAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "COLUMBUS",
            abbreviation: null,
            code: null,
          },
          {
            name: "CRAVEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CUMBERLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "CURRITUCK",
            abbreviation: null,
            code: null,
          },
          {
            name: "DARE",
            abbreviation: null,
            code: null,
          },
          {
            name: "DAVIDSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "DAVIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "DUPLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "DURHAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "EDGECOMBE",
            abbreviation: null,
            code: null,
          },
          {
            name: "FORSYTH",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRANKLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "GASTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "GATES",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRAHAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRANVILLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREENE",
            abbreviation: null,
            code: null,
          },
          {
            name: "GUILFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "HALIFAX",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARNETT",
            abbreviation: null,
            code: null,
          },
          {
            name: "HAYWOOD",
            abbreviation: null,
            code: null,
          },
          {
            name: "HENDERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HERTFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "HYDE",
            abbreviation: null,
            code: null,
          },
          {
            name: "IREDELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "JACKSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JOHNSTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JONES",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LENOIR",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINCOLN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MACON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MADISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARTIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCDOWELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "MECKLENBURG",
            abbreviation: null,
            code: null,
          },
          {
            name: "MITCHELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONTGOMERY",
            abbreviation: null,
            code: null,
          },
          {
            name: "MOORE",
            abbreviation: null,
            code: null,
          },
          {
            name: "NASH",
            abbreviation: null,
            code: null,
          },
          {
            name: "NEW HANOVER",
            abbreviation: null,
            code: null,
          },
          {
            name: "NORTHAMPTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "ONSLOW",
            abbreviation: null,
            code: null,
          },
          {
            name: "ORANGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PAMLICO",
            abbreviation: null,
            code: null,
          },
          {
            name: "PASQUOTANK",
            abbreviation: null,
            code: null,
          },
          {
            name: "PENDER",
            abbreviation: null,
            code: null,
          },
          {
            name: "PERQUIMANS",
            abbreviation: null,
            code: null,
          },
          {
            name: "PERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "PITT",
            abbreviation: null,
            code: null,
          },
          {
            name: "POLK",
            abbreviation: null,
            code: null,
          },
          {
            name: "RANDOLPH",
            abbreviation: null,
            code: null,
          },
          {
            name: "RICHMOND",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROBESON",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROCKINGHAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROWAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "RUTHERFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "SAMPSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "SCOTLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "STANLY",
            abbreviation: null,
            code: null,
          },
          {
            name: "STOKES",
            abbreviation: null,
            code: null,
          },
          {
            name: "SURRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "SWAIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "TRANSYLVANIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "TYRRELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "UNION",
            abbreviation: null,
            code: null,
          },
          {
            name: "VANCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WAKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WARREN",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WATAUGA",
            abbreviation: null,
            code: null,
          },
          {
            name: "WAYNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WILKES",
            abbreviation: null,
            code: null,
          },
          {
            name: "WILSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "YADKIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "YANCEY",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "North Dakota",
        abbreviation: "ND",
        counties: [
          {
            name: "ADAMS",
            abbreviation: null,
            code: null,
          },
          {
            name: "BARNES",
            abbreviation: null,
            code: null,
          },
          {
            name: "BENSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "BILLINGS",
            abbreviation: null,
            code: null,
          },
          {
            name: "BOTTINEAU",
            abbreviation: null,
            code: null,
          },
          {
            name: "BOWMAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "BURKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BURLEIGH",
            abbreviation: null,
            code: null,
          },
          {
            name: "CASS",
            abbreviation: null,
            code: null,
          },
          {
            name: "CAVALIER",
            abbreviation: null,
            code: null,
          },
          {
            name: "DICKEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "DIVIDE",
            abbreviation: null,
            code: null,
          },
          {
            name: "DUNN",
            abbreviation: null,
            code: null,
          },
          {
            name: "EDDY",
            abbreviation: null,
            code: null,
          },
          {
            name: "EMMONS",
            abbreviation: null,
            code: null,
          },
          {
            name: "FOSTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "GOLDEN VALLEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRAND FORKS",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRANT",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRIGGS",
            abbreviation: null,
            code: null,
          },
          {
            name: "HETTINGER",
            abbreviation: null,
            code: null,
          },
          {
            name: "KIDDER",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAMOURE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LOGAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCHENRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCINTOSH",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCKENZIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCLEAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MERCER",
            abbreviation: null,
            code: null,
          },
          {
            name: "MORTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MOUNTRAIL",
            abbreviation: null,
            code: null,
          },
          {
            name: "NELSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "OLIVER",
            abbreviation: null,
            code: null,
          },
          {
            name: "PEMBINA",
            abbreviation: null,
            code: null,
          },
          {
            name: "PIERCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "RAMSEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "RANSOM",
            abbreviation: null,
            code: null,
          },
          {
            name: "RENVILLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "RICHLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROLETTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SARGENT",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHERIDAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "SIOUX",
            abbreviation: null,
            code: null,
          },
          {
            name: "SLOPE",
            abbreviation: null,
            code: null,
          },
          {
            name: "STARK",
            abbreviation: null,
            code: null,
          },
          {
            name: "STEELE",
            abbreviation: null,
            code: null,
          },
          {
            name: "STUTSMAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "TOWNER",
            abbreviation: null,
            code: null,
          },
          {
            name: "TRAILL",
            abbreviation: null,
            code: null,
          },
          {
            name: "WALSH",
            abbreviation: null,
            code: null,
          },
          {
            name: "WARD",
            abbreviation: null,
            code: null,
          },
          {
            name: "WELLS",
            abbreviation: null,
            code: null,
          },
          {
            name: "WILLIAMS",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Nebraska",
        abbreviation: "NE",
        counties: [
          {
            name: "ADAMS",
            abbreviation: null,
            code: null,
          },
          {
            name: "ANTELOPE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ARTHUR",
            abbreviation: null,
            code: null,
          },
          {
            name: "BANNER",
            abbreviation: null,
            code: null,
          },
          {
            name: "BLAINE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BOONE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BOX BUTTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BOYD",
            abbreviation: null,
            code: null,
          },
          {
            name: "BROWN",
            abbreviation: null,
            code: null,
          },
          {
            name: "BUFFALO",
            abbreviation: null,
            code: null,
          },
          {
            name: "BURT",
            abbreviation: null,
            code: null,
          },
          {
            name: "BUTLER",
            abbreviation: null,
            code: null,
          },
          {
            name: "CASS",
            abbreviation: null,
            code: null,
          },
          {
            name: "CEDAR",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHASE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHERRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHEYENNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "COLFAX",
            abbreviation: null,
            code: null,
          },
          {
            name: "CUMING",
            abbreviation: null,
            code: null,
          },
          {
            name: "CUSTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "DAKOTA",
            abbreviation: null,
            code: null,
          },
          {
            name: "DAWES",
            abbreviation: null,
            code: null,
          },
          {
            name: "DAWSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "DEUEL",
            abbreviation: null,
            code: null,
          },
          {
            name: "DIXON",
            abbreviation: null,
            code: null,
          },
          {
            name: "DODGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "DOUGLAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "DUNDY",
            abbreviation: null,
            code: null,
          },
          {
            name: "FILLMORE",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRANKLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRONTIER",
            abbreviation: null,
            code: null,
          },
          {
            name: "FURNAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "GAGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "GARDEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "GARFIELD",
            abbreviation: null,
            code: null,
          },
          {
            name: "GOSPER",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRANT",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREELEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "HALL",
            abbreviation: null,
            code: null,
          },
          {
            name: "HAMILTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARLAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "HAYES",
            abbreviation: null,
            code: null,
          },
          {
            name: "HITCHCOCK",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOLT",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOOKER",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOWARD",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JOHNSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "KEARNEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "KEITH",
            abbreviation: null,
            code: null,
          },
          {
            name: "KEYA PAHA",
            abbreviation: null,
            code: null,
          },
          {
            name: "KIMBALL",
            abbreviation: null,
            code: null,
          },
          {
            name: "KNOX",
            abbreviation: null,
            code: null,
          },
          {
            name: "LANCASTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINCOLN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LOGAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LOUP",
            abbreviation: null,
            code: null,
          },
          {
            name: "MADISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCPHERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MERRICK",
            abbreviation: null,
            code: null,
          },
          {
            name: "MORRILL",
            abbreviation: null,
            code: null,
          },
          {
            name: "NANCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "NEMAHA",
            abbreviation: null,
            code: null,
          },
          {
            name: "NUCKOLLS",
            abbreviation: null,
            code: null,
          },
          {
            name: "OTOE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PAWNEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PERKINS",
            abbreviation: null,
            code: null,
          },
          {
            name: "PHELPS",
            abbreviation: null,
            code: null,
          },
          {
            name: "PIERCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PLATTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "POLK",
            abbreviation: null,
            code: null,
          },
          {
            name: "RED WILLOW",
            abbreviation: null,
            code: null,
          },
          {
            name: "RICHARDSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROCK",
            abbreviation: null,
            code: null,
          },
          {
            name: "SALINE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SARPY",
            abbreviation: null,
            code: null,
          },
          {
            name: "SAUNDERS",
            abbreviation: null,
            code: null,
          },
          {
            name: "SCOTTS BLUFF",
            abbreviation: null,
            code: null,
          },
          {
            name: "SEWARD",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHERIDAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHERMAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "SIOUX",
            abbreviation: null,
            code: null,
          },
          {
            name: "STANTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "THAYER",
            abbreviation: null,
            code: null,
          },
          {
            name: "THOMAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "THURSTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "VALLEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WAYNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WEBSTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "WHEELER",
            abbreviation: null,
            code: null,
          },
          {
            name: "YORK",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "New Hampshire",
        abbreviation: "NH",
        counties: [
          {
            name: "BELKNAP",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARROLL",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHESHIRE",
            abbreviation: null,
            code: null,
          },
          {
            name: "COOS",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRAFTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HILLSBOROUGH",
            abbreviation: null,
            code: null,
          },
          {
            name: "MERRIMACK",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROCKINGHAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "STRAFFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "SULLIVAN",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "New Jersey",
        abbreviation: "NJ",
        counties: [
          {
            name: "ATLANTIC",
            abbreviation: null,
            code: null,
          },
          {
            name: "BERGEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "BURLINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CAMDEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CAPE MAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CUMBERLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "ESSEX",
            abbreviation: null,
            code: null,
          },
          {
            name: "GLOUCESTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "HUDSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HUNTERDON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MERCER",
            abbreviation: null,
            code: null,
          },
          {
            name: "MIDDLESEX",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONMOUTH",
            abbreviation: null,
            code: null,
          },
          {
            name: "MORRIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "OCEAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "PASSAIC",
            abbreviation: null,
            code: null,
          },
          {
            name: "SALEM",
            abbreviation: null,
            code: null,
          },
          {
            name: "SOMERSET",
            abbreviation: null,
            code: null,
          },
          {
            name: "SUSSEX",
            abbreviation: null,
            code: null,
          },
          {
            name: "UNION",
            abbreviation: null,
            code: null,
          },
          {
            name: "WARREN",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "New Mexico",
        abbreviation: "NM",
        counties: [
          {
            name: "BERNALILLO",
            abbreviation: null,
            code: null,
          },
          {
            name: "CATRON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHAVES",
            abbreviation: null,
            code: null,
          },
          {
            name: "CIBOLA",
            abbreviation: null,
            code: null,
          },
          {
            name: "COLFAX",
            abbreviation: null,
            code: null,
          },
          {
            name: "CURRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "DE BACA",
            abbreviation: null,
            code: null,
          },
          {
            name: "DONA ANA",
            abbreviation: null,
            code: null,
          },
          {
            name: "EDDY",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRANT",
            abbreviation: null,
            code: null,
          },
          {
            name: "GUADALUPE",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARDING",
            abbreviation: null,
            code: null,
          },
          {
            name: "HIDALGO",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEA",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINCOLN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LOS ALAMOS",
            abbreviation: null,
            code: null,
          },
          {
            name: "LUNA",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCKINLEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "MORA",
            abbreviation: null,
            code: null,
          },
          {
            name: "OTERO",
            abbreviation: null,
            code: null,
          },
          {
            name: "QUAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "RIO ARRIBA",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROOSEVELT",
            abbreviation: null,
            code: null,
          },
          {
            name: "SAN JUAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "SAN MIGUEL",
            abbreviation: null,
            code: null,
          },
          {
            name: "SANDOVAL",
            abbreviation: null,
            code: null,
          },
          {
            name: "SANTA FE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SIERRA",
            abbreviation: null,
            code: null,
          },
          {
            name: "SOCORRO",
            abbreviation: null,
            code: null,
          },
          {
            name: "TAOS",
            abbreviation: null,
            code: null,
          },
          {
            name: "TORRANCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "UNION",
            abbreviation: null,
            code: null,
          },
          {
            name: "VALENCIA",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Nevada",
        abbreviation: "NV",
        counties: [
          {
            name: "CARSON CITY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHURCHILL",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLARK",
            abbreviation: null,
            code: null,
          },
          {
            name: "DOUGLAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "ELKO",
            abbreviation: null,
            code: null,
          },
          {
            name: "ESMERALDA",
            abbreviation: null,
            code: null,
          },
          {
            name: "EUREKA",
            abbreviation: null,
            code: null,
          },
          {
            name: "HUMBOLDT",
            abbreviation: null,
            code: null,
          },
          {
            name: "LANDER",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINCOLN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LYON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MINERAL",
            abbreviation: null,
            code: null,
          },
          {
            name: "NYE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PERSHING",
            abbreviation: null,
            code: null,
          },
          {
            name: "STOREY",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHOE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WHITE PINE",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "New York",
        abbreviation: "NY",
        counties: [
          {
            name: "ALBANY",
            abbreviation: null,
            code: null,
          },
          {
            name: "ALLEGANY",
            abbreviation: null,
            code: null,
          },
          {
            name: "BRONX",
            abbreviation: null,
            code: null,
          },
          {
            name: "BROOME",
            abbreviation: null,
            code: null,
          },
          {
            name: "CATTARAUGUS",
            abbreviation: null,
            code: null,
          },
          {
            name: "CAYUGA",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHAUTAUQUA",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHEMUNG",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHENANGO",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLINTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "COLUMBIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "CORTLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "DELAWARE",
            abbreviation: null,
            code: null,
          },
          {
            name: "DUTCHESS",
            abbreviation: null,
            code: null,
          },
          {
            name: "ERIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ESSEX",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRANKLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "FULTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "GENESEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREENE",
            abbreviation: null,
            code: null,
          },
          {
            name: "HAMILTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HERKIMER",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "KINGS",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEWIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "LIVINGSTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MADISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONROE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONTGOMERY",
            abbreviation: null,
            code: null,
          },
          {
            name: "NASSAU",
            abbreviation: null,
            code: null,
          },
          {
            name: "NEW YORK",
            abbreviation: null,
            code: null,
          },
          {
            name: "NIAGARA",
            abbreviation: null,
            code: null,
          },
          {
            name: "ONEIDA",
            abbreviation: null,
            code: null,
          },
          {
            name: "ONONDAGA",
            abbreviation: null,
            code: null,
          },
          {
            name: "ONTARIO",
            abbreviation: null,
            code: null,
          },
          {
            name: "ORANGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ORLEANS",
            abbreviation: null,
            code: null,
          },
          {
            name: "OSWEGO",
            abbreviation: null,
            code: null,
          },
          {
            name: "OTSEGO",
            abbreviation: null,
            code: null,
          },
          {
            name: "PUTNAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "QUEENS",
            abbreviation: null,
            code: null,
          },
          {
            name: "RENSSELAER",
            abbreviation: null,
            code: null,
          },
          {
            name: "RICHMOND",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROCKLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "SARATOGA",
            abbreviation: null,
            code: null,
          },
          {
            name: "SCHENECTADY",
            abbreviation: null,
            code: null,
          },
          {
            name: "SCHOHARIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SCHUYLER",
            abbreviation: null,
            code: null,
          },
          {
            name: "SENECA",
            abbreviation: null,
            code: null,
          },
          {
            name: "ST LAWRENCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "STEUBEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "SUFFOLK",
            abbreviation: null,
            code: null,
          },
          {
            name: "SULLIVAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "TIOGA",
            abbreviation: null,
            code: null,
          },
          {
            name: "TOMPKINS",
            abbreviation: null,
            code: null,
          },
          {
            name: "ULSTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "WARREN",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WAYNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WESTCHESTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "WYOMING",
            abbreviation: null,
            code: null,
          },
          {
            name: "YATES",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Ohio",
        abbreviation: "OH",
        counties: [
          {
            name: "ADAMS",
            abbreviation: null,
            code: null,
          },
          {
            name: "ALLEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "ASHLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "ASHTABULA",
            abbreviation: null,
            code: null,
          },
          {
            name: "ATHENS",
            abbreviation: null,
            code: null,
          },
          {
            name: "AUGLAIZE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BELMONT",
            abbreviation: null,
            code: null,
          },
          {
            name: "BROWN",
            abbreviation: null,
            code: null,
          },
          {
            name: "BUTLER",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARROLL",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHAMPAIGN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLARK",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLERMONT",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLINTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "COLUMBIANA",
            abbreviation: null,
            code: null,
          },
          {
            name: "COSHOCTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CRAWFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "CUYAHOGA",
            abbreviation: null,
            code: null,
          },
          {
            name: "DARKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "DEFIANCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "DELAWARE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ERIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "FAIRFIELD",
            abbreviation: null,
            code: null,
          },
          {
            name: "FAYETTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRANKLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "FULTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "GALLIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "GEAUGA",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREENE",
            abbreviation: null,
            code: null,
          },
          {
            name: "GUERNSEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "HAMILTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HANCOCK",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARDIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARRISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HENRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "HIGHLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOCKING",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOLMES",
            abbreviation: null,
            code: null,
          },
          {
            name: "HURON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JACKSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "KNOX",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAWRENCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LICKING",
            abbreviation: null,
            code: null,
          },
          {
            name: "LOGAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LORAIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LUCAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "MADISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MAHONING",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARION",
            abbreviation: null,
            code: null,
          },
          {
            name: "MEDINA",
            abbreviation: null,
            code: null,
          },
          {
            name: "MEIGS",
            abbreviation: null,
            code: null,
          },
          {
            name: "MERCER",
            abbreviation: null,
            code: null,
          },
          {
            name: "MIAMI",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONROE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONTGOMERY",
            abbreviation: null,
            code: null,
          },
          {
            name: "MORGAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MORROW",
            abbreviation: null,
            code: null,
          },
          {
            name: "MUSKINGUM",
            abbreviation: null,
            code: null,
          },
          {
            name: "NOBLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "OTTAWA",
            abbreviation: null,
            code: null,
          },
          {
            name: "PAULDING",
            abbreviation: null,
            code: null,
          },
          {
            name: "PERRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "PICKAWAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "PIKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PORTAGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PREBLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PUTNAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "RICHLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROSS",
            abbreviation: null,
            code: null,
          },
          {
            name: "SANDUSKY",
            abbreviation: null,
            code: null,
          },
          {
            name: "SCIOTO",
            abbreviation: null,
            code: null,
          },
          {
            name: "SENECA",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHELBY",
            abbreviation: null,
            code: null,
          },
          {
            name: "STARK",
            abbreviation: null,
            code: null,
          },
          {
            name: "SUMMIT",
            abbreviation: null,
            code: null,
          },
          {
            name: "TRUMBULL",
            abbreviation: null,
            code: null,
          },
          {
            name: "TUSCARAWAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "UNION",
            abbreviation: null,
            code: null,
          },
          {
            name: "VAN WERT",
            abbreviation: null,
            code: null,
          },
          {
            name: "VINTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WARREN",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WAYNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WILLIAMS",
            abbreviation: null,
            code: null,
          },
          {
            name: "WOOD",
            abbreviation: null,
            code: null,
          },
          {
            name: "WYANDOT",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Oklahoma",
        abbreviation: "OK",
        counties: [
          {
            name: "ADAIR",
            abbreviation: null,
            code: null,
          },
          {
            name: "ALFALFA",
            abbreviation: null,
            code: null,
          },
          {
            name: "ATOKA",
            abbreviation: null,
            code: null,
          },
          {
            name: "BEAVER",
            abbreviation: null,
            code: null,
          },
          {
            name: "BECKHAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "BLAINE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BRYAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CADDO",
            abbreviation: null,
            code: null,
          },
          {
            name: "CANADIAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHEROKEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHOCTAW",
            abbreviation: null,
            code: null,
          },
          {
            name: "CIMARRON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLEVELAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "COAL",
            abbreviation: null,
            code: null,
          },
          {
            name: "COMANCHE",
            abbreviation: null,
            code: null,
          },
          {
            name: "COTTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CRAIG",
            abbreviation: null,
            code: null,
          },
          {
            name: "CREEK",
            abbreviation: null,
            code: null,
          },
          {
            name: "CUSTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "DELAWARE",
            abbreviation: null,
            code: null,
          },
          {
            name: "DEWEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "ELLIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "GARFIELD",
            abbreviation: null,
            code: null,
          },
          {
            name: "GARVIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRADY",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRANT",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREER",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARMON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARPER",
            abbreviation: null,
            code: null,
          },
          {
            name: "HASKELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "HUGHES",
            abbreviation: null,
            code: null,
          },
          {
            name: "JACKSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JOHNSTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "KAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "KINGFISHER",
            abbreviation: null,
            code: null,
          },
          {
            name: "KIOWA",
            abbreviation: null,
            code: null,
          },
          {
            name: "LATIMER",
            abbreviation: null,
            code: null,
          },
          {
            name: "LE FLORE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINCOLN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LOGAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LOVE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MAJOR",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARSHALL",
            abbreviation: null,
            code: null,
          },
          {
            name: "MAYES",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCCLAIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCCURTAIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCINTOSH",
            abbreviation: null,
            code: null,
          },
          {
            name: "MURRAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "MUSKOGEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "NOBLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "NOWATA",
            abbreviation: null,
            code: null,
          },
          {
            name: "OKFUSKEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "OKLAHOMA",
            abbreviation: null,
            code: null,
          },
          {
            name: "OKMULGEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "OSAGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "OTTAWA",
            abbreviation: null,
            code: null,
          },
          {
            name: "PAWNEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PAYNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PITTSBURG",
            abbreviation: null,
            code: null,
          },
          {
            name: "PONTOTOC",
            abbreviation: null,
            code: null,
          },
          {
            name: "POTTAWATOMIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PUSHMATAHA",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROGER MILLS",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROGERS",
            abbreviation: null,
            code: null,
          },
          {
            name: "SEMINOLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SEQUOYAH",
            abbreviation: null,
            code: null,
          },
          {
            name: "STEPHENS",
            abbreviation: null,
            code: null,
          },
          {
            name: "TEXAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "TILLMAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "TULSA",
            abbreviation: null,
            code: null,
          },
          {
            name: "WAGONER",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHITA",
            abbreviation: null,
            code: null,
          },
          {
            name: "WOODS",
            abbreviation: null,
            code: null,
          },
          {
            name: "WOODWARD",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Oregon",
        abbreviation: "OR",
        counties: [
          {
            name: "BAKER",
            abbreviation: null,
            code: null,
          },
          {
            name: "BENTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLACKAMAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLATSOP",
            abbreviation: null,
            code: null,
          },
          {
            name: "COLUMBIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "COOS",
            abbreviation: null,
            code: null,
          },
          {
            name: "CROOK",
            abbreviation: null,
            code: null,
          },
          {
            name: "CURRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "DESCHUTES",
            abbreviation: null,
            code: null,
          },
          {
            name: "DOUGLAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "GILLIAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRANT",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARNEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOOD RIVER",
            abbreviation: null,
            code: null,
          },
          {
            name: "JACKSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JOSEPHINE",
            abbreviation: null,
            code: null,
          },
          {
            name: "KLAMATH",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LANE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINCOLN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MALHEUR",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARION",
            abbreviation: null,
            code: null,
          },
          {
            name: "MORROW",
            abbreviation: null,
            code: null,
          },
          {
            name: "MULTNOMAH",
            abbreviation: null,
            code: null,
          },
          {
            name: "POLK",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHERMAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "TILLAMOOK",
            abbreviation: null,
            code: null,
          },
          {
            name: "UMATILLA",
            abbreviation: null,
            code: null,
          },
          {
            name: "UNION",
            abbreviation: null,
            code: null,
          },
          {
            name: "WALLOWA",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASCO",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WHEELER",
            abbreviation: null,
            code: null,
          },
          {
            name: "YAMHILL",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Pennsylvania",
        abbreviation: "PA",
        counties: [
          {
            name: "ADAMS",
            abbreviation: null,
            code: null,
          },
          {
            name: "ALLEGHENY",
            abbreviation: null,
            code: null,
          },
          {
            name: "ARMSTRONG",
            abbreviation: null,
            code: null,
          },
          {
            name: "BEAVER",
            abbreviation: null,
            code: null,
          },
          {
            name: "BEDFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "BERKS",
            abbreviation: null,
            code: null,
          },
          {
            name: "BLAIR",
            abbreviation: null,
            code: null,
          },
          {
            name: "BRADFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "BUCKS",
            abbreviation: null,
            code: null,
          },
          {
            name: "BUTLER",
            abbreviation: null,
            code: null,
          },
          {
            name: "CAMBRIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "CAMERON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARBON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CENTRE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHESTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLARION",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLEARFIELD",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLINTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "COLUMBIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "CRAWFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "CUMBERLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "DAUPHIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "DELAWARE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ELK",
            abbreviation: null,
            code: null,
          },
          {
            name: "ERIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "FAYETTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "FOREST",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRANKLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "FULTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREENE",
            abbreviation: null,
            code: null,
          },
          {
            name: "HUNTINGDON",
            abbreviation: null,
            code: null,
          },
          {
            name: "INDIANA",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JUNIATA",
            abbreviation: null,
            code: null,
          },
          {
            name: "LACKAWANNA",
            abbreviation: null,
            code: null,
          },
          {
            name: "LANCASTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAWRENCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEBANON",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEHIGH",
            abbreviation: null,
            code: null,
          },
          {
            name: "LUZERNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LYCOMING",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCKEAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MERCER",
            abbreviation: null,
            code: null,
          },
          {
            name: "MIFFLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONROE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONTGOMERY",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONTOUR",
            abbreviation: null,
            code: null,
          },
          {
            name: "NORTHAMPTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "NORTHUMBERLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "PERRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "PHILADELPHIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "PIKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "POTTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "SCHUYLKILL",
            abbreviation: null,
            code: null,
          },
          {
            name: "SNYDER",
            abbreviation: null,
            code: null,
          },
          {
            name: "SOMERSET",
            abbreviation: null,
            code: null,
          },
          {
            name: "SULLIVAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "SUSQUEHANNA",
            abbreviation: null,
            code: null,
          },
          {
            name: "TIOGA",
            abbreviation: null,
            code: null,
          },
          {
            name: "UNION",
            abbreviation: null,
            code: null,
          },
          {
            name: "VENANGO",
            abbreviation: null,
            code: null,
          },
          {
            name: "WARREN",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WAYNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WESTMORELAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "WYOMING",
            abbreviation: null,
            code: null,
          },
          {
            name: "YORK",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Rhode Island",
        abbreviation: "RI",
        counties: [
          {
            name: "BRISTOL",
            abbreviation: null,
            code: null,
          },
          {
            name: "KENT",
            abbreviation: null,
            code: null,
          },
          {
            name: "NEWPORT",
            abbreviation: null,
            code: null,
          },
          {
            name: "PROVIDENCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "South Carolina",
        abbreviation: "SC",
        counties: [
          {
            name: "ABBEVILLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "AIKEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "ALLENDALE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ANDERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "BAMBERG",
            abbreviation: null,
            code: null,
          },
          {
            name: "BARNWELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "BEAUFORT",
            abbreviation: null,
            code: null,
          },
          {
            name: "BERKELEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CALHOUN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHARLESTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHEROKEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHESTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHESTERFIELD",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLARENDON",
            abbreviation: null,
            code: null,
          },
          {
            name: "COLLETON",
            abbreviation: null,
            code: null,
          },
          {
            name: "DARLINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "DILLON",
            abbreviation: null,
            code: null,
          },
          {
            name: "DORCHESTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "EDGEFIELD",
            abbreviation: null,
            code: null,
          },
          {
            name: "FAIRFIELD",
            abbreviation: null,
            code: null,
          },
          {
            name: "FLORENCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "GEORGETOWN",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREENVILLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREENWOOD",
            abbreviation: null,
            code: null,
          },
          {
            name: "HAMPTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HORRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "JASPER",
            abbreviation: null,
            code: null,
          },
          {
            name: "KERSHAW",
            abbreviation: null,
            code: null,
          },
          {
            name: "LANCASTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAURENS",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEXINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARION",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARLBORO",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCCORMICK",
            abbreviation: null,
            code: null,
          },
          {
            name: "NEWBERRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "OCONEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ORANGEBURG",
            abbreviation: null,
            code: null,
          },
          {
            name: "PICKENS",
            abbreviation: null,
            code: null,
          },
          {
            name: "RICHLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "SALUDA",
            abbreviation: null,
            code: null,
          },
          {
            name: "SPARTANBURG",
            abbreviation: null,
            code: null,
          },
          {
            name: "SUMTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "UNION",
            abbreviation: null,
            code: null,
          },
          {
            name: "WILLIAMSBURG",
            abbreviation: null,
            code: null,
          },
          {
            name: "YORK",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "South Dakota",
        abbreviation: "SD",
        counties: [
          {
            name: "AURORA",
            abbreviation: null,
            code: null,
          },
          {
            name: "BEADLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BENNETT",
            abbreviation: null,
            code: null,
          },
          {
            name: "BON HOMME",
            abbreviation: null,
            code: null,
          },
          {
            name: "BROOKINGS",
            abbreviation: null,
            code: null,
          },
          {
            name: "BROWN",
            abbreviation: null,
            code: null,
          },
          {
            name: "BRULE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BUFFALO",
            abbreviation: null,
            code: null,
          },
          {
            name: "BUTTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CAMPBELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHARLES MIX",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLARK",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CODINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CORSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CUSTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "DAVISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "DAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "DEUEL",
            abbreviation: null,
            code: null,
          },
          {
            name: "DEWEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "DOUGLAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "EDMUNDS",
            abbreviation: null,
            code: null,
          },
          {
            name: "FALL RIVER",
            abbreviation: null,
            code: null,
          },
          {
            name: "FAULK",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRANT",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREGORY",
            abbreviation: null,
            code: null,
          },
          {
            name: "HAAKON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HAMLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "HAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "HANSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARDING",
            abbreviation: null,
            code: null,
          },
          {
            name: "HUGHES",
            abbreviation: null,
            code: null,
          },
          {
            name: "HUTCHINSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HYDE",
            abbreviation: null,
            code: null,
          },
          {
            name: "JACKSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JERAULD",
            abbreviation: null,
            code: null,
          },
          {
            name: "JONES",
            abbreviation: null,
            code: null,
          },
          {
            name: "KINGSBURY",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAWRENCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINCOLN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LYMAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARSHALL",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCCOOK",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCPHERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MEADE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MELLETTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MINER",
            abbreviation: null,
            code: null,
          },
          {
            name: "MINNEHAHA",
            abbreviation: null,
            code: null,
          },
          {
            name: "MOODY",
            abbreviation: null,
            code: null,
          },
          {
            name: "OGLALA LAKOTA",
            abbreviation: null,
            code: null,
          },
          {
            name: "PENNINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "PERKINS",
            abbreviation: null,
            code: null,
          },
          {
            name: "POTTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROBERTS",
            abbreviation: null,
            code: null,
          },
          {
            name: "SANBORN",
            abbreviation: null,
            code: null,
          },
          {
            name: "SPINK",
            abbreviation: null,
            code: null,
          },
          {
            name: "STANLEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "SULLY",
            abbreviation: null,
            code: null,
          },
          {
            name: "TODD",
            abbreviation: null,
            code: null,
          },
          {
            name: "TRIPP",
            abbreviation: null,
            code: null,
          },
          {
            name: "TURNER",
            abbreviation: null,
            code: null,
          },
          {
            name: "UNION",
            abbreviation: null,
            code: null,
          },
          {
            name: "WALWORTH",
            abbreviation: null,
            code: null,
          },
          {
            name: "YANKTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "ZIEBACH",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Tennessee",
        abbreviation: "TN",
        counties: [
          {
            name: "ANDERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "BEDFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "BENTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "BLEDSOE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BLOUNT",
            abbreviation: null,
            code: null,
          },
          {
            name: "BRADLEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CAMPBELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "CANNON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARROLL",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHEATHAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHESTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLAIBORNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "COCKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "COFFEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CROCKETT",
            abbreviation: null,
            code: null,
          },
          {
            name: "CUMBERLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "DAVIDSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "DECATUR",
            abbreviation: null,
            code: null,
          },
          {
            name: "DEKALB",
            abbreviation: null,
            code: null,
          },
          {
            name: "DICKSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "DYER",
            abbreviation: null,
            code: null,
          },
          {
            name: "FAYETTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "FENTRESS",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRANKLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "GIBSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "GILES",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRAINGER",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREENE",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRUNDY",
            abbreviation: null,
            code: null,
          },
          {
            name: "HAMBLEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "HAMILTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HANCOCK",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARDEMAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARDIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "HAWKINS",
            abbreviation: null,
            code: null,
          },
          {
            name: "HAYWOOD",
            abbreviation: null,
            code: null,
          },
          {
            name: "HENDERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HENRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "HICKMAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOUSTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HUMPHREYS",
            abbreviation: null,
            code: null,
          },
          {
            name: "JACKSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JOHNSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "KNOX",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAUDERDALE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAWRENCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEWIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINCOLN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LOUDON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MACON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MADISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARION",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARSHALL",
            abbreviation: null,
            code: null,
          },
          {
            name: "MAURY",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCMINN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCNAIRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "MEIGS",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONROE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONTGOMERY",
            abbreviation: null,
            code: null,
          },
          {
            name: "MOORE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MORGAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "OBION",
            abbreviation: null,
            code: null,
          },
          {
            name: "OVERTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "PERRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "PICKETT",
            abbreviation: null,
            code: null,
          },
          {
            name: "POLK",
            abbreviation: null,
            code: null,
          },
          {
            name: "PUTNAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "RHEA",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROANE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROBERTSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "RUTHERFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "SCOTT",
            abbreviation: null,
            code: null,
          },
          {
            name: "SEQUATCHIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SEVIER",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHELBY",
            abbreviation: null,
            code: null,
          },
          {
            name: "SMITH",
            abbreviation: null,
            code: null,
          },
          {
            name: "STEWART",
            abbreviation: null,
            code: null,
          },
          {
            name: "SULLIVAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "SUMNER",
            abbreviation: null,
            code: null,
          },
          {
            name: "TIPTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "TROUSDALE",
            abbreviation: null,
            code: null,
          },
          {
            name: "UNICOI",
            abbreviation: null,
            code: null,
          },
          {
            name: "UNION",
            abbreviation: null,
            code: null,
          },
          {
            name: "VAN BUREN",
            abbreviation: null,
            code: null,
          },
          {
            name: "WARREN",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WAYNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WEAKLEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "WHITE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WILLIAMSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WILSON",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Texas",
        abbreviation: "TX",
        counties: [
          {
            name: "ANDERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "ANDREWS",
            abbreviation: null,
            code: null,
          },
          {
            name: "ANGELINA",
            abbreviation: null,
            code: null,
          },
          {
            name: "ARANSAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "ARCHER",
            abbreviation: null,
            code: null,
          },
          {
            name: "ARMSTRONG",
            abbreviation: null,
            code: null,
          },
          {
            name: "ATASCOSA",
            abbreviation: null,
            code: null,
          },
          {
            name: "AUSTIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "BAILEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "BANDERA",
            abbreviation: null,
            code: null,
          },
          {
            name: "BASTROP",
            abbreviation: null,
            code: null,
          },
          {
            name: "BAYLOR",
            abbreviation: null,
            code: null,
          },
          {
            name: "BEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "BEXAR",
            abbreviation: null,
            code: null,
          },
          {
            name: "BLANCO",
            abbreviation: null,
            code: null,
          },
          {
            name: "BORDEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "BOSQUE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BOWIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BRAZORIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "BRAZOS",
            abbreviation: null,
            code: null,
          },
          {
            name: "BREWSTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "BRISCOE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BROOKS",
            abbreviation: null,
            code: null,
          },
          {
            name: "BROWN",
            abbreviation: null,
            code: null,
          },
          {
            name: "BURLESON",
            abbreviation: null,
            code: null,
          },
          {
            name: "BURNET",
            abbreviation: null,
            code: null,
          },
          {
            name: "CALDWELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "CALHOUN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CALLAHAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CAMERON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CAMP",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CASS",
            abbreviation: null,
            code: null,
          },
          {
            name: "CASTRO",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHAMBERS",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHEROKEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHILDRESS",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "COCHRAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "COKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "COLEMAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "COLLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "COLLINGSWORTH",
            abbreviation: null,
            code: null,
          },
          {
            name: "COLORADO",
            abbreviation: null,
            code: null,
          },
          {
            name: "COMAL",
            abbreviation: null,
            code: null,
          },
          {
            name: "COMANCHE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CONCHO",
            abbreviation: null,
            code: null,
          },
          {
            name: "COOKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CORYELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "COTTLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CRANE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CROCKETT",
            abbreviation: null,
            code: null,
          },
          {
            name: "CROSBY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CULBERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "DALLAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "DALLAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "DAWSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "DEAF SMITH",
            abbreviation: null,
            code: null,
          },
          {
            name: "DELTA",
            abbreviation: null,
            code: null,
          },
          {
            name: "DENTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "DEWITT",
            abbreviation: null,
            code: null,
          },
          {
            name: "DICKENS",
            abbreviation: null,
            code: null,
          },
          {
            name: "DIMMIT",
            abbreviation: null,
            code: null,
          },
          {
            name: "DONLEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "DUVAL",
            abbreviation: null,
            code: null,
          },
          {
            name: "EASTLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "ECTOR",
            abbreviation: null,
            code: null,
          },
          {
            name: "EDWARDS",
            abbreviation: null,
            code: null,
          },
          {
            name: "EL PASO",
            abbreviation: null,
            code: null,
          },
          {
            name: "ELLIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "ERATH",
            abbreviation: null,
            code: null,
          },
          {
            name: "FALLS",
            abbreviation: null,
            code: null,
          },
          {
            name: "FANNIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "FAYETTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "FISHER",
            abbreviation: null,
            code: null,
          },
          {
            name: "FLOYD",
            abbreviation: null,
            code: null,
          },
          {
            name: "FOARD",
            abbreviation: null,
            code: null,
          },
          {
            name: "FORT BEND",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRANKLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "FREESTONE",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRIO",
            abbreviation: null,
            code: null,
          },
          {
            name: "GAINES",
            abbreviation: null,
            code: null,
          },
          {
            name: "GALVESTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "GARZA",
            abbreviation: null,
            code: null,
          },
          {
            name: "GILLESPIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "GLASSCOCK",
            abbreviation: null,
            code: null,
          },
          {
            name: "GOLIAD",
            abbreviation: null,
            code: null,
          },
          {
            name: "GONZALES",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRAYSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREGG",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRIMES",
            abbreviation: null,
            code: null,
          },
          {
            name: "GUADALUPE",
            abbreviation: null,
            code: null,
          },
          {
            name: "HALE",
            abbreviation: null,
            code: null,
          },
          {
            name: "HALL",
            abbreviation: null,
            code: null,
          },
          {
            name: "HAMILTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HANSFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARDEMAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARDIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARRIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARRISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARTLEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "HASKELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "HAYS",
            abbreviation: null,
            code: null,
          },
          {
            name: "HEMPHILL",
            abbreviation: null,
            code: null,
          },
          {
            name: "HENDERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HIDALGO",
            abbreviation: null,
            code: null,
          },
          {
            name: "HILL",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOCKLEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOOD",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOPKINS",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOUSTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOWARD",
            abbreviation: null,
            code: null,
          },
          {
            name: "HUDSPETH",
            abbreviation: null,
            code: null,
          },
          {
            name: "HUNT",
            abbreviation: null,
            code: null,
          },
          {
            name: "HUTCHINSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "IRION",
            abbreviation: null,
            code: null,
          },
          {
            name: "JACK",
            abbreviation: null,
            code: null,
          },
          {
            name: "JACKSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JASPER",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFF DAVIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JIM HOGG",
            abbreviation: null,
            code: null,
          },
          {
            name: "JIM WELLS",
            abbreviation: null,
            code: null,
          },
          {
            name: "JOHNSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JONES",
            abbreviation: null,
            code: null,
          },
          {
            name: "KARNES",
            abbreviation: null,
            code: null,
          },
          {
            name: "KAUFMAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "KENDALL",
            abbreviation: null,
            code: null,
          },
          {
            name: "KENEDY",
            abbreviation: null,
            code: null,
          },
          {
            name: "KENT",
            abbreviation: null,
            code: null,
          },
          {
            name: "KERR",
            abbreviation: null,
            code: null,
          },
          {
            name: "KIMBLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "KING",
            abbreviation: null,
            code: null,
          },
          {
            name: "KINNEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "KLEBERG",
            abbreviation: null,
            code: null,
          },
          {
            name: "KNOX",
            abbreviation: null,
            code: null,
          },
          {
            name: "LA SALLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAMAR",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAMB",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAMPASAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAVACA",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEON",
            abbreviation: null,
            code: null,
          },
          {
            name: "LIBERTY",
            abbreviation: null,
            code: null,
          },
          {
            name: "LIMESTONE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LIPSCOMB",
            abbreviation: null,
            code: null,
          },
          {
            name: "LIVE OAK",
            abbreviation: null,
            code: null,
          },
          {
            name: "LLANO",
            abbreviation: null,
            code: null,
          },
          {
            name: "LOVING",
            abbreviation: null,
            code: null,
          },
          {
            name: "LUBBOCK",
            abbreviation: null,
            code: null,
          },
          {
            name: "LYNN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MADISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARION",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARTIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MASON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MATAGORDA",
            abbreviation: null,
            code: null,
          },
          {
            name: "MAVERICK",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCCULLOCH",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCLENNAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCMULLEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MEDINA",
            abbreviation: null,
            code: null,
          },
          {
            name: "MENARD",
            abbreviation: null,
            code: null,
          },
          {
            name: "MIDLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "MILAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "MILLS",
            abbreviation: null,
            code: null,
          },
          {
            name: "MITCHELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONTAGUE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONTGOMERY",
            abbreviation: null,
            code: null,
          },
          {
            name: "MOORE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MORRIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "MOTLEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "NACOGDOCHES",
            abbreviation: null,
            code: null,
          },
          {
            name: "NAVARRO",
            abbreviation: null,
            code: null,
          },
          {
            name: "NEWTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "NOLAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "NUECES",
            abbreviation: null,
            code: null,
          },
          {
            name: "OCHILTREE",
            abbreviation: null,
            code: null,
          },
          {
            name: "OLDHAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "ORANGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PALO PINTO",
            abbreviation: null,
            code: null,
          },
          {
            name: "PANOLA",
            abbreviation: null,
            code: null,
          },
          {
            name: "PARKER",
            abbreviation: null,
            code: null,
          },
          {
            name: "PARMER",
            abbreviation: null,
            code: null,
          },
          {
            name: "PECOS",
            abbreviation: null,
            code: null,
          },
          {
            name: "POLK",
            abbreviation: null,
            code: null,
          },
          {
            name: "POTTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "PRESIDIO",
            abbreviation: null,
            code: null,
          },
          {
            name: "RAINS",
            abbreviation: null,
            code: null,
          },
          {
            name: "RANDALL",
            abbreviation: null,
            code: null,
          },
          {
            name: "REAGAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "REAL",
            abbreviation: null,
            code: null,
          },
          {
            name: "RED RIVER",
            abbreviation: null,
            code: null,
          },
          {
            name: "REEVES",
            abbreviation: null,
            code: null,
          },
          {
            name: "REFUGIO",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROBERTS",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROBERTSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROCKWALL",
            abbreviation: null,
            code: null,
          },
          {
            name: "RUNNELS",
            abbreviation: null,
            code: null,
          },
          {
            name: "RUSK",
            abbreviation: null,
            code: null,
          },
          {
            name: "SABINE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SAN AUGUSTINE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SAN JACINTO",
            abbreviation: null,
            code: null,
          },
          {
            name: "SAN PATRICIO",
            abbreviation: null,
            code: null,
          },
          {
            name: "SAN SABA",
            abbreviation: null,
            code: null,
          },
          {
            name: "SCHLEICHER",
            abbreviation: null,
            code: null,
          },
          {
            name: "SCURRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHACKELFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHELBY",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHERMAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "SMITH",
            abbreviation: null,
            code: null,
          },
          {
            name: "SOMERVELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "STARR",
            abbreviation: null,
            code: null,
          },
          {
            name: "STEPHENS",
            abbreviation: null,
            code: null,
          },
          {
            name: "STERLING",
            abbreviation: null,
            code: null,
          },
          {
            name: "STONEWALL",
            abbreviation: null,
            code: null,
          },
          {
            name: "SUTTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "SWISHER",
            abbreviation: null,
            code: null,
          },
          {
            name: "TARRANT",
            abbreviation: null,
            code: null,
          },
          {
            name: "TAYLOR",
            abbreviation: null,
            code: null,
          },
          {
            name: "TERRELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "TERRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "THROCKMORTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "TITUS",
            abbreviation: null,
            code: null,
          },
          {
            name: "TOM GREEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "TRAVIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "TRINITY",
            abbreviation: null,
            code: null,
          },
          {
            name: "TYLER",
            abbreviation: null,
            code: null,
          },
          {
            name: "UPSHUR",
            abbreviation: null,
            code: null,
          },
          {
            name: "UPTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "UVALDE",
            abbreviation: null,
            code: null,
          },
          {
            name: "VAL VERDE",
            abbreviation: null,
            code: null,
          },
          {
            name: "VAN ZANDT",
            abbreviation: null,
            code: null,
          },
          {
            name: "VICTORIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "WALKER",
            abbreviation: null,
            code: null,
          },
          {
            name: "WALLER",
            abbreviation: null,
            code: null,
          },
          {
            name: "WARD",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WEBB",
            abbreviation: null,
            code: null,
          },
          {
            name: "WHARTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WHEELER",
            abbreviation: null,
            code: null,
          },
          {
            name: "WICHITA",
            abbreviation: null,
            code: null,
          },
          {
            name: "WILBARGER",
            abbreviation: null,
            code: null,
          },
          {
            name: "WILLACY",
            abbreviation: null,
            code: null,
          },
          {
            name: "WILLIAMSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WILSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WINKLER",
            abbreviation: null,
            code: null,
          },
          {
            name: "WISE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WOOD",
            abbreviation: null,
            code: null,
          },
          {
            name: "YOAKUM",
            abbreviation: null,
            code: null,
          },
          {
            name: "YOUNG",
            abbreviation: null,
            code: null,
          },
          {
            name: "ZAPATA",
            abbreviation: null,
            code: null,
          },
          {
            name: "ZAVALA",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Utah",
        abbreviation: "UT",
        counties: [
          {
            name: "BEAVER",
            abbreviation: null,
            code: null,
          },
          {
            name: "BOX ELDER",
            abbreviation: null,
            code: null,
          },
          {
            name: "CACHE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARBON",
            abbreviation: null,
            code: null,
          },
          {
            name: "DAGGETT",
            abbreviation: null,
            code: null,
          },
          {
            name: "DAVIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "DUCHESNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "EMERY",
            abbreviation: null,
            code: null,
          },
          {
            name: "GARFIELD",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "IRON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JUAB",
            abbreviation: null,
            code: null,
          },
          {
            name: "KANE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MILLARD",
            abbreviation: null,
            code: null,
          },
          {
            name: "MORGAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "PIUTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "RICH",
            abbreviation: null,
            code: null,
          },
          {
            name: "SALT LAKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SAN JUAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "SANPETE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SEVIER",
            abbreviation: null,
            code: null,
          },
          {
            name: "SUMMIT",
            abbreviation: null,
            code: null,
          },
          {
            name: "TOOELE",
            abbreviation: null,
            code: null,
          },
          {
            name: "UINTAH",
            abbreviation: null,
            code: null,
          },
          {
            name: "UTAH",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASATCH",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WAYNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WEBER",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Virginia",
        abbreviation: "VA",
        counties: [
          {
            name: "ACCOMACK",
            abbreviation: null,
            code: null,
          },
          {
            name: "ALBEMARLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ALEXANDRIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "ALLEGHANY",
            abbreviation: null,
            code: null,
          },
          {
            name: "AMELIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "AMHERST",
            abbreviation: null,
            code: null,
          },
          {
            name: "APPOMATTOX",
            abbreviation: null,
            code: null,
          },
          {
            name: "ARLINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "AUGUSTA",
            abbreviation: null,
            code: null,
          },
          {
            name: "BATH",
            abbreviation: null,
            code: null,
          },
          {
            name: "BEDFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "BLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "BOTETOURT",
            abbreviation: null,
            code: null,
          },
          {
            name: "BRISTOL",
            abbreviation: null,
            code: null,
          },
          {
            name: "BRUNSWICK",
            abbreviation: null,
            code: null,
          },
          {
            name: "BUCHANAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "BUCKINGHAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "BUENA VISTA",
            abbreviation: null,
            code: null,
          },
          {
            name: "CAMPBELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "CAROLINE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARROLL",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHARLES CITY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHARLOTTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHARLOTTESVILLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHESAPEAKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHESTERFIELD",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLARKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "COLONIAL HEIGHTS",
            abbreviation: null,
            code: null,
          },
          {
            name: "COVINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CRAIG",
            abbreviation: null,
            code: null,
          },
          {
            name: "CULPEPER",
            abbreviation: null,
            code: null,
          },
          {
            name: "CUMBERLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "DANVILLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "DICKENSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "DINWIDDIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "EMPORIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "ESSEX",
            abbreviation: null,
            code: null,
          },
          {
            name: "FAIRFAX",
            abbreviation: null,
            code: null,
          },
          {
            name: "FAIRFAX",
            abbreviation: null,
            code: null,
          },
          {
            name: "FALLS CHURCH",
            abbreviation: null,
            code: null,
          },
          {
            name: "FAUQUIER",
            abbreviation: null,
            code: null,
          },
          {
            name: "FLOYD",
            abbreviation: null,
            code: null,
          },
          {
            name: "FLUVANNA",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRANKLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRANKLIN CITY",
            abbreviation: null,
            code: null,
          },
          {
            name: "FREDERICK",
            abbreviation: null,
            code: null,
          },
          {
            name: "FREDERICKSBURG",
            abbreviation: null,
            code: null,
          },
          {
            name: "GALAX",
            abbreviation: null,
            code: null,
          },
          {
            name: "GILES",
            abbreviation: null,
            code: null,
          },
          {
            name: "GLOUCESTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "GOOCHLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRAYSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREENE",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREENSVILLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "HALIFAX",
            abbreviation: null,
            code: null,
          },
          {
            name: "HAMPTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HANOVER",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARRISONBURG",
            abbreviation: null,
            code: null,
          },
          {
            name: "HENRICO",
            abbreviation: null,
            code: null,
          },
          {
            name: "HENRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "HIGHLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOPEWELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "ISLE OF WIGHT",
            abbreviation: null,
            code: null,
          },
          {
            name: "JAMES CITY",
            abbreviation: null,
            code: null,
          },
          {
            name: "KING AND QUEEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "KING GEORGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "KING WILLIAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "LANCASTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEXINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "LOUDOUN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LOUISA",
            abbreviation: null,
            code: null,
          },
          {
            name: "LUNENBURG",
            abbreviation: null,
            code: null,
          },
          {
            name: "LYNCHBURG",
            abbreviation: null,
            code: null,
          },
          {
            name: "MADISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MANASSAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "MANASSAS PARK",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARTINSVILLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MATHEWS",
            abbreviation: null,
            code: null,
          },
          {
            name: "MECKLENBURG",
            abbreviation: null,
            code: null,
          },
          {
            name: "MIDDLESEX",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONTGOMERY",
            abbreviation: null,
            code: null,
          },
          {
            name: "NELSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "NEW KENT",
            abbreviation: null,
            code: null,
          },
          {
            name: "NEWPORT NEWS",
            abbreviation: null,
            code: null,
          },
          {
            name: "NORFOLK",
            abbreviation: null,
            code: null,
          },
          {
            name: "NORTHAMPTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "NORTHUMBERLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "NORTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "NOTTOWAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "ORANGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PAGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PATRICK",
            abbreviation: null,
            code: null,
          },
          {
            name: "PETERSBURG",
            abbreviation: null,
            code: null,
          },
          {
            name: "PITTSYLVANIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "POQUOSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "PORTSMOUTH",
            abbreviation: null,
            code: null,
          },
          {
            name: "POWHATAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "PRINCE EDWARD",
            abbreviation: null,
            code: null,
          },
          {
            name: "PRINCE GEORGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PRINCE WILLIAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "PULASKI",
            abbreviation: null,
            code: null,
          },
          {
            name: "RADFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "RAPPAHANNOCK",
            abbreviation: null,
            code: null,
          },
          {
            name: "RICHMOND",
            abbreviation: null,
            code: null,
          },
          {
            name: "RICHMOND",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROANOKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROANOKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROCKBRIDGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROCKINGHAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "RUSSELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "SALEM",
            abbreviation: null,
            code: null,
          },
          {
            name: "SCOTT",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHENANDOAH",
            abbreviation: null,
            code: null,
          },
          {
            name: "SMYTH",
            abbreviation: null,
            code: null,
          },
          {
            name: "SOUTHAMPTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "SPOTSYLVANIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "STAFFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "STAUNTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "SUFFOLK",
            abbreviation: null,
            code: null,
          },
          {
            name: "SURRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "SUSSEX",
            abbreviation: null,
            code: null,
          },
          {
            name: "TAZEWELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "VIRGINIA BEACH",
            abbreviation: null,
            code: null,
          },
          {
            name: "WARREN",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WAYNESBORO",
            abbreviation: null,
            code: null,
          },
          {
            name: "WESTMORELAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "WILLIAMSBURG",
            abbreviation: null,
            code: null,
          },
          {
            name: "WINCHESTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "WISE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WYTHE",
            abbreviation: null,
            code: null,
          },
          {
            name: "YORK",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Vermont",
        abbreviation: "VT",
        counties: [
          {
            name: "ADDISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "BENNINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CALEDONIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHITTENDEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "ESSEX",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRANKLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRAND ISLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAMOILLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ORANGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ORLEANS",
            abbreviation: null,
            code: null,
          },
          {
            name: "RUTLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WINDHAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "WINDSOR",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Washington",
        abbreviation: "WA",
        counties: [
          {
            name: "ADAMS",
            abbreviation: null,
            code: null,
          },
          {
            name: "ASOTIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "BENTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHELAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLALLAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLARK",
            abbreviation: null,
            code: null,
          },
          {
            name: "COLUMBIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "COWLITZ",
            abbreviation: null,
            code: null,
          },
          {
            name: "DOUGLAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "FERRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRANKLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "GARFIELD",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRANT",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRAYS HARBOR",
            abbreviation: null,
            code: null,
          },
          {
            name: "ISLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "KING",
            abbreviation: null,
            code: null,
          },
          {
            name: "KITSAP",
            abbreviation: null,
            code: null,
          },
          {
            name: "KITTITAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "KLICKITAT",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEWIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINCOLN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MASON",
            abbreviation: null,
            code: null,
          },
          {
            name: "OKANOGAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "PACIFIC",
            abbreviation: null,
            code: null,
          },
          {
            name: "PEND OREILLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PIERCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SAN JUAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "SKAGIT",
            abbreviation: null,
            code: null,
          },
          {
            name: "SKAMANIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "SNOHOMISH",
            abbreviation: null,
            code: null,
          },
          {
            name: "SPOKANE",
            abbreviation: null,
            code: null,
          },
          {
            name: "STEVENS",
            abbreviation: null,
            code: null,
          },
          {
            name: "THURSTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WAHKIAKUM",
            abbreviation: null,
            code: null,
          },
          {
            name: "WALLA WALLA",
            abbreviation: null,
            code: null,
          },
          {
            name: "WHATCOM",
            abbreviation: null,
            code: null,
          },
          {
            name: "WHITMAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "YAKIMA",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Wisconsin",
        abbreviation: "WI",
        counties: [
          {
            name: "ADAMS",
            abbreviation: null,
            code: null,
          },
          {
            name: "ASHLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "BARRON",
            abbreviation: null,
            code: null,
          },
          {
            name: "BAYFIELD",
            abbreviation: null,
            code: null,
          },
          {
            name: "BROWN",
            abbreviation: null,
            code: null,
          },
          {
            name: "BUFFALO",
            abbreviation: null,
            code: null,
          },
          {
            name: "BURNETT",
            abbreviation: null,
            code: null,
          },
          {
            name: "CALUMET",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHIPPEWA",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLARK",
            abbreviation: null,
            code: null,
          },
          {
            name: "COLUMBIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "CRAWFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "DANE",
            abbreviation: null,
            code: null,
          },
          {
            name: "DODGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "DOOR",
            abbreviation: null,
            code: null,
          },
          {
            name: "DOUGLAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "DUNN",
            abbreviation: null,
            code: null,
          },
          {
            name: "EAU CLAIRE",
            abbreviation: null,
            code: null,
          },
          {
            name: "FLORENCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "FOND DU LAC",
            abbreviation: null,
            code: null,
          },
          {
            name: "FOREST",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRANT",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREEN LAKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "IOWA",
            abbreviation: null,
            code: null,
          },
          {
            name: "IRON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JACKSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JUNEAU",
            abbreviation: null,
            code: null,
          },
          {
            name: "KENOSHA",
            abbreviation: null,
            code: null,
          },
          {
            name: "KEWAUNEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LA CROSSE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAFAYETTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LANGLADE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINCOLN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MANITOWOC",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARATHON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARINETTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARQUETTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MENOMINEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MILWAUKEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONROE",
            abbreviation: null,
            code: null,
          },
          {
            name: "OCONTO",
            abbreviation: null,
            code: null,
          },
          {
            name: "ONEIDA",
            abbreviation: null,
            code: null,
          },
          {
            name: "OUTAGAMIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "OZAUKEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PEPIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "PIERCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "POLK",
            abbreviation: null,
            code: null,
          },
          {
            name: "PORTAGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PRICE",
            abbreviation: null,
            code: null,
          },
          {
            name: "RACINE",
            abbreviation: null,
            code: null,
          },
          {
            name: "RICHLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROCK",
            abbreviation: null,
            code: null,
          },
          {
            name: "RUSK",
            abbreviation: null,
            code: null,
          },
          {
            name: "SAUK",
            abbreviation: null,
            code: null,
          },
          {
            name: "SAWYER",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHAWANO",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHEBOYGAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "ST CROIX",
            abbreviation: null,
            code: null,
          },
          {
            name: "TAYLOR",
            abbreviation: null,
            code: null,
          },
          {
            name: "TREMPEALEAU",
            abbreviation: null,
            code: null,
          },
          {
            name: "VERNON",
            abbreviation: null,
            code: null,
          },
          {
            name: "VILAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "WALWORTH",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHBURN",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WAUKESHA",
            abbreviation: null,
            code: null,
          },
          {
            name: "WAUPACA",
            abbreviation: null,
            code: null,
          },
          {
            name: "WAUSHARA",
            abbreviation: null,
            code: null,
          },
          {
            name: "WINNEBAGO",
            abbreviation: null,
            code: null,
          },
          {
            name: "WOOD",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "West Virginia",
        abbreviation: "WV",
        counties: [
          {
            name: "BARBOUR",
            abbreviation: null,
            code: null,
          },
          {
            name: "BERKELEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "BOONE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BRAXTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "BROOKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CABELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "CALHOUN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "DODDRIDGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "FAYETTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "GILMER",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRANT",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREENBRIER",
            abbreviation: null,
            code: null,
          },
          {
            name: "HAMPSHIRE",
            abbreviation: null,
            code: null,
          },
          {
            name: "HANCOCK",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARDY",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARRISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JACKSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "KANAWHA",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEWIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINCOLN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LOGAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARION",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARSHALL",
            abbreviation: null,
            code: null,
          },
          {
            name: "MASON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCDOWELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "MERCER",
            abbreviation: null,
            code: null,
          },
          {
            name: "MINERAL",
            abbreviation: null,
            code: null,
          },
          {
            name: "MINGO",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONONGALIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONROE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MORGAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "NICHOLAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "OHIO",
            abbreviation: null,
            code: null,
          },
          {
            name: "PENDLETON",
            abbreviation: null,
            code: null,
          },
          {
            name: "PLEASANTS",
            abbreviation: null,
            code: null,
          },
          {
            name: "POCAHONTAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "PRESTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "PUTNAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "RALEIGH",
            abbreviation: null,
            code: null,
          },
          {
            name: "RANDOLPH",
            abbreviation: null,
            code: null,
          },
          {
            name: "RITCHIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROANE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SUMMERS",
            abbreviation: null,
            code: null,
          },
          {
            name: "TAYLOR",
            abbreviation: null,
            code: null,
          },
          {
            name: "TUCKER",
            abbreviation: null,
            code: null,
          },
          {
            name: "TYLER",
            abbreviation: null,
            code: null,
          },
          {
            name: "UPSHUR",
            abbreviation: null,
            code: null,
          },
          {
            name: "WAYNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WEBSTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "WETZEL",
            abbreviation: null,
            code: null,
          },
          {
            name: "WIRT",
            abbreviation: null,
            code: null,
          },
          {
            name: "WOOD",
            abbreviation: null,
            code: null,
          },
          {
            name: "WYOMING",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Wyoming",
        abbreviation: "WY",
        counties: [
          {
            name: "ALBANY",
            abbreviation: null,
            code: null,
          },
          {
            name: "BIG HORN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CAMPBELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARBON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CONVERSE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CROOK",
            abbreviation: null,
            code: null,
          },
          {
            name: "FREMONT",
            abbreviation: null,
            code: null,
          },
          {
            name: "GOSHEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOT SPRINGS",
            abbreviation: null,
            code: null,
          },
          {
            name: "JOHNSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "LARAMIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINCOLN",
            abbreviation: null,
            code: null,
          },
          {
            name: "NATRONA",
            abbreviation: null,
            code: null,
          },
          {
            name: "NIOBRARA",
            abbreviation: null,
            code: null,
          },
          {
            name: "PARK",
            abbreviation: null,
            code: null,
          },
          {
            name: "PLATTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHERIDAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "SUBLETTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SWEETWATER",
            abbreviation: null,
            code: null,
          },
          {
            name: "TETON",
            abbreviation: null,
            code: null,
          },
          {
            name: "UINTA",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHAKIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WESTON",
            abbreviation: null,
            code: null,
          },
        ],
      },
    ],
    region: "usa",
    name: "United States",
  },
  {
    code: "CA",
    states: [
      {
        name: "Alberta",
        abbreviation: null,
        counties: null,
      },
      {
        name: "British Columbia",
        abbreviation: null,
        counties: [
          {
            name: "Lower Mainland",
            abbreviation: null,
            code: null,
          },
          {
            name: "Northern BC",
            abbreviation: null,
            code: null,
          },
          {
            name: "Vancouver Island",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Manitoba",
        abbreviation: null,
        counties: null,
      },
      {
        name: "New Brunswick",
        abbreviation: null,
        counties: null,
      },
      {
        name: "Newfoundland and Labrador",
        abbreviation: null,
        counties: null,
      },
      {
        name: "Northwest Territories",
        abbreviation: null,
        counties: null,
      },
      {
        name: "Nova Scotia",
        abbreviation: null,
        counties: null,
      },
      {
        name: "Nunavut",
        abbreviation: null,
        counties: null,
      },
      {
        name: "Ontario",
        abbreviation: null,
        counties: [
          { name: "Algoma", abbreviation: null, code: null },
          { name: "Brant", abbreviation: null, code: null },
          { name: "Bruce", abbreviation: null, code: null },
          { name: "Chatham-Kent", abbreviation: null, code: null },
          { name: "Cochrane", abbreviation: null, code: null },
          { name: "Dufferin", abbreviation: null, code: null },
          { name: "Durham", abbreviation: null, code: null },
          { name: "Elgin", abbreviation: null, code: null },
          { name: "Essex", abbreviation: null, code: null },
          { name: "Frontenac", abbreviation: null, code: null },
          {
            name: "Greater Sudbury / Grand Sudbury",
            abbreviation: null,
            code: null,
          },
          { name: "Grey", abbreviation: null, code: null },
          { name: "Haldimand-Norfolk", abbreviation: null, code: null },
          { name: "Haliburton", abbreviation: null, code: null },
          { name: "Halton", abbreviation: null, code: null },
          { name: "Hamilton", abbreviation: null, code: null },
          { name: "Hastings", abbreviation: null, code: null },
          { name: "Huron", abbreviation: null, code: null },
          { name: "Kawartha Lakes", abbreviation: null, code: null },
          { name: "Kenora", abbreviation: null, code: null },
          { name: "Lambton", abbreviation: null, code: null },
          { name: "Lanark", abbreviation: null, code: null },
          { name: "Leeds and Grenville", abbreviation: null, code: null },
          { name: "Lennox and Addington", abbreviation: null, code: null },
          { name: "Manitoulin", abbreviation: null, code: null },
          { name: "Middlesex", abbreviation: null, code: null },
          { name: "Muskoka", abbreviation: null, code: null },
          { name: "Niagara", abbreviation: null, code: null },
          { name: "Nipissing", abbreviation: null, code: null },
          { name: "Northumberland", abbreviation: null, code: null },
          { name: "Ottawa", abbreviation: null, code: null },
          { name: "Oxford", abbreviation: null, code: null },
          { name: "Parry Sound", abbreviation: null, code: null },
          { name: "Peel", abbreviation: null, code: null },
          { name: "Perth", abbreviation: null, code: null },
          { name: "Peterborough", abbreviation: null, code: null },
          { name: "Prescott and Russell", abbreviation: null, code: null },
          { name: "Prince Edward", abbreviation: null, code: null },
          { name: "Rainy River", abbreviation: null, code: null },
          { name: "Renfrew", abbreviation: null, code: null },
          { name: "Simcoe", abbreviation: null, code: null },
          {
            name: "Stormont Dundas and Glengarry",
            abbreviation: null,
            code: null,
          },
          { name: "Sudbury", abbreviation: null, code: null },
          { name: "Thunder Bay", abbreviation: null, code: null },
          { name: "Timiskaming", abbreviation: null, code: null },
          { name: "Toronto", abbreviation: null, code: null },
          { name: "Waterloo", abbreviation: null, code: null },
          { name: "Wellington", abbreviation: null, code: null },
          { name: "York", abbreviation: null, code: null },
        ],
      },
      {
        name: "Prince Edward Island",
        abbreviation: null,
        counties: null,
      },
      {
        name: "Quebec",
        abbreviation: null,
        counties: [
          { name: "Abitibi Temiscamingue", abbreviation: null, code: null },
          { name: "Bas Saint Laurent", abbreviation: null, code: null },
          { name: "Capitale Nationale", abbreviation: null, code: null },
          { name: "Centre du Quebec", abbreviation: null, code: null },
          { name: "Chaudiere Appalaches", abbreviation: null, code: null },
          { name: "Cote Nord", abbreviation: null, code: null },
          { name: "Estrie", abbreviation: null, code: null },
          {
            name: "Gaspesie iles de la Madeleine",
            abbreviation: null,
            code: null,
          },
          { name: "Lanaudiere", abbreviation: null, code: null },
          { name: "Laurentides", abbreviation: null, code: null },
          { name: "Laval", abbreviation: null, code: null },
          { name: "Mauricie", abbreviation: null, code: null },
          { name: "Monteregie", abbreviation: null, code: null },
          { name: "Montreal", abbreviation: null, code: null },
          { name: "Nord du Quebec", abbreviation: null, code: null },
          { name: "Outaouais", abbreviation: null, code: null },
          { name: "Saguenay Lac Saint Jean", abbreviation: null, code: null },
        ],
      },
      {
        name: "Saskatchewan",
        abbreviation: null,
        counties: null,
      },
      {
        name: "Yukon",
        abbreviation: null,
        counties: null,
      },
    ],
    region: "canada",
    name: "Canada",
  },
  {
    code: "AFG",
    states: null,
    region: "Asia",
    name: "Afghanistan",
  },
  {
    code: "ALA",
    states: null,
    region: "Europe",
    name: "Aland Islands",
  },
  {
    code: "ALB",
    states: null,
    region: "Europe",
    name: "Albania",
  },
  {
    code: "DZA",
    states: null,
    region: "Africa",
    name: "Algeria",
  },
  {
    code: "ASM",
    states: null,
    region: "Oceania",
    name: "American Samoa",
  },
  {
    code: "AND",
    states: null,
    region: "Europe",
    name: "Andorra",
  },
  {
    code: "AGO",
    states: null,
    region: "Africa",
    name: "Angola",
  },
  {
    code: null,
    states: null,
    region: "caribbean",
    name: "Anguilla",
  },
  {
    code: null,
    states: null,
    region: null,
    name: "Antarctica",
  },
  {
    code: null,
    states: null,
    region: "caribbean",
    name: "Antigua and Barbuda",
  },
  {
    code: null,
    states: null,
    region: "southAmerica",
    name: "Argentina",
  },
  {
    code: null,
    states: null,
    region: "europe",
    name: "Armenia",
  },
  {
    code: null,
    states: null,
    region: "caribbean",
    name: "Aruba",
  },
  {
    code: null,
    states: null,
    region: "australia",
    name: "Australia",
  },
  {
    code: null,
    states: null,
    region: "europe",
    name: "Austria",
  },
  {
    code: null,
    states: null,
    region: "europe",
    name: "Azerbaijan",
  },
  {
    code: null,
    states: null,
    region: "caribbean",
    name: "Bahamas",
  },
  {
    code: null,
    states: null,
    region: "middleEast",
    name: "Bahrain",
  },
  {
    code: null,
    states: null,
    region: "asia",
    name: "Bangladesh",
  },
  {
    code: null,
    states: null,
    region: "caribbean",
    name: "Barbados",
  },
  {
    code: null,
    states: null,
    region: "europe",
    name: "Belarus",
  },
  {
    code: null,
    states: null,
    region: "europe",
    name: "Belgium",
  },
  {
    code: null,
    states: null,
    region: "centralAmerica",
    name: "Belize",
  },
  {
    code: null,
    states: null,
    region: "africa",
    name: "Benin",
  },
  {
    code: null,
    states: null,
    region: null,
    name: "Bermuda",
  },
  {
    code: null,
    states: null,
    region: "asia",
    name: "Bhutan",
  },
  {
    code: null,
    states: null,
    region: "southAmerica",
    name: "Bolivia",
  },
  {
    code: null,
    states: null,
    region: "europe",
    name: "Bosnia and Herzegovina",
  },
  {
    code: null,
    states: null,
    region: "africa",
    name: "Botswana",
  },
  {
    code: null,
    states: null,
    region: null,
    name: "Bouvet Island",
  },
  {
    code: null,
    states: null,
    region: "southAmerica",
    name: "Brazil",
  },
  {
    code: null,
    states: null,
    region: null,
    name: "British Indian Ocean Territory",
  },
  {
    code: null,
    states: null,
    region: "asia",
    name: "Brunei Darussalam",
  },
  {
    code: null,
    states: null,
    region: "europe",
    name: "Bulgaria",
  },
  {
    code: null,
    states: null,
    region: "africa",
    name: "Burkina Faso",
  },
  {
    code: null,
    states: null,
    region: "africa",
    name: "Burundi",
  },
  {
    code: null,
    states: null,
    region: "asia",
    name: "Cambodia",
  },
  {
    code: null,
    states: null,
    region: "africa",
    name: "Cameroon",
  },
  {
    code: null,
    states: null,
    region: null,
    name: "Cape Verde",
  },
  {
    code: null,
    states: null,
    region: "caribbean",
    name: "Cayman Islands",
  },
  {
    code: null,
    states: null,
    region: "africa",
    name: "Central African Republic",
  },
  {
    code: null,
    states: null,
    region: "africa",
    name: "Chad",
  },
  {
    code: null,
    states: null,
    region: "southAmerica",
    name: "Chile",
  },
  {
    code: null,
    states: null,
    region: "asia",
    name: "China",
  },
  {
    code: null,
    states: null,
    region: "oceania",
    name: "Christmas Island",
  },
  {
    code: null,
    states: null,
    region: "oceania",
    name: "Cocos (Keeling) Islands",
  },
  {
    code: null,
    states: null,
    region: "southAmerica",
    name: "Colombia",
  },
  {
    code: null,
    states: null,
    region: "africa",
    name: "Comoros",
  },
  {
    code: null,
    states: null,
    region: "africa",
    name: "Congo",
  },
  {
    code: null,
    states: null,
    region: "africa",
    name: "Congo, The Democratic Republic of the",
  },
  {
    code: null,
    states: null,
    region: "oceania",
    name: "Cook Islands",
  },
  {
    code: null,
    states: null,
    region: "centralAmerica",
    name: "Costa Rica",
  },
  {
    code: null,
    states: null,
    region: "africa",
    name: "Cote d'Ivoire",
  },
  {
    code: null,
    states: null,
    region: "europe",
    name: "Croatia",
  },
  {
    code: null,
    states: null,
    region: "caribbean",
    name: "Cuba",
  },
  {
    code: null,
    states: null,
    region: "caribbean",
    name: "Curacao",
  },
  {
    code: null,
    states: null,
    region: "middleEast",
    name: "Cyprus",
  },
  {
    code: null,
    states: null,
    region: "europe",
    name: "Czech Republic",
  },
  {
    code: null,
    states: null,
    region: "europe",
    name: "Denmark",
  },
  {
    code: null,
    states: null,
    region: "africa",
    name: "Djibouti",
  },
  {
    code: null,
    states: null,
    region: "caribbean",
    name: "Dominica",
  },
  {
    code: null,
    states: null,
    region: "caribbean",
    name: "Dominican Republic",
  },
  {
    code: null,
    states: null,
    region: "southAmerica",
    name: "Ecuador",
  },
  {
    code: null,
    states: null,
    region: "africa",
    name: "Egypt",
  },
  {
    code: null,
    states: null,
    region: "centralAmerica",
    name: "El Salvador",
  },
  {
    code: null,
    states: null,
    region: "africa",
    name: "Equatorial Guinea",
  },
  {
    code: null,
    states: null,
    region: "africa",
    name: "Eritrea",
  },
  {
    code: null,
    states: null,
    region: "europe",
    name: "Estonia",
  },
  {
    code: null,
    states: null,
    region: "africa",
    name: "Ethiopia",
  },
  {
    code: null,
    states: null,
    region: "southAmerica",
    name: "Falkland Islands (Malvinas)",
  },
  {
    code: null,
    states: null,
    region: "europe",
    name: "Faroe Islands",
  },
  {
    code: null,
    states: null,
    region: "oceania",
    name: "Fiji",
  },
  {
    code: null,
    states: null,
    region: "europe",
    name: "Finland",
  },
  {
    code: null,
    states: null,
    region: "europe",
    name: "France",
  },
  {
    code: null,
    states: null,
    region: "southAmerica",
    name: "French Guiana",
  },
  {
    code: null,
    states: null,
    region: "oceania",
    name: "French Polynesia",
  },
  {
    code: null,
    states: null,
    region: null,
    name: "French Southern Territories",
  },
  {
    code: null,
    states: null,
    region: "africa",
    name: "Gabon",
  },
  {
    code: null,
    states: null,
    region: "africa",
    name: "Gambia",
  },
  {
    code: null,
    states: null,
    region: "europe",
    name: "Georgia",
  },
  {
    code: null,
    states: null,
    region: "europe",
    name: "Germany",
  },
  {
    code: null,
    states: null,
    region: "africa",
    name: "Ghana",
  },
  {
    code: null,
    states: null,
    region: "europe",
    name: "Gibraltar",
  },
  {
    code: null,
    states: null,
    region: "europe",
    name: "Greece",
  },
  {
    code: null,
    states: null,
    region: null,
    name: "Greenland",
  },
  {
    code: null,
    states: null,
    region: "caribbean",
    name: "Grenada",
  },
  {
    code: null,
    states: null,
    region: "caribbean",
    name: "Guadeloupe",
  },
  {
    code: null,
    states: null,
    region: "oceania",
    name: "Guam",
  },
  {
    code: null,
    states: null,
    region: "centralAmerica",
    name: "Guatemala",
  },
  {
    code: null,
    states: null,
    region: "europe",
    name: "Guernsey",
  },
  {
    code: null,
    states: null,
    region: "africa",
    name: "Guinea",
  },
  {
    code: null,
    states: null,
    region: "africa",
    name: "Guinea-Bissau",
  },
  {
    code: null,
    states: null,
    region: "southAmerica",
    name: "Guyana",
  },
  {
    code: null,
    states: null,
    region: "caribbean",
    name: "Haiti",
  },
  {
    code: null,
    states: null,
    region: null,
    name: "Heard Island and McDonald Islands",
  },
  {
    code: null,
    states: null,
    region: "europe",
    name: "Holy See (Vatican City State)",
  },
  {
    code: null,
    states: null,
    region: "centralAmerica",
    name: "Honduras",
  },
  {
    code: null,
    states: null,
    region: "asia",
    name: "Hong Kong",
  },
  {
    code: null,
    states: null,
    region: "europe",
    name: "Hungary",
  },
  {
    code: null,
    states: null,
    region: "europe",
    name: "Iceland",
  },
  {
    code: null,
    states: null,
    region: "asia",
    name: "India",
  },
  {
    code: null,
    states: null,
    region: "asia",
    name: "Indonesia",
  },
  {
    code: null,
    states: null,
    region: "middleEast",
    name: "Iran, Islamic Republic of",
  },
  {
    code: null,
    states: null,
    region: "middleEast",
    name: "Iraq",
  },
  {
    code: null,
    states: null,
    region: "europe",
    name: "Ireland",
  },
  {
    code: null,
    states: null,
    region: "europe",
    name: "Isle of Man",
  },
  {
    code: null,
    states: null,
    region: "middleEast",
    name: "Israel",
  },
  {
    code: null,
    states: null,
    region: "europe",
    name: "Italy",
  },
  {
    code: null,
    states: null,
    region: "caribbean",
    name: "Jamaica",
  },
  {
    code: null,
    states: null,
    region: "asia",
    name: "Japan",
  },
  {
    code: null,
    states: null,
    region: "europe",
    name: "Jersey",
  },
  {
    code: null,
    states: null,
    region: "middleEast",
    name: "Jordan",
  },
  {
    code: null,
    states: null,
    region: "europe",
    name: "Kazakhstan",
  },
  {
    code: null,
    states: null,
    region: "africa",
    name: "Kenya",
  },
  {
    code: null,
    states: null,
    region: "oceania",
    name: "Kiribati",
  },
  {
    code: null,
    states: null,
    region: "asia",
    name: "Korea, Democratic People's Republic of",
  },
  {
    code: null,
    states: null,
    region: "asia",
    name: "Korea, Republic of",
  },
  {
    code: null,
    states: null,
    region: "middleEast",
    name: "Kuwait",
  },
  {
    code: null,
    states: null,
    region: "asia",
    name: "Kyrgyzstan",
  },
  {
    code: null,
    states: null,
    region: "asia",
    name: "Lao People's Democratic Republic",
  },
  {
    code: null,
    states: null,
    region: "europe",
    name: "Latvia",
  },
  {
    code: null,
    states: null,
    region: "middleEast",
    name: "Lebanon",
  },
  {
    code: null,
    states: null,
    region: "africa",
    name: "Lesotho",
  },
  {
    code: null,
    states: null,
    region: "africa",
    name: "Liberia",
  },
  {
    code: null,
    states: null,
    region: null,
    name: "Libyan Arab Jamahiriya",
  },
  {
    code: null,
    states: null,
    region: "europe",
    name: "Liechtenstein",
  },
  {
    code: null,
    states: null,
    region: "europe",
    name: "Lithuania",
  },
  {
    code: null,
    states: null,
    region: "europe",
    name: "Luxembourg",
  },
  {
    code: null,
    states: null,
    region: "asia",
    name: "Macao",
  },
  {
    code: null,
    states: null,
    region: null,
    name: "Macedonia, The Former Yugoslav Republic of",
  },
  {
    code: null,
    states: null,
    region: "africa",
    name: "Madagascar",
  },
  {
    code: null,
    states: null,
    region: "africa",
    name: "Malawi",
  },
  {
    code: null,
    states: null,
    region: "asia",
    name: "Malaysia",
  },
  {
    code: null,
    states: null,
    region: "asia",
    name: "Maldives",
  },
  {
    code: null,
    states: null,
    region: "africa",
    name: "Mali",
  },
  {
    code: null,
    states: null,
    region: "europe",
    name: "Malta",
  },
  {
    code: null,
    states: null,
    region: "oceania",
    name: "Marshall Islands",
  },
  {
    code: null,
    states: null,
    region: "caribbean",
    name: "Martinique",
  },
  {
    code: null,
    states: null,
    region: "africa",
    name: "Mauritania",
  },
  {
    code: null,
    states: null,
    region: "africa",
    name: "Mauritius",
  },
  {
    code: null,
    states: null,
    region: "africa",
    name: "Mayotte",
  },
  {
    code: null,
    states: null,
    region: "centralAmerica",
    name: "Mexico",
  },
  {
    code: null,
    states: null,
    region: "oceania",
    name: "Micronesia, Federated States of",
  },
  {
    code: null,
    states: null,
    region: "europe",
    name: "Moldova, Republic of",
  },
  {
    code: null,
    states: null,
    region: "europe",
    name: "Monaco",
  },
  {
    code: null,
    states: null,
    region: "asia",
    name: "Mongolia",
  },
  {
    code: null,
    states: null,
    region: "europe",
    name: "Montenegro",
  },
  {
    code: null,
    states: null,
    region: "caribbean",
    name: "Montserrat",
  },
  {
    code: null,
    states: null,
    region: "africa",
    name: "Morocco",
  },
  {
    code: null,
    states: null,
    region: "africa",
    name: "Mozambique",
  },
  {
    code: null,
    states: null,
    region: "asia",
    name: "Myanmar",
  },
  {
    code: null,
    states: null,
    region: "africa",
    name: "Namibia",
  },
  {
    code: null,
    states: null,
    region: "oceania",
    name: "Nauru",
  },
  {
    code: null,
    states: null,
    region: "asia",
    name: "Nepal",
  },
  {
    code: null,
    states: null,
    region: "europe",
    name: "Netherlands",
  },
  {
    code: null,
    states: null,
    region: null,
    name: "Netherlands Antilles",
  },
  {
    code: null,
    states: null,
    region: "oceania",
    name: "New Caledonia",
  },
  {
    code: null,
    states: null,
    region: "oceania",
    name: "New Zealand",
  },
  {
    code: null,
    states: null,
    region: "centralAmerica",
    name: "Nicaragua",
  },
  {
    code: null,
    states: null,
    region: "africa",
    name: "Niger",
  },
  {
    code: null,
    states: null,
    region: "africa",
    name: "Nigeria",
  },
  {
    code: null,
    states: null,
    region: "oceania",
    name: "Niue",
  },
  {
    code: null,
    states: null,
    region: "oceania",
    name: "Norfolk Island",
  },
  {
    code: null,
    states: null,
    region: "oceania",
    name: "Northern Mariana Islands",
  },
  {
    code: null,
    states: null,
    region: "europe",
    name: "Norway",
  },
  {
    code: null,
    states: null,
    region: "middleEast",
    name: "Oman",
  },
  {
    code: null,
    states: null,
    region: "asia",
    name: "Pakistan",
  },
  {
    code: null,
    states: null,
    region: "oceania",
    name: "Palau",
  },
  {
    code: null,
    states: null,
    region: "middleEast",
    name: "Palestinian Territory,Occupied",
  },
  {
    code: null,
    states: null,
    region: "centralAmerica",
    name: "Panama",
  },
  {
    code: null,
    states: null,
    region: "oceania",
    name: "Papua New Guinea",
  },
  {
    code: null,
    states: null,
    region: "southAmerica",
    name: "Paraguay",
  },
  {
    code: null,
    states: null,
    region: "southAmerica",
    name: "Peru",
  },
  {
    code: null,
    states: null,
    region: "asia",
    name: "Philippines",
  },
  {
    code: null,
    states: null,
    region: "oceania",
    name: "Pitcairn",
  },
  {
    code: null,
    states: null,
    region: "europe",
    name: "Poland",
  },
  {
    code: null,
    states: null,
    region: "europe",
    name: "Portugal",
  },
  {
    code: null,
    states: null,
    region: "caribbean",
    name: "Puerto Rico",
  },
  {
    code: null,
    states: null,
    region: "middleEast",
    name: "Qatar",
  },
  {
    code: null,
    states: null,
    region: "africa",
    name: "Reunion",
  },
  {
    code: null,
    states: null,
    region: "europe",
    name: "Romania",
  },
  {
    code: null,
    states: null,
    region: "europe",
    name: "Russian Federation",
  },
  {
    code: null,
    states: null,
    region: "africa",
    name: "Rwanda",
  },
  {
    code: null,
    states: null,
    region: "caribbean",
    name: "Saint Barthelemy",
  },
  {
    code: null,
    states: null,
    region: "africa",
    name: "Saint Helena",
  },
  {
    code: null,
    states: null,
    region: "caribbean",
    name: "Saint Kitts and Nevis",
  },
  {
    code: null,
    states: null,
    region: "caribbean",
    name: "Saint Lucia",
  },
  {
    code: null,
    states: null,
    region: "caribbean",
    name: "Saint Martin",
  },
  {
    code: null,
    states: null,
    region: null,
    name: "Saint Pierre and Miquelon",
  },
  {
    code: null,
    states: null,
    region: "caribbean",
    name: "Saint Vincent and the Grenadines",
  },
  {
    code: null,
    states: null,
    region: "oceania",
    name: "Samoa",
  },
  {
    code: null,
    states: null,
    region: "europe",
    name: "San Marino",
  },
  {
    code: null,
    states: null,
    region: "africa",
    name: "Sao Tome and Principe",
  },
  {
    code: null,
    states: null,
    region: "middleEast",
    name: "Saudi Arabia",
  },
  {
    code: null,
    states: null,
    region: "africa",
    name: "Senegal",
  },
  {
    code: null,
    states: null,
    region: "europe",
    name: "Serbia",
  },
  {
    code: null,
    states: null,
    region: "africa",
    name: "Seychelles",
  },
  {
    code: null,
    states: null,
    region: "africa",
    name: "Sierra Leone",
  },
  {
    code: null,
    states: null,
    region: "asia",
    name: "Singapore",
  },
  {
    code: null,
    states: null,
    region: "caribbean",
    name: "Sint Maarten",
  },
  {
    code: null,
    states: null,
    region: "europe",
    name: "Slovakia",
  },
  {
    code: null,
    states: null,
    region: "europe",
    name: "Slovenia",
  },
  {
    code: null,
    states: null,
    region: "oceania",
    name: "Solomon Islands",
  },
  {
    code: null,
    states: null,
    region: "africa",
    name: "Somalia",
  },
  {
    code: null,
    states: null,
    region: "africa",
    name: "South Africa",
  },
  {
    code: null,
    states: null,
    region: null,
    name: "South Georgia and the South Sandwich Islands",
  },
  {
    code: null,
    states: null,
    region: "europe",
    name: "Spain",
  },
  {
    code: null,
    states: null,
    region: "asia",
    name: "Sri Lanka",
  },
  {
    code: null,
    states: null,
    region: "africa",
    name: "Sudan",
  },
  {
    code: null,
    states: null,
    region: "southAmerica",
    name: "Suriname",
  },
  {
    code: null,
    states: null,
    region: "europe",
    name: "Svalbard and Jan Mayen",
  },
  {
    code: null,
    states: null,
    region: null,
    name: "Swaziland",
  },
  {
    code: null,
    states: null,
    region: "europe",
    name: "Sweden",
  },
  {
    code: null,
    states: null,
    region: "europe",
    name: "Switzerland",
  },
  {
    code: null,
    states: null,
    region: "middleEast",
    name: "Syrian Arab Republic",
  },
  {
    code: null,
    states: null,
    region: "asia",
    name: "Taiwan",
  },
  {
    code: null,
    states: null,
    region: "asia",
    name: "Tajikistan",
  },
  {
    code: null,
    states: null,
    region: "africa",
    name: "Tanzania, United Republic of",
  },
  {
    code: null,
    states: null,
    region: "asia",
    name: "Thailand",
  },
  {
    code: null,
    states: null,
    region: "asia",
    name: "Timor-Leste",
  },
  {
    code: null,
    states: null,
    region: "africa",
    name: "Togo",
  },
  {
    code: null,
    states: null,
    region: "oceania",
    name: "Tokelau",
  },
  {
    code: null,
    states: null,
    region: "oceania",
    name: "Tonga",
  },
  {
    code: null,
    states: null,
    region: "caribbean",
    name: "Trinidad and Tobago",
  },
  {
    code: null,
    states: null,
    region: "africa",
    name: "Tunisia",
  },
  {
    code: null,
    states: null,
    region: "middleEast",
    name: "Turkey",
  },
  {
    code: null,
    states: null,
    region: "asia",
    name: "Turkmenistan",
  },
  {
    code: null,
    states: null,
    region: "caribbean",
    name: "Turks and Caicos Islands",
  },
  {
    code: null,
    states: null,
    region: "oceania",
    name: "Tuvalu",
  },
  {
    code: null,
    states: null,
    region: null,
    name: "UAE",
  },
  {
    code: null,
    states: null,
    region: "africa",
    name: "Uganda",
  },
  {
    code: null,
    states: null,
    region: "europe",
    name: "UK",
  },
  {
    code: null,
    states: null,
    region: "europe",
    name: "Ukraine",
  },
  {
    code: "US",
    states: [
      {
        name: "Alaska",
        abbreviation: "AK",
        counties: [
          {
            name: "ALEUTIANS EAST",
            abbreviation: null,
            code: null,
          },
          {
            name: "ALEUTIANS WEST",
            abbreviation: null,
            code: null,
          },
          {
            name: "ANCHORAGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BETHEL",
            abbreviation: null,
            code: null,
          },
          {
            name: "BRISTOL BAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHUGACH",
            abbreviation: null,
            code: null,
          },
          {
            name: "COPPER RIVER",
            abbreviation: null,
            code: null,
          },
          {
            name: "DENALI",
            abbreviation: null,
            code: null,
          },
          {
            name: "DILLINGHAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "FAIRBANKS NORTH STAR",
            abbreviation: null,
            code: null,
          },
          {
            name: "HAINES",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOONAH-ANGOON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JUNEAU",
            abbreviation: null,
            code: null,
          },
          {
            name: "KENAI PENINSULA",
            abbreviation: null,
            code: null,
          },
          {
            name: "KETCHIKAN GATEWAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "KODIAK ISLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "KUSILVAK",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAKE AND PENINSULA",
            abbreviation: null,
            code: null,
          },
          {
            name: "MATANUSKA-SUSITNA",
            abbreviation: null,
            code: null,
          },
          {
            name: "NOME",
            abbreviation: null,
            code: null,
          },
          {
            name: "NORTH SLOPE",
            abbreviation: null,
            code: null,
          },
          {
            name: "NORTHWEST ARCTIC",
            abbreviation: null,
            code: null,
          },
          {
            name: "PETERSBURG",
            abbreviation: null,
            code: null,
          },
          {
            name: "PRINCE OF WALES-HYDER",
            abbreviation: null,
            code: null,
          },
          {
            name: "SITKA",
            abbreviation: null,
            code: null,
          },
          {
            name: "SKAGWAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "SOUTHEAST FAIRBANKS",
            abbreviation: null,
            code: null,
          },
          {
            name: "WRANGELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "YAKUTAT",
            abbreviation: null,
            code: null,
          },
          {
            name: "YUKON-KOYUKUK",
            abbreviation: null,
            code: null,
          },
          {
            name: "VALDEZ\u2013CORDOVA",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Alabama",
        abbreviation: "AL",
        counties: [
          {
            name: "AUTAUGA",
            abbreviation: null,
            code: null,
          },
          {
            name: "BALDWIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "BARBOUR",
            abbreviation: null,
            code: null,
          },
          {
            name: "BIBB",
            abbreviation: null,
            code: null,
          },
          {
            name: "BLOUNT",
            abbreviation: null,
            code: null,
          },
          {
            name: "BULLOCK",
            abbreviation: null,
            code: null,
          },
          {
            name: "BUTLER",
            abbreviation: null,
            code: null,
          },
          {
            name: "CALHOUN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHAMBERS",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHEROKEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHILTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHOCTAW",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLARKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLEBURNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "COFFEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "COLBERT",
            abbreviation: null,
            code: null,
          },
          {
            name: "CONECUH",
            abbreviation: null,
            code: null,
          },
          {
            name: "COOSA",
            abbreviation: null,
            code: null,
          },
          {
            name: "COVINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CRENSHAW",
            abbreviation: null,
            code: null,
          },
          {
            name: "CULLMAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "DALE",
            abbreviation: null,
            code: null,
          },
          {
            name: "DALLAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "DEKALB",
            abbreviation: null,
            code: null,
          },
          {
            name: "ELMORE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ESCAMBIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "ETOWAH",
            abbreviation: null,
            code: null,
          },
          {
            name: "FAYETTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRANKLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "GENEVA",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREENE",
            abbreviation: null,
            code: null,
          },
          {
            name: "HALE",
            abbreviation: null,
            code: null,
          },
          {
            name: "HENRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOUSTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JACKSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAMAR",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAUDERDALE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAWRENCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LIMESTONE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LOWNDES",
            abbreviation: null,
            code: null,
          },
          {
            name: "MACON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MADISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARENGO",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARION",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARSHALL",
            abbreviation: null,
            code: null,
          },
          {
            name: "MOBILE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONROE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONTGOMERY",
            abbreviation: null,
            code: null,
          },
          {
            name: "MORGAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "PERRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "PICKENS",
            abbreviation: null,
            code: null,
          },
          {
            name: "PIKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "RANDOLPH",
            abbreviation: null,
            code: null,
          },
          {
            name: "RUSSELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHELBY",
            abbreviation: null,
            code: null,
          },
          {
            name: "ST CLAIR",
            abbreviation: null,
            code: null,
          },
          {
            name: "SUMTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "TALLADEGA",
            abbreviation: null,
            code: null,
          },
          {
            name: "TALLAPOOSA",
            abbreviation: null,
            code: null,
          },
          {
            name: "TUSCALOOSA",
            abbreviation: null,
            code: null,
          },
          {
            name: "WALKER",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WILCOX",
            abbreviation: null,
            code: null,
          },
          {
            name: "WINSTON",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Arkansas",
        abbreviation: "AR",
        counties: [
          {
            name: "ARKANSAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "ASHLEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "BAXTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "BENTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "BOONE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BRADLEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CALHOUN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARROLL",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHICOT",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLARK",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLEBURNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLEVELAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "COLUMBIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "CONWAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CRAIGHEAD",
            abbreviation: null,
            code: null,
          },
          {
            name: "CRAWFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "CRITTENDEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CROSS",
            abbreviation: null,
            code: null,
          },
          {
            name: "DALLAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "DESHA",
            abbreviation: null,
            code: null,
          },
          {
            name: "DREW",
            abbreviation: null,
            code: null,
          },
          {
            name: "FAULKNER",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRANKLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "FULTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "GARLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRANT",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREENE",
            abbreviation: null,
            code: null,
          },
          {
            name: "HEMPSTEAD",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOT SPRING",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOWARD",
            abbreviation: null,
            code: null,
          },
          {
            name: "INDEPENDENCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "IZARD",
            abbreviation: null,
            code: null,
          },
          {
            name: "JACKSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JOHNSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAFAYETTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAWRENCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINCOLN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LITTLE RIVER",
            abbreviation: null,
            code: null,
          },
          {
            name: "LOGAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LONOKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MADISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARION",
            abbreviation: null,
            code: null,
          },
          {
            name: "MILLER",
            abbreviation: null,
            code: null,
          },
          {
            name: "MISSISSIPPI",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONROE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONTGOMERY",
            abbreviation: null,
            code: null,
          },
          {
            name: "NEVADA",
            abbreviation: null,
            code: null,
          },
          {
            name: "NEWTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "OUACHITA",
            abbreviation: null,
            code: null,
          },
          {
            name: "PERRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "PHILLIPS",
            abbreviation: null,
            code: null,
          },
          {
            name: "PIKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "POINSETT",
            abbreviation: null,
            code: null,
          },
          {
            name: "POLK",
            abbreviation: null,
            code: null,
          },
          {
            name: "POPE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PRAIRIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PULASKI",
            abbreviation: null,
            code: null,
          },
          {
            name: "RANDOLPH",
            abbreviation: null,
            code: null,
          },
          {
            name: "SALINE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SCOTT",
            abbreviation: null,
            code: null,
          },
          {
            name: "SEARCY",
            abbreviation: null,
            code: null,
          },
          {
            name: "SEBASTIAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "SEVIER",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHARP",
            abbreviation: null,
            code: null,
          },
          {
            name: "ST FRANCIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "STONE",
            abbreviation: null,
            code: null,
          },
          {
            name: "UNION",
            abbreviation: null,
            code: null,
          },
          {
            name: "VAN BUREN",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WHITE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WOODRUFF",
            abbreviation: null,
            code: null,
          },
          {
            name: "YELL",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Arizona",
        abbreviation: "AZ",
        counties: [
          {
            name: "APACHE",
            abbreviation: null,
            code: null,
          },
          {
            name: "COCHISE",
            abbreviation: null,
            code: null,
          },
          {
            name: "COCONINO",
            abbreviation: null,
            code: null,
          },
          {
            name: "GILA",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRAHAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREENLEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LA PAZ",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARICOPA",
            abbreviation: null,
            code: null,
          },
          {
            name: "MOHAVE",
            abbreviation: null,
            code: null,
          },
          {
            name: "NAVAJO",
            abbreviation: null,
            code: null,
          },
          {
            name: "PIMA",
            abbreviation: null,
            code: null,
          },
          {
            name: "PINAL",
            abbreviation: null,
            code: null,
          },
          {
            name: "SANTA CRUZ",
            abbreviation: null,
            code: null,
          },
          {
            name: "YAVAPAI",
            abbreviation: null,
            code: null,
          },
          {
            name: "YUMA",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "California",
        abbreviation: "CA",
        counties: [
          {
            name: "ALAMEDA",
            abbreviation: null,
            code: null,
          },
          {
            name: "ALPINE",
            abbreviation: null,
            code: null,
          },
          {
            name: "AMADOR",
            abbreviation: null,
            code: null,
          },
          {
            name: "BUTTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CALAVERAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "COLUSA",
            abbreviation: null,
            code: null,
          },
          {
            name: "CONTRA COSTA",
            abbreviation: null,
            code: null,
          },
          {
            name: "DEL NORTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "EL DORADO",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRESNO",
            abbreviation: null,
            code: null,
          },
          {
            name: "GLENN",
            abbreviation: null,
            code: null,
          },
          {
            name: "HUMBOLDT",
            abbreviation: null,
            code: null,
          },
          {
            name: "IMPERIAL",
            abbreviation: null,
            code: null,
          },
          {
            name: "INYO",
            abbreviation: null,
            code: null,
          },
          {
            name: "KERN",
            abbreviation: null,
            code: null,
          },
          {
            name: "KINGS",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LASSEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LOS ANGELES",
            abbreviation: null,
            code: null,
          },
          {
            name: "MADERA",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARIPOSA",
            abbreviation: null,
            code: null,
          },
          {
            name: "MENDOCINO",
            abbreviation: null,
            code: null,
          },
          {
            name: "MERCED",
            abbreviation: null,
            code: null,
          },
          {
            name: "MODOC",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONO",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONTEREY",
            abbreviation: null,
            code: null,
          },
          {
            name: "NAPA",
            abbreviation: null,
            code: null,
          },
          {
            name: "NEVADA",
            abbreviation: null,
            code: null,
          },
          {
            name: "ORANGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PLACER",
            abbreviation: null,
            code: null,
          },
          {
            name: "PLUMAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "RIVERSIDE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SACRAMENTO",
            abbreviation: null,
            code: null,
          },
          {
            name: "SAN BENITO",
            abbreviation: null,
            code: null,
          },
          {
            name: "SAN BERNARDINO",
            abbreviation: null,
            code: null,
          },
          {
            name: "SAN DIEGO",
            abbreviation: null,
            code: null,
          },
          {
            name: "SAN FRANCISCO",
            abbreviation: null,
            code: null,
          },
          {
            name: "SAN JOAQUIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "SAN LUIS OBISPO",
            abbreviation: null,
            code: null,
          },
          {
            name: "SAN MATEO",
            abbreviation: null,
            code: null,
          },
          {
            name: "SANTA BARBARA",
            abbreviation: null,
            code: null,
          },
          {
            name: "SANTA CLARA",
            abbreviation: null,
            code: null,
          },
          {
            name: "SANTA CRUZ",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHASTA",
            abbreviation: null,
            code: null,
          },
          {
            name: "SIERRA",
            abbreviation: null,
            code: null,
          },
          {
            name: "SISKIYOU",
            abbreviation: null,
            code: null,
          },
          {
            name: "SOLANO",
            abbreviation: null,
            code: null,
          },
          {
            name: "SONOMA",
            abbreviation: null,
            code: null,
          },
          {
            name: "STANISLAUS",
            abbreviation: null,
            code: null,
          },
          {
            name: "SUTTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "TEHAMA",
            abbreviation: null,
            code: null,
          },
          {
            name: "TRINITY",
            abbreviation: null,
            code: null,
          },
          {
            name: "TULARE",
            abbreviation: null,
            code: null,
          },
          {
            name: "TUOLUMNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "VENTURA",
            abbreviation: null,
            code: null,
          },
          {
            name: "YOLO",
            abbreviation: null,
            code: null,
          },
          {
            name: "YUBA",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Colorado",
        abbreviation: "CO",
        counties: [
          {
            name: "ADAMS",
            abbreviation: null,
            code: null,
          },
          {
            name: "ALAMOSA",
            abbreviation: null,
            code: null,
          },
          {
            name: "ARAPAHOE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ARCHULETA",
            abbreviation: null,
            code: null,
          },
          {
            name: "BACA",
            abbreviation: null,
            code: null,
          },
          {
            name: "BENT",
            abbreviation: null,
            code: null,
          },
          {
            name: "BOULDER",
            abbreviation: null,
            code: null,
          },
          {
            name: "BROOMFIELD",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHAFFEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHEYENNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLEAR CREEK",
            abbreviation: null,
            code: null,
          },
          {
            name: "CONEJOS",
            abbreviation: null,
            code: null,
          },
          {
            name: "COSTILLA",
            abbreviation: null,
            code: null,
          },
          {
            name: "CROWLEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CUSTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "DELTA",
            abbreviation: null,
            code: null,
          },
          {
            name: "DENVER",
            abbreviation: null,
            code: null,
          },
          {
            name: "DOLORES",
            abbreviation: null,
            code: null,
          },
          {
            name: "DOUGLAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "EAGLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "EL PASO",
            abbreviation: null,
            code: null,
          },
          {
            name: "ELBERT",
            abbreviation: null,
            code: null,
          },
          {
            name: "FREMONT",
            abbreviation: null,
            code: null,
          },
          {
            name: "GARFIELD",
            abbreviation: null,
            code: null,
          },
          {
            name: "GILPIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "GUNNISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HINSDALE",
            abbreviation: null,
            code: null,
          },
          {
            name: "HUERFANO",
            abbreviation: null,
            code: null,
          },
          {
            name: "JACKSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "KIOWA",
            abbreviation: null,
            code: null,
          },
          {
            name: "KIT CARSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "LA PLATA",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LARIMER",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAS ANIMAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINCOLN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LOGAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MESA",
            abbreviation: null,
            code: null,
          },
          {
            name: "MINERAL",
            abbreviation: null,
            code: null,
          },
          {
            name: "MOFFAT",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONTEZUMA",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONTROSE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MORGAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "OTERO",
            abbreviation: null,
            code: null,
          },
          {
            name: "OURAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "PARK",
            abbreviation: null,
            code: null,
          },
          {
            name: "PHILLIPS",
            abbreviation: null,
            code: null,
          },
          {
            name: "PITKIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "PROWERS",
            abbreviation: null,
            code: null,
          },
          {
            name: "PUEBLO",
            abbreviation: null,
            code: null,
          },
          {
            name: "RIO BLANCO",
            abbreviation: null,
            code: null,
          },
          {
            name: "RIO GRANDE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROUTT",
            abbreviation: null,
            code: null,
          },
          {
            name: "SAGUACHE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SAN JUAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "SAN MIGUEL",
            abbreviation: null,
            code: null,
          },
          {
            name: "SEDGWICK",
            abbreviation: null,
            code: null,
          },
          {
            name: "SUMMIT",
            abbreviation: null,
            code: null,
          },
          {
            name: "TELLER",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WELD",
            abbreviation: null,
            code: null,
          },
          {
            name: "YUMA",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Connecticut",
        abbreviation: "CT",
        counties: [
          {
            name: "FAIRFIELD",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARTFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "LITCHFIELD",
            abbreviation: null,
            code: null,
          },
          {
            name: "MIDDLESEX",
            abbreviation: null,
            code: null,
          },
          {
            name: "NEW HAVEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "NEW LONDON",
            abbreviation: null,
            code: null,
          },
          {
            name: "TOLLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "WINDHAM",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "District of Columbia",
        abbreviation: "DC",
        counties: [
          {
            name: "DISTRICT OF COLUMBIA",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Delaware",
        abbreviation: "DE",
        counties: [
          {
            name: "KENT",
            abbreviation: null,
            code: null,
          },
          {
            name: "NEW CASTLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SUSSEX",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Florida",
        abbreviation: "FL",
        counties: [
          {
            name: "ALACHUA",
            abbreviation: null,
            code: null,
          },
          {
            name: "BAKER",
            abbreviation: null,
            code: null,
          },
          {
            name: "BAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "BRADFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "BREVARD",
            abbreviation: null,
            code: null,
          },
          {
            name: "BROWARD",
            abbreviation: null,
            code: null,
          },
          {
            name: "CALHOUN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHARLOTTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CITRUS",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "COLLIER",
            abbreviation: null,
            code: null,
          },
          {
            name: "COLUMBIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "DESOTO",
            abbreviation: null,
            code: null,
          },
          {
            name: "DIXIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "DUVAL",
            abbreviation: null,
            code: null,
          },
          {
            name: "ESCAMBIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "FLAGLER",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRANKLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "GADSDEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "GILCHRIST",
            abbreviation: null,
            code: null,
          },
          {
            name: "GLADES",
            abbreviation: null,
            code: null,
          },
          {
            name: "GULF",
            abbreviation: null,
            code: null,
          },
          {
            name: "HAMILTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARDEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "HENDRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "HERNANDO",
            abbreviation: null,
            code: null,
          },
          {
            name: "HIGHLANDS",
            abbreviation: null,
            code: null,
          },
          {
            name: "HILLSBOROUGH",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOLMES",
            abbreviation: null,
            code: null,
          },
          {
            name: "INDIAN RIVER",
            abbreviation: null,
            code: null,
          },
          {
            name: "JACKSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAFAYETTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEON",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEVY",
            abbreviation: null,
            code: null,
          },
          {
            name: "LIBERTY",
            abbreviation: null,
            code: null,
          },
          {
            name: "MADISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MANATEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARION",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARTIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MIAMI-DADE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONROE",
            abbreviation: null,
            code: null,
          },
          {
            name: "NASSAU",
            abbreviation: null,
            code: null,
          },
          {
            name: "OKALOOSA",
            abbreviation: null,
            code: null,
          },
          {
            name: "OKEECHOBEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ORANGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "OSCEOLA",
            abbreviation: null,
            code: null,
          },
          {
            name: "PALM BEACH",
            abbreviation: null,
            code: null,
          },
          {
            name: "PASCO",
            abbreviation: null,
            code: null,
          },
          {
            name: "PINELLAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "POLK",
            abbreviation: null,
            code: null,
          },
          {
            name: "PUTNAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "SANTA ROSA",
            abbreviation: null,
            code: null,
          },
          {
            name: "SARASOTA",
            abbreviation: null,
            code: null,
          },
          {
            name: "SEMINOLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ST JOHNS",
            abbreviation: null,
            code: null,
          },
          {
            name: "ST LUCIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SUMTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "SUWANNEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "TAYLOR",
            abbreviation: null,
            code: null,
          },
          {
            name: "UNION",
            abbreviation: null,
            code: null,
          },
          {
            name: "VOLUSIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "WAKULLA",
            abbreviation: null,
            code: null,
          },
          {
            name: "WALTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Georgia",
        abbreviation: "GA",
        counties: [
          {
            name: "APPLING",
            abbreviation: null,
            code: null,
          },
          {
            name: "ATKINSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "BACON",
            abbreviation: null,
            code: null,
          },
          {
            name: "BAKER",
            abbreviation: null,
            code: null,
          },
          {
            name: "BALDWIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "BANKS",
            abbreviation: null,
            code: null,
          },
          {
            name: "BARROW",
            abbreviation: null,
            code: null,
          },
          {
            name: "BARTOW",
            abbreviation: null,
            code: null,
          },
          {
            name: "BEN HILL",
            abbreviation: null,
            code: null,
          },
          {
            name: "BERRIEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "BIBB",
            abbreviation: null,
            code: null,
          },
          {
            name: "BLECKLEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "BRANTLEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "BROOKS",
            abbreviation: null,
            code: null,
          },
          {
            name: "BRYAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "BULLOCH",
            abbreviation: null,
            code: null,
          },
          {
            name: "BURKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BUTTS",
            abbreviation: null,
            code: null,
          },
          {
            name: "CALHOUN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CAMDEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CANDLER",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARROLL",
            abbreviation: null,
            code: null,
          },
          {
            name: "CATOOSA",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHARLTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHATHAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHATTAHOOCHEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHATTOOGA",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHEROKEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLARKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLAYTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLINCH",
            abbreviation: null,
            code: null,
          },
          {
            name: "COBB",
            abbreviation: null,
            code: null,
          },
          {
            name: "COFFEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "COLQUITT",
            abbreviation: null,
            code: null,
          },
          {
            name: "COLUMBIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "COOK",
            abbreviation: null,
            code: null,
          },
          {
            name: "COWETA",
            abbreviation: null,
            code: null,
          },
          {
            name: "CRAWFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "CRISP",
            abbreviation: null,
            code: null,
          },
          {
            name: "DADE",
            abbreviation: null,
            code: null,
          },
          {
            name: "DAWSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "DECATUR",
            abbreviation: null,
            code: null,
          },
          {
            name: "DEKALB",
            abbreviation: null,
            code: null,
          },
          {
            name: "DODGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "DOOLY",
            abbreviation: null,
            code: null,
          },
          {
            name: "DOUGHERTY",
            abbreviation: null,
            code: null,
          },
          {
            name: "DOUGLAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "EARLY",
            abbreviation: null,
            code: null,
          },
          {
            name: "ECHOLS",
            abbreviation: null,
            code: null,
          },
          {
            name: "EFFINGHAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "ELBERT",
            abbreviation: null,
            code: null,
          },
          {
            name: "EMANUEL",
            abbreviation: null,
            code: null,
          },
          {
            name: "EVANS",
            abbreviation: null,
            code: null,
          },
          {
            name: "FANNIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "FAYETTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "FLOYD",
            abbreviation: null,
            code: null,
          },
          {
            name: "FORSYTH",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRANKLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "FULTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "GILMER",
            abbreviation: null,
            code: null,
          },
          {
            name: "GLASCOCK",
            abbreviation: null,
            code: null,
          },
          {
            name: "GLYNN",
            abbreviation: null,
            code: null,
          },
          {
            name: "GORDON",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRADY",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREENE",
            abbreviation: null,
            code: null,
          },
          {
            name: "GWINNETT",
            abbreviation: null,
            code: null,
          },
          {
            name: "HABERSHAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "HALL",
            abbreviation: null,
            code: null,
          },
          {
            name: "HANCOCK",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARALSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARRIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "HART",
            abbreviation: null,
            code: null,
          },
          {
            name: "HEARD",
            abbreviation: null,
            code: null,
          },
          {
            name: "HENRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOUSTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "IRWIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "JACKSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JASPER",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFF DAVIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JENKINS",
            abbreviation: null,
            code: null,
          },
          {
            name: "JOHNSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JONES",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAMAR",
            abbreviation: null,
            code: null,
          },
          {
            name: "LANIER",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAURENS",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LIBERTY",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINCOLN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LONG",
            abbreviation: null,
            code: null,
          },
          {
            name: "LOWNDES",
            abbreviation: null,
            code: null,
          },
          {
            name: "LUMPKIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MACON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MADISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARION",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCDUFFIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCINTOSH",
            abbreviation: null,
            code: null,
          },
          {
            name: "MERIWETHER",
            abbreviation: null,
            code: null,
          },
          {
            name: "MILLER",
            abbreviation: null,
            code: null,
          },
          {
            name: "MITCHELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONROE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONTGOMERY",
            abbreviation: null,
            code: null,
          },
          {
            name: "MORGAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MURRAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "MUSCOGEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "NEWTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "OCONEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "OGLETHORPE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PAULDING",
            abbreviation: null,
            code: null,
          },
          {
            name: "PEACH",
            abbreviation: null,
            code: null,
          },
          {
            name: "PICKENS",
            abbreviation: null,
            code: null,
          },
          {
            name: "PIERCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PIKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "POLK",
            abbreviation: null,
            code: null,
          },
          {
            name: "PULASKI",
            abbreviation: null,
            code: null,
          },
          {
            name: "PUTNAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "QUITMAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "RABUN",
            abbreviation: null,
            code: null,
          },
          {
            name: "RANDOLPH",
            abbreviation: null,
            code: null,
          },
          {
            name: "RICHMOND",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROCKDALE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SCHLEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "SCREVEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "SEMINOLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SPALDING",
            abbreviation: null,
            code: null,
          },
          {
            name: "STEPHENS",
            abbreviation: null,
            code: null,
          },
          {
            name: "STEWART",
            abbreviation: null,
            code: null,
          },
          {
            name: "SUMTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "TALBOT",
            abbreviation: null,
            code: null,
          },
          {
            name: "TALIAFERRO",
            abbreviation: null,
            code: null,
          },
          {
            name: "TATTNALL",
            abbreviation: null,
            code: null,
          },
          {
            name: "TAYLOR",
            abbreviation: null,
            code: null,
          },
          {
            name: "TELFAIR",
            abbreviation: null,
            code: null,
          },
          {
            name: "TERRELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "THOMAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "TIFT",
            abbreviation: null,
            code: null,
          },
          {
            name: "TOOMBS",
            abbreviation: null,
            code: null,
          },
          {
            name: "TOWNS",
            abbreviation: null,
            code: null,
          },
          {
            name: "TREUTLEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "TROUP",
            abbreviation: null,
            code: null,
          },
          {
            name: "TURNER",
            abbreviation: null,
            code: null,
          },
          {
            name: "TWIGGS",
            abbreviation: null,
            code: null,
          },
          {
            name: "UNION",
            abbreviation: null,
            code: null,
          },
          {
            name: "UPSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WALKER",
            abbreviation: null,
            code: null,
          },
          {
            name: "WALTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WARE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WARREN",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WAYNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WEBSTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "WHEELER",
            abbreviation: null,
            code: null,
          },
          {
            name: "WHITE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WHITFIELD",
            abbreviation: null,
            code: null,
          },
          {
            name: "WILCOX",
            abbreviation: null,
            code: null,
          },
          {
            name: "WILKES",
            abbreviation: null,
            code: null,
          },
          {
            name: "WILKINSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WORTH",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Hawaii",
        abbreviation: "HI",
        counties: [
          {
            name: "HAWAII",
            abbreviation: null,
            code: null,
          },
          {
            name: "HONOLULU",
            abbreviation: null,
            code: null,
          },
          {
            name: "KALAWAO",
            abbreviation: null,
            code: null,
          },
          {
            name: "KAUAI",
            abbreviation: null,
            code: null,
          },
          {
            name: "MAUI",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Iowa",
        abbreviation: "IA",
        counties: [
          {
            name: "ADAIR",
            abbreviation: null,
            code: null,
          },
          {
            name: "ADAMS",
            abbreviation: null,
            code: null,
          },
          {
            name: "ALLAMAKEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "APPANOOSE",
            abbreviation: null,
            code: null,
          },
          {
            name: "AUDUBON",
            abbreviation: null,
            code: null,
          },
          {
            name: "BENTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "BLACK HAWK",
            abbreviation: null,
            code: null,
          },
          {
            name: "BOONE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BREMER",
            abbreviation: null,
            code: null,
          },
          {
            name: "BUCHANAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "BUENA VISTA",
            abbreviation: null,
            code: null,
          },
          {
            name: "BUTLER",
            abbreviation: null,
            code: null,
          },
          {
            name: "CALHOUN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARROLL",
            abbreviation: null,
            code: null,
          },
          {
            name: "CASS",
            abbreviation: null,
            code: null,
          },
          {
            name: "CEDAR",
            abbreviation: null,
            code: null,
          },
          {
            name: "CERRO GORDO",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHEROKEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHICKASAW",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLARKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLAYTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLINTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CRAWFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "DALLAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "DAVIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "DECATUR",
            abbreviation: null,
            code: null,
          },
          {
            name: "DELAWARE",
            abbreviation: null,
            code: null,
          },
          {
            name: "DES MOINES",
            abbreviation: null,
            code: null,
          },
          {
            name: "DICKINSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "DUBUQUE",
            abbreviation: null,
            code: null,
          },
          {
            name: "EMMET",
            abbreviation: null,
            code: null,
          },
          {
            name: "FAYETTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "FLOYD",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRANKLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "FREMONT",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREENE",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRUNDY",
            abbreviation: null,
            code: null,
          },
          {
            name: "GUTHRIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "HAMILTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HANCOCK",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARDIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARRISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HENRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOWARD",
            abbreviation: null,
            code: null,
          },
          {
            name: "HUMBOLDT",
            abbreviation: null,
            code: null,
          },
          {
            name: "IDA",
            abbreviation: null,
            code: null,
          },
          {
            name: "IOWA",
            abbreviation: null,
            code: null,
          },
          {
            name: "JACKSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JASPER",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JOHNSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JONES",
            abbreviation: null,
            code: null,
          },
          {
            name: "KEOKUK",
            abbreviation: null,
            code: null,
          },
          {
            name: "KOSSUTH",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LOUISA",
            abbreviation: null,
            code: null,
          },
          {
            name: "LUCAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "LYON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MADISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MAHASKA",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARION",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARSHALL",
            abbreviation: null,
            code: null,
          },
          {
            name: "MILLS",
            abbreviation: null,
            code: null,
          },
          {
            name: "MITCHELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONONA",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONROE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONTGOMERY",
            abbreviation: null,
            code: null,
          },
          {
            name: "MUSCATINE",
            abbreviation: null,
            code: null,
          },
          {
            name: "O'BRIEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "OSCEOLA",
            abbreviation: null,
            code: null,
          },
          {
            name: "PAGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PALO ALTO",
            abbreviation: null,
            code: null,
          },
          {
            name: "PLYMOUTH",
            abbreviation: null,
            code: null,
          },
          {
            name: "POCAHONTAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "POLK",
            abbreviation: null,
            code: null,
          },
          {
            name: "POTTAWATTAMIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "POWESHIEK",
            abbreviation: null,
            code: null,
          },
          {
            name: "RINGGOLD",
            abbreviation: null,
            code: null,
          },
          {
            name: "SAC",
            abbreviation: null,
            code: null,
          },
          {
            name: "SCOTT",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHELBY",
            abbreviation: null,
            code: null,
          },
          {
            name: "SIOUX",
            abbreviation: null,
            code: null,
          },
          {
            name: "STORY",
            abbreviation: null,
            code: null,
          },
          {
            name: "TAMA",
            abbreviation: null,
            code: null,
          },
          {
            name: "TAYLOR",
            abbreviation: null,
            code: null,
          },
          {
            name: "UNION",
            abbreviation: null,
            code: null,
          },
          {
            name: "VAN BUREN",
            abbreviation: null,
            code: null,
          },
          {
            name: "WAPELLO",
            abbreviation: null,
            code: null,
          },
          {
            name: "WARREN",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WAYNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WEBSTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "WINNEBAGO",
            abbreviation: null,
            code: null,
          },
          {
            name: "WINNESHIEK",
            abbreviation: null,
            code: null,
          },
          {
            name: "WOODBURY",
            abbreviation: null,
            code: null,
          },
          {
            name: "WORTH",
            abbreviation: null,
            code: null,
          },
          {
            name: "WRIGHT",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Idaho",
        abbreviation: "ID",
        counties: [
          {
            name: "ADA",
            abbreviation: null,
            code: null,
          },
          {
            name: "ADAMS",
            abbreviation: null,
            code: null,
          },
          {
            name: "BANNOCK",
            abbreviation: null,
            code: null,
          },
          {
            name: "BEAR LAKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BENEWAH",
            abbreviation: null,
            code: null,
          },
          {
            name: "BINGHAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "BLAINE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BOISE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BONNER",
            abbreviation: null,
            code: null,
          },
          {
            name: "BONNEVILLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BOUNDARY",
            abbreviation: null,
            code: null,
          },
          {
            name: "BUTTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CAMAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "CANYON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARIBOU",
            abbreviation: null,
            code: null,
          },
          {
            name: "CASSIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLARK",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLEARWATER",
            abbreviation: null,
            code: null,
          },
          {
            name: "CUSTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "ELMORE",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRANKLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "FREMONT",
            abbreviation: null,
            code: null,
          },
          {
            name: "GEM",
            abbreviation: null,
            code: null,
          },
          {
            name: "GOODING",
            abbreviation: null,
            code: null,
          },
          {
            name: "IDAHO",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEROME",
            abbreviation: null,
            code: null,
          },
          {
            name: "KOOTENAI",
            abbreviation: null,
            code: null,
          },
          {
            name: "LATAH",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEMHI",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEWIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINCOLN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MADISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MINIDOKA",
            abbreviation: null,
            code: null,
          },
          {
            name: "NEZ PERCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ONEIDA",
            abbreviation: null,
            code: null,
          },
          {
            name: "OWYHEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PAYETTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "POWER",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHOSHONE",
            abbreviation: null,
            code: null,
          },
          {
            name: "TETON",
            abbreviation: null,
            code: null,
          },
          {
            name: "TWIN FALLS",
            abbreviation: null,
            code: null,
          },
          {
            name: "VALLEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Illinois",
        abbreviation: "IL",
        counties: [
          {
            name: "ADAMS",
            abbreviation: null,
            code: null,
          },
          {
            name: "ALEXANDER",
            abbreviation: null,
            code: null,
          },
          {
            name: "BOND",
            abbreviation: null,
            code: null,
          },
          {
            name: "BOONE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BROWN",
            abbreviation: null,
            code: null,
          },
          {
            name: "BUREAU",
            abbreviation: null,
            code: null,
          },
          {
            name: "CALHOUN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARROLL",
            abbreviation: null,
            code: null,
          },
          {
            name: "CASS",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHAMPAIGN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHRISTIAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLARK",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLINTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "COLES",
            abbreviation: null,
            code: null,
          },
          {
            name: "COOK",
            abbreviation: null,
            code: null,
          },
          {
            name: "CRAWFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "CUMBERLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "DEWITT",
            abbreviation: null,
            code: null,
          },
          {
            name: "DEKALB",
            abbreviation: null,
            code: null,
          },
          {
            name: "DOUGLAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "DUPAGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "EDGAR",
            abbreviation: null,
            code: null,
          },
          {
            name: "EDWARDS",
            abbreviation: null,
            code: null,
          },
          {
            name: "EFFINGHAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "FAYETTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "FORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRANKLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "FULTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "GALLATIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREENE",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRUNDY",
            abbreviation: null,
            code: null,
          },
          {
            name: "HAMILTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HANCOCK",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARDIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "HENDERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HENRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "IROQUOIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "JACKSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JASPER",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JERSEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "JO DAVIESS",
            abbreviation: null,
            code: null,
          },
          {
            name: "JOHNSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "KANE",
            abbreviation: null,
            code: null,
          },
          {
            name: "KANKAKEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "KENDALL",
            abbreviation: null,
            code: null,
          },
          {
            name: "KNOX",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LASALLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAWRENCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LIVINGSTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "LOGAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MACON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MACOUPIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MADISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARION",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARSHALL",
            abbreviation: null,
            code: null,
          },
          {
            name: "MASON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MASSAC",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCDONOUGH",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCHENRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCLEAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MENARD",
            abbreviation: null,
            code: null,
          },
          {
            name: "MERCER",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONROE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONTGOMERY",
            abbreviation: null,
            code: null,
          },
          {
            name: "MORGAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MOULTRIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "OGLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PEORIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "PERRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "PIATT",
            abbreviation: null,
            code: null,
          },
          {
            name: "PIKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "POPE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PULASKI",
            abbreviation: null,
            code: null,
          },
          {
            name: "PUTNAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "RANDOLPH",
            abbreviation: null,
            code: null,
          },
          {
            name: "RICHLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROCK ISLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "SALINE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SANGAMON",
            abbreviation: null,
            code: null,
          },
          {
            name: "SCHUYLER",
            abbreviation: null,
            code: null,
          },
          {
            name: "SCOTT",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHELBY",
            abbreviation: null,
            code: null,
          },
          {
            name: "ST CLAIR",
            abbreviation: null,
            code: null,
          },
          {
            name: "STARK",
            abbreviation: null,
            code: null,
          },
          {
            name: "STEPHENSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "TAZEWELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "UNION",
            abbreviation: null,
            code: null,
          },
          {
            name: "VERMILION",
            abbreviation: null,
            code: null,
          },
          {
            name: "WABASH",
            abbreviation: null,
            code: null,
          },
          {
            name: "WARREN",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WAYNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WHITE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WHITESIDE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WILL",
            abbreviation: null,
            code: null,
          },
          {
            name: "WILLIAMSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WINNEBAGO",
            abbreviation: null,
            code: null,
          },
          {
            name: "WOODFORD",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Indiana",
        abbreviation: "IN",
        counties: [
          {
            name: "ADAMS",
            abbreviation: null,
            code: null,
          },
          {
            name: "ALLEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "BARTHOLOMEW",
            abbreviation: null,
            code: null,
          },
          {
            name: "BENTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "BLACKFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "BOONE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BROWN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARROLL",
            abbreviation: null,
            code: null,
          },
          {
            name: "CASS",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLARK",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLINTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CRAWFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "DAVIESS",
            abbreviation: null,
            code: null,
          },
          {
            name: "DEARBORN",
            abbreviation: null,
            code: null,
          },
          {
            name: "DECATUR",
            abbreviation: null,
            code: null,
          },
          {
            name: "DEKALB",
            abbreviation: null,
            code: null,
          },
          {
            name: "DELAWARE",
            abbreviation: null,
            code: null,
          },
          {
            name: "DUBOIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "ELKHART",
            abbreviation: null,
            code: null,
          },
          {
            name: "FAYETTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "FLOYD",
            abbreviation: null,
            code: null,
          },
          {
            name: "FOUNTAIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRANKLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "FULTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "GIBSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRANT",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREENE",
            abbreviation: null,
            code: null,
          },
          {
            name: "HAMILTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HANCOCK",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARRISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HENDRICKS",
            abbreviation: null,
            code: null,
          },
          {
            name: "HENRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOWARD",
            abbreviation: null,
            code: null,
          },
          {
            name: "HUNTINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JACKSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JASPER",
            abbreviation: null,
            code: null,
          },
          {
            name: "JAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JENNINGS",
            abbreviation: null,
            code: null,
          },
          {
            name: "JOHNSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "KNOX",
            abbreviation: null,
            code: null,
          },
          {
            name: "KOSCIUSKO",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAGRANGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAPORTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAWRENCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MADISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARION",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARSHALL",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARTIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MIAMI",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONROE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONTGOMERY",
            abbreviation: null,
            code: null,
          },
          {
            name: "MORGAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "NEWTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "NOBLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "OHIO",
            abbreviation: null,
            code: null,
          },
          {
            name: "ORANGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "OWEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "PARKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PERRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "PIKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PORTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "POSEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "PULASKI",
            abbreviation: null,
            code: null,
          },
          {
            name: "PUTNAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "RANDOLPH",
            abbreviation: null,
            code: null,
          },
          {
            name: "RIPLEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "RUSH",
            abbreviation: null,
            code: null,
          },
          {
            name: "SCOTT",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHELBY",
            abbreviation: null,
            code: null,
          },
          {
            name: "SPENCER",
            abbreviation: null,
            code: null,
          },
          {
            name: "ST JOSEPH",
            abbreviation: null,
            code: null,
          },
          {
            name: "STARKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "STEUBEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "SULLIVAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "SWITZERLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "TIPPECANOE",
            abbreviation: null,
            code: null,
          },
          {
            name: "TIPTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "UNION",
            abbreviation: null,
            code: null,
          },
          {
            name: "VANDERBURGH",
            abbreviation: null,
            code: null,
          },
          {
            name: "VERMILLION",
            abbreviation: null,
            code: null,
          },
          {
            name: "VIGO",
            abbreviation: null,
            code: null,
          },
          {
            name: "WABASH",
            abbreviation: null,
            code: null,
          },
          {
            name: "WARREN",
            abbreviation: null,
            code: null,
          },
          {
            name: "WARRICK",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WAYNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WELLS",
            abbreviation: null,
            code: null,
          },
          {
            name: "WHITE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WHITLEY",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Kansas",
        abbreviation: "KS",
        counties: [
          {
            name: "ALLEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "ANDERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "ATCHISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "BARBER",
            abbreviation: null,
            code: null,
          },
          {
            name: "BARTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "BOURBON",
            abbreviation: null,
            code: null,
          },
          {
            name: "BROWN",
            abbreviation: null,
            code: null,
          },
          {
            name: "BUTLER",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHASE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHAUTAUQUA",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHEROKEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHEYENNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLARK",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLOUD",
            abbreviation: null,
            code: null,
          },
          {
            name: "COFFEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "COMANCHE",
            abbreviation: null,
            code: null,
          },
          {
            name: "COWLEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CRAWFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "DECATUR",
            abbreviation: null,
            code: null,
          },
          {
            name: "DICKINSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "DONIPHAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "DOUGLAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "EDWARDS",
            abbreviation: null,
            code: null,
          },
          {
            name: "ELK",
            abbreviation: null,
            code: null,
          },
          {
            name: "ELLIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "ELLSWORTH",
            abbreviation: null,
            code: null,
          },
          {
            name: "FINNEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "FORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRANKLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "GEARY",
            abbreviation: null,
            code: null,
          },
          {
            name: "GOVE",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRAHAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRANT",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREELEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREENWOOD",
            abbreviation: null,
            code: null,
          },
          {
            name: "HAMILTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARPER",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARVEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "HASKELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "HODGEMAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "JACKSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEWELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "JOHNSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "KEARNY",
            abbreviation: null,
            code: null,
          },
          {
            name: "KINGMAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "KIOWA",
            abbreviation: null,
            code: null,
          },
          {
            name: "LABETTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LANE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEAVENWORTH",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINCOLN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LOGAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LYON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARION",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARSHALL",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCPHERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MEADE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MIAMI",
            abbreviation: null,
            code: null,
          },
          {
            name: "MITCHELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONTGOMERY",
            abbreviation: null,
            code: null,
          },
          {
            name: "MORRIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "MORTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "NEMAHA",
            abbreviation: null,
            code: null,
          },
          {
            name: "NEOSHO",
            abbreviation: null,
            code: null,
          },
          {
            name: "NESS",
            abbreviation: null,
            code: null,
          },
          {
            name: "NORTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "OSAGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "OSBORNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "OTTAWA",
            abbreviation: null,
            code: null,
          },
          {
            name: "PAWNEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PHILLIPS",
            abbreviation: null,
            code: null,
          },
          {
            name: "POTTAWATOMIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PRATT",
            abbreviation: null,
            code: null,
          },
          {
            name: "RAWLINS",
            abbreviation: null,
            code: null,
          },
          {
            name: "RENO",
            abbreviation: null,
            code: null,
          },
          {
            name: "REPUBLIC",
            abbreviation: null,
            code: null,
          },
          {
            name: "RICE",
            abbreviation: null,
            code: null,
          },
          {
            name: "RILEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROOKS",
            abbreviation: null,
            code: null,
          },
          {
            name: "RUSH",
            abbreviation: null,
            code: null,
          },
          {
            name: "RUSSELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "SALINE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SCOTT",
            abbreviation: null,
            code: null,
          },
          {
            name: "SEDGWICK",
            abbreviation: null,
            code: null,
          },
          {
            name: "SEWARD",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHAWNEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHERIDAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHERMAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "SMITH",
            abbreviation: null,
            code: null,
          },
          {
            name: "STAFFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "STANTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "STEVENS",
            abbreviation: null,
            code: null,
          },
          {
            name: "SUMNER",
            abbreviation: null,
            code: null,
          },
          {
            name: "THOMAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "TREGO",
            abbreviation: null,
            code: null,
          },
          {
            name: "WABAUNSEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WALLACE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WICHITA",
            abbreviation: null,
            code: null,
          },
          {
            name: "WILSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WOODSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WYANDOTTE",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Kentucky",
        abbreviation: "KY",
        counties: [
          {
            name: "ADAIR",
            abbreviation: null,
            code: null,
          },
          {
            name: "ALLEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "ANDERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "BALLARD",
            abbreviation: null,
            code: null,
          },
          {
            name: "BARREN",
            abbreviation: null,
            code: null,
          },
          {
            name: "BATH",
            abbreviation: null,
            code: null,
          },
          {
            name: "BELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "BOONE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BOURBON",
            abbreviation: null,
            code: null,
          },
          {
            name: "BOYD",
            abbreviation: null,
            code: null,
          },
          {
            name: "BOYLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BRACKEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "BREATHITT",
            abbreviation: null,
            code: null,
          },
          {
            name: "BRECKINRIDGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BULLITT",
            abbreviation: null,
            code: null,
          },
          {
            name: "BUTLER",
            abbreviation: null,
            code: null,
          },
          {
            name: "CALDWELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "CALLOWAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CAMPBELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARLISLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARROLL",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "CASEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHRISTIAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLARK",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLINTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CRITTENDEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CUMBERLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "DAVIESS",
            abbreviation: null,
            code: null,
          },
          {
            name: "EDMONSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "ELLIOTT",
            abbreviation: null,
            code: null,
          },
          {
            name: "ESTILL",
            abbreviation: null,
            code: null,
          },
          {
            name: "FAYETTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "FLEMING",
            abbreviation: null,
            code: null,
          },
          {
            name: "FLOYD",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRANKLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "FULTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "GALLATIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "GARRARD",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRANT",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRAVES",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRAYSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREENUP",
            abbreviation: null,
            code: null,
          },
          {
            name: "HANCOCK",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARDIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARLAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARRISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HART",
            abbreviation: null,
            code: null,
          },
          {
            name: "HENDERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HENRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "HICKMAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOPKINS",
            abbreviation: null,
            code: null,
          },
          {
            name: "JACKSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JESSAMINE",
            abbreviation: null,
            code: null,
          },
          {
            name: "JOHNSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "KENTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "KNOTT",
            abbreviation: null,
            code: null,
          },
          {
            name: "KNOX",
            abbreviation: null,
            code: null,
          },
          {
            name: "LARUE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAUREL",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAWRENCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LESLIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LETCHER",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEWIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINCOLN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LIVINGSTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "LOGAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LYON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MADISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MAGOFFIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARION",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARSHALL",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARTIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MASON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCCRACKEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCCREARY",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCLEAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MEADE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MENIFEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MERCER",
            abbreviation: null,
            code: null,
          },
          {
            name: "METCALFE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONROE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONTGOMERY",
            abbreviation: null,
            code: null,
          },
          {
            name: "MORGAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MUHLENBERG",
            abbreviation: null,
            code: null,
          },
          {
            name: "NELSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "NICHOLAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "OHIO",
            abbreviation: null,
            code: null,
          },
          {
            name: "OLDHAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "OWEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "OWSLEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "PENDLETON",
            abbreviation: null,
            code: null,
          },
          {
            name: "PERRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "PIKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "POWELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "PULASKI",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROBERTSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROCKCASTLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROWAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "RUSSELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "SCOTT",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHELBY",
            abbreviation: null,
            code: null,
          },
          {
            name: "SIMPSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "SPENCER",
            abbreviation: null,
            code: null,
          },
          {
            name: "TAYLOR",
            abbreviation: null,
            code: null,
          },
          {
            name: "TODD",
            abbreviation: null,
            code: null,
          },
          {
            name: "TRIGG",
            abbreviation: null,
            code: null,
          },
          {
            name: "TRIMBLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "UNION",
            abbreviation: null,
            code: null,
          },
          {
            name: "WARREN",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WAYNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WEBSTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "WHITLEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "WOLFE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WOODFORD",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Louisiana",
        abbreviation: "LA",
        counties: [
          {
            name: "ACADIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "ALLEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "ASCENSION",
            abbreviation: null,
            code: null,
          },
          {
            name: "ASSUMPTION",
            abbreviation: null,
            code: null,
          },
          {
            name: "AVOYELLES",
            abbreviation: null,
            code: null,
          },
          {
            name: "BEAUREGARD",
            abbreviation: null,
            code: null,
          },
          {
            name: "BIENVILLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BOSSIER",
            abbreviation: null,
            code: null,
          },
          {
            name: "CADDO",
            abbreviation: null,
            code: null,
          },
          {
            name: "CALCASIEU",
            abbreviation: null,
            code: null,
          },
          {
            name: "CALDWELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "CAMERON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CATAHOULA",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLAIBORNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CONCORDIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "DE SOTO",
            abbreviation: null,
            code: null,
          },
          {
            name: "EAST BATON ROUGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "EAST CARROLL",
            abbreviation: null,
            code: null,
          },
          {
            name: "EAST FELICIANA",
            abbreviation: null,
            code: null,
          },
          {
            name: "EVANGELINE",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRANKLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRANT",
            abbreviation: null,
            code: null,
          },
          {
            name: "IBERIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "IBERVILLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "JACKSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON DAVIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAFAYETTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAFOURCHE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LASALLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINCOLN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LIVINGSTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MADISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MOREHOUSE",
            abbreviation: null,
            code: null,
          },
          {
            name: "NATCHITOCHES",
            abbreviation: null,
            code: null,
          },
          {
            name: "ORLEANS",
            abbreviation: null,
            code: null,
          },
          {
            name: "OUACHITA",
            abbreviation: null,
            code: null,
          },
          {
            name: "PLAQUEMINES",
            abbreviation: null,
            code: null,
          },
          {
            name: "POINTE COUPEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "RAPIDES",
            abbreviation: null,
            code: null,
          },
          {
            name: "RED RIVER",
            abbreviation: null,
            code: null,
          },
          {
            name: "RICHLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "SABINE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ST BERNARD",
            abbreviation: null,
            code: null,
          },
          {
            name: "ST CHARLES",
            abbreviation: null,
            code: null,
          },
          {
            name: "ST HELENA",
            abbreviation: null,
            code: null,
          },
          {
            name: "ST JAMES",
            abbreviation: null,
            code: null,
          },
          {
            name: "ST JOHN THE BAPTIST",
            abbreviation: null,
            code: null,
          },
          {
            name: "ST LANDRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "ST MARTIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "ST MARY",
            abbreviation: null,
            code: null,
          },
          {
            name: "ST TAMMANY",
            abbreviation: null,
            code: null,
          },
          {
            name: "TANGIPAHOA",
            abbreviation: null,
            code: null,
          },
          {
            name: "TENSAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "TERREBONNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "UNION",
            abbreviation: null,
            code: null,
          },
          {
            name: "VERMILION",
            abbreviation: null,
            code: null,
          },
          {
            name: "VERNON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WEBSTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "WEST BATON ROUGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WEST CARROLL",
            abbreviation: null,
            code: null,
          },
          {
            name: "WEST FELICIANA",
            abbreviation: null,
            code: null,
          },
          {
            name: "WINN",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Massachusetts",
        abbreviation: "MA",
        counties: [
          {
            name: "BARNSTABLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BERKSHIRE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BRISTOL",
            abbreviation: null,
            code: null,
          },
          {
            name: "DUKES",
            abbreviation: null,
            code: null,
          },
          {
            name: "ESSEX",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRANKLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "HAMPDEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "HAMPSHIRE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MIDDLESEX",
            abbreviation: null,
            code: null,
          },
          {
            name: "NANTUCKET",
            abbreviation: null,
            code: null,
          },
          {
            name: "NORFOLK",
            abbreviation: null,
            code: null,
          },
          {
            name: "PLYMOUTH",
            abbreviation: null,
            code: null,
          },
          {
            name: "SUFFOLK",
            abbreviation: null,
            code: null,
          },
          {
            name: "WORCESTER",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Maryland",
        abbreviation: "MD",
        counties: [
          {
            name: "ALLEGANY",
            abbreviation: null,
            code: null,
          },
          {
            name: "ANNE ARUNDEL",
            abbreviation: null,
            code: null,
          },
          {
            name: "BALTIMORE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BALTIMORE CITY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CALVERT",
            abbreviation: null,
            code: null,
          },
          {
            name: "CAROLINE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARROLL",
            abbreviation: null,
            code: null,
          },
          {
            name: "CECIL",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHARLES",
            abbreviation: null,
            code: null,
          },
          {
            name: "DORCHESTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "FREDERICK",
            abbreviation: null,
            code: null,
          },
          {
            name: "GARRETT",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOWARD",
            abbreviation: null,
            code: null,
          },
          {
            name: "KENT",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONTGOMERY",
            abbreviation: null,
            code: null,
          },
          {
            name: "PRINCE GEORGE'S",
            abbreviation: null,
            code: null,
          },
          {
            name: "QUEEN ANNE'S",
            abbreviation: null,
            code: null,
          },
          {
            name: "SOMERSET",
            abbreviation: null,
            code: null,
          },
          {
            name: "ST MARY'S",
            abbreviation: null,
            code: null,
          },
          {
            name: "TALBOT",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WICOMICO",
            abbreviation: null,
            code: null,
          },
          {
            name: "WORCESTER",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Maine",
        abbreviation: "ME",
        counties: [
          {
            name: "ANDROSCOGGIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "AROOSTOOK",
            abbreviation: null,
            code: null,
          },
          {
            name: "CUMBERLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRANKLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "HANCOCK",
            abbreviation: null,
            code: null,
          },
          {
            name: "KENNEBEC",
            abbreviation: null,
            code: null,
          },
          {
            name: "KNOX",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINCOLN",
            abbreviation: null,
            code: null,
          },
          {
            name: "OXFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "PENOBSCOT",
            abbreviation: null,
            code: null,
          },
          {
            name: "PISCATAQUIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "SAGADAHOC",
            abbreviation: null,
            code: null,
          },
          {
            name: "SOMERSET",
            abbreviation: null,
            code: null,
          },
          {
            name: "WALDO",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "YORK",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Michigan",
        abbreviation: "MI",
        counties: [
          {
            name: "ALCONA",
            abbreviation: null,
            code: null,
          },
          {
            name: "ALGER",
            abbreviation: null,
            code: null,
          },
          {
            name: "ALLEGAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "ALPENA",
            abbreviation: null,
            code: null,
          },
          {
            name: "ANTRIM",
            abbreviation: null,
            code: null,
          },
          {
            name: "ARENAC",
            abbreviation: null,
            code: null,
          },
          {
            name: "BARAGA",
            abbreviation: null,
            code: null,
          },
          {
            name: "BARRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "BAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "BENZIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BERRIEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "BRANCH",
            abbreviation: null,
            code: null,
          },
          {
            name: "CALHOUN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CASS",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHARLEVOIX",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHEBOYGAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHIPPEWA",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLARE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLINTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CRAWFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "DELTA",
            abbreviation: null,
            code: null,
          },
          {
            name: "DICKINSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "EATON",
            abbreviation: null,
            code: null,
          },
          {
            name: "EMMET",
            abbreviation: null,
            code: null,
          },
          {
            name: "GENESEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "GLADWIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "GOGEBIC",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRAND TRAVERSE",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRATIOT",
            abbreviation: null,
            code: null,
          },
          {
            name: "HILLSDALE",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOUGHTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HURON",
            abbreviation: null,
            code: null,
          },
          {
            name: "INGHAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "IONIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "IOSCO",
            abbreviation: null,
            code: null,
          },
          {
            name: "IRON",
            abbreviation: null,
            code: null,
          },
          {
            name: "ISABELLA",
            abbreviation: null,
            code: null,
          },
          {
            name: "JACKSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "KALAMAZOO",
            abbreviation: null,
            code: null,
          },
          {
            name: "KALKASKA",
            abbreviation: null,
            code: null,
          },
          {
            name: "KENT",
            abbreviation: null,
            code: null,
          },
          {
            name: "KEWEENAW",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAPEER",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEELANAU",
            abbreviation: null,
            code: null,
          },
          {
            name: "LENAWEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LIVINGSTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "LUCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MACKINAC",
            abbreviation: null,
            code: null,
          },
          {
            name: "MACOMB",
            abbreviation: null,
            code: null,
          },
          {
            name: "MANISTEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARQUETTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MASON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MECOSTA",
            abbreviation: null,
            code: null,
          },
          {
            name: "MENOMINEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MIDLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "MISSAUKEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONROE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONTCALM",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONTMORENCY",
            abbreviation: null,
            code: null,
          },
          {
            name: "MUSKEGON",
            abbreviation: null,
            code: null,
          },
          {
            name: "NEWAYGO",
            abbreviation: null,
            code: null,
          },
          {
            name: "OAKLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "OCEANA",
            abbreviation: null,
            code: null,
          },
          {
            name: "OGEMAW",
            abbreviation: null,
            code: null,
          },
          {
            name: "ONTONAGON",
            abbreviation: null,
            code: null,
          },
          {
            name: "OSCEOLA",
            abbreviation: null,
            code: null,
          },
          {
            name: "OSCODA",
            abbreviation: null,
            code: null,
          },
          {
            name: "OTSEGO",
            abbreviation: null,
            code: null,
          },
          {
            name: "OTTAWA",
            abbreviation: null,
            code: null,
          },
          {
            name: "PRESQUE ISLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROSCOMMON",
            abbreviation: null,
            code: null,
          },
          {
            name: "SAGINAW",
            abbreviation: null,
            code: null,
          },
          {
            name: "SANILAC",
            abbreviation: null,
            code: null,
          },
          {
            name: "SCHOOLCRAFT",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHIAWASSEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ST CLAIR",
            abbreviation: null,
            code: null,
          },
          {
            name: "ST JOSEPH",
            abbreviation: null,
            code: null,
          },
          {
            name: "TUSCOLA",
            abbreviation: null,
            code: null,
          },
          {
            name: "VAN BUREN",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHTENAW",
            abbreviation: null,
            code: null,
          },
          {
            name: "WAYNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WEXFORD",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Minnesota",
        abbreviation: "MN",
        counties: [
          {
            name: "AITKIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "ANOKA",
            abbreviation: null,
            code: null,
          },
          {
            name: "BECKER",
            abbreviation: null,
            code: null,
          },
          {
            name: "BELTRAMI",
            abbreviation: null,
            code: null,
          },
          {
            name: "BENTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "BIG STONE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BLUE EARTH",
            abbreviation: null,
            code: null,
          },
          {
            name: "BROWN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARLTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARVER",
            abbreviation: null,
            code: null,
          },
          {
            name: "CASS",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHIPPEWA",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHISAGO",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLEARWATER",
            abbreviation: null,
            code: null,
          },
          {
            name: "COOK",
            abbreviation: null,
            code: null,
          },
          {
            name: "COTTONWOOD",
            abbreviation: null,
            code: null,
          },
          {
            name: "CROW WING",
            abbreviation: null,
            code: null,
          },
          {
            name: "DAKOTA",
            abbreviation: null,
            code: null,
          },
          {
            name: "DODGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "DOUGLAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "FARIBAULT",
            abbreviation: null,
            code: null,
          },
          {
            name: "FILLMORE",
            abbreviation: null,
            code: null,
          },
          {
            name: "FREEBORN",
            abbreviation: null,
            code: null,
          },
          {
            name: "GOODHUE",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRANT",
            abbreviation: null,
            code: null,
          },
          {
            name: "HENNEPIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOUSTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HUBBARD",
            abbreviation: null,
            code: null,
          },
          {
            name: "ISANTI",
            abbreviation: null,
            code: null,
          },
          {
            name: "ITASCA",
            abbreviation: null,
            code: null,
          },
          {
            name: "JACKSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "KANABEC",
            abbreviation: null,
            code: null,
          },
          {
            name: "KANDIYOHI",
            abbreviation: null,
            code: null,
          },
          {
            name: "KITTSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "KOOCHICHING",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAC QUI PARLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAKE OF THE WOODS",
            abbreviation: null,
            code: null,
          },
          {
            name: "LE SUEUR",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINCOLN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LYON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MAHNOMEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARSHALL",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARTIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCLEOD",
            abbreviation: null,
            code: null,
          },
          {
            name: "MEEKER",
            abbreviation: null,
            code: null,
          },
          {
            name: "MILLE LACS",
            abbreviation: null,
            code: null,
          },
          {
            name: "MORRISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MOWER",
            abbreviation: null,
            code: null,
          },
          {
            name: "MURRAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "NICOLLET",
            abbreviation: null,
            code: null,
          },
          {
            name: "NOBLES",
            abbreviation: null,
            code: null,
          },
          {
            name: "NORMAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "OLMSTED",
            abbreviation: null,
            code: null,
          },
          {
            name: "OTTER TAIL",
            abbreviation: null,
            code: null,
          },
          {
            name: "PENNINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "PINE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PIPESTONE",
            abbreviation: null,
            code: null,
          },
          {
            name: "POLK",
            abbreviation: null,
            code: null,
          },
          {
            name: "POPE",
            abbreviation: null,
            code: null,
          },
          {
            name: "RAMSEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "RED LAKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "REDWOOD",
            abbreviation: null,
            code: null,
          },
          {
            name: "RENVILLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "RICE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROCK",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROSEAU",
            abbreviation: null,
            code: null,
          },
          {
            name: "SCOTT",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHERBURNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SIBLEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "ST LOUIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "STEARNS",
            abbreviation: null,
            code: null,
          },
          {
            name: "STEELE",
            abbreviation: null,
            code: null,
          },
          {
            name: "STEVENS",
            abbreviation: null,
            code: null,
          },
          {
            name: "SWIFT",
            abbreviation: null,
            code: null,
          },
          {
            name: "TODD",
            abbreviation: null,
            code: null,
          },
          {
            name: "TRAVERSE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WABASHA",
            abbreviation: null,
            code: null,
          },
          {
            name: "WADENA",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASECA",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WATONWAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "WILKIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "WINONA",
            abbreviation: null,
            code: null,
          },
          {
            name: "WRIGHT",
            abbreviation: null,
            code: null,
          },
          {
            name: "YELLOW MEDICINE",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Missouri",
        abbreviation: "MO",
        counties: [
          {
            name: "ADAIR",
            abbreviation: null,
            code: null,
          },
          {
            name: "ANDREW",
            abbreviation: null,
            code: null,
          },
          {
            name: "ATCHISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "AUDRAIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "BARRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "BARTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "BATES",
            abbreviation: null,
            code: null,
          },
          {
            name: "BENTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "BOLLINGER",
            abbreviation: null,
            code: null,
          },
          {
            name: "BOONE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BUCHANAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "BUTLER",
            abbreviation: null,
            code: null,
          },
          {
            name: "CALDWELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "CALLAWAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CAMDEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CAPE GIRARDEAU",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARROLL",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "CASS",
            abbreviation: null,
            code: null,
          },
          {
            name: "CEDAR",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHARITON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHRISTIAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLARK",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLINTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "COLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "COOPER",
            abbreviation: null,
            code: null,
          },
          {
            name: "CRAWFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "DADE",
            abbreviation: null,
            code: null,
          },
          {
            name: "DALLAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "DAVIESS",
            abbreviation: null,
            code: null,
          },
          {
            name: "DEKALB",
            abbreviation: null,
            code: null,
          },
          {
            name: "DENT",
            abbreviation: null,
            code: null,
          },
          {
            name: "DOUGLAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "DUNKLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRANKLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "GASCONADE",
            abbreviation: null,
            code: null,
          },
          {
            name: "GENTRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREENE",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRUNDY",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARRISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HENRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "HICKORY",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOLT",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOWARD",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOWELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "IRON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JACKSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JASPER",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JOHNSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "KNOX",
            abbreviation: null,
            code: null,
          },
          {
            name: "LACLEDE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAFAYETTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAWRENCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEWIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINCOLN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LIVINGSTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MACON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MADISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARIES",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARION",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCDONALD",
            abbreviation: null,
            code: null,
          },
          {
            name: "MERCER",
            abbreviation: null,
            code: null,
          },
          {
            name: "MILLER",
            abbreviation: null,
            code: null,
          },
          {
            name: "MISSISSIPPI",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONITEAU",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONROE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONTGOMERY",
            abbreviation: null,
            code: null,
          },
          {
            name: "MORGAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "NEW MADRID",
            abbreviation: null,
            code: null,
          },
          {
            name: "NEWTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "NODAWAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "OREGON",
            abbreviation: null,
            code: null,
          },
          {
            name: "OSAGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "OZARK",
            abbreviation: null,
            code: null,
          },
          {
            name: "PEMISCOT",
            abbreviation: null,
            code: null,
          },
          {
            name: "PERRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "PETTIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "PHELPS",
            abbreviation: null,
            code: null,
          },
          {
            name: "PIKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PLATTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "POLK",
            abbreviation: null,
            code: null,
          },
          {
            name: "PULASKI",
            abbreviation: null,
            code: null,
          },
          {
            name: "PUTNAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "RALLS",
            abbreviation: null,
            code: null,
          },
          {
            name: "RANDOLPH",
            abbreviation: null,
            code: null,
          },
          {
            name: "RAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "REYNOLDS",
            abbreviation: null,
            code: null,
          },
          {
            name: "RIPLEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "SALINE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SCHUYLER",
            abbreviation: null,
            code: null,
          },
          {
            name: "SCOTLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "SCOTT",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHANNON",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHELBY",
            abbreviation: null,
            code: null,
          },
          {
            name: "ST CHARLES",
            abbreviation: null,
            code: null,
          },
          {
            name: "ST CLAIR",
            abbreviation: null,
            code: null,
          },
          {
            name: "ST FRANCOIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "ST LOUIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "ST LOUIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "STE GENEVIEVE",
            abbreviation: null,
            code: null,
          },
          {
            name: "STODDARD",
            abbreviation: null,
            code: null,
          },
          {
            name: "STONE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SULLIVAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "TANEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "TEXAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "VERNON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WARREN",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WAYNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WEBSTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "WORTH",
            abbreviation: null,
            code: null,
          },
          {
            name: "WRIGHT",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Mississippi",
        abbreviation: "MS",
        counties: [
          {
            name: "ADAMS",
            abbreviation: null,
            code: null,
          },
          {
            name: "ALCORN",
            abbreviation: null,
            code: null,
          },
          {
            name: "AMITE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ATTALA",
            abbreviation: null,
            code: null,
          },
          {
            name: "BENTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "BOLIVAR",
            abbreviation: null,
            code: null,
          },
          {
            name: "CALHOUN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARROLL",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHICKASAW",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHOCTAW",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLAIBORNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLARKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "COAHOMA",
            abbreviation: null,
            code: null,
          },
          {
            name: "COPIAH",
            abbreviation: null,
            code: null,
          },
          {
            name: "COVINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "DESOTO",
            abbreviation: null,
            code: null,
          },
          {
            name: "FORREST",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRANKLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "GEORGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREENE",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRENADA",
            abbreviation: null,
            code: null,
          },
          {
            name: "HANCOCK",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARRISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HINDS",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOLMES",
            abbreviation: null,
            code: null,
          },
          {
            name: "HUMPHREYS",
            abbreviation: null,
            code: null,
          },
          {
            name: "ISSAQUENA",
            abbreviation: null,
            code: null,
          },
          {
            name: "ITAWAMBA",
            abbreviation: null,
            code: null,
          },
          {
            name: "JACKSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JASPER",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON DAVIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "JONES",
            abbreviation: null,
            code: null,
          },
          {
            name: "KEMPER",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAFAYETTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAMAR",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAUDERDALE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAWRENCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEAKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEFLORE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINCOLN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LOWNDES",
            abbreviation: null,
            code: null,
          },
          {
            name: "MADISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARION",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARSHALL",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONROE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONTGOMERY",
            abbreviation: null,
            code: null,
          },
          {
            name: "NESHOBA",
            abbreviation: null,
            code: null,
          },
          {
            name: "NEWTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "NOXUBEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "OKTIBBEHA",
            abbreviation: null,
            code: null,
          },
          {
            name: "PANOLA",
            abbreviation: null,
            code: null,
          },
          {
            name: "PEARL RIVER",
            abbreviation: null,
            code: null,
          },
          {
            name: "PERRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "PIKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PONTOTOC",
            abbreviation: null,
            code: null,
          },
          {
            name: "PRENTISS",
            abbreviation: null,
            code: null,
          },
          {
            name: "QUITMAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "RANKIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "SCOTT",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHARKEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "SIMPSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "SMITH",
            abbreviation: null,
            code: null,
          },
          {
            name: "STONE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SUNFLOWER",
            abbreviation: null,
            code: null,
          },
          {
            name: "TALLAHATCHIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "TATE",
            abbreviation: null,
            code: null,
          },
          {
            name: "TIPPAH",
            abbreviation: null,
            code: null,
          },
          {
            name: "TISHOMINGO",
            abbreviation: null,
            code: null,
          },
          {
            name: "TUNICA",
            abbreviation: null,
            code: null,
          },
          {
            name: "UNION",
            abbreviation: null,
            code: null,
          },
          {
            name: "WALTHALL",
            abbreviation: null,
            code: null,
          },
          {
            name: "WARREN",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WAYNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WEBSTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "WILKINSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WINSTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "YALOBUSHA",
            abbreviation: null,
            code: null,
          },
          {
            name: "YAZOO",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Montana",
        abbreviation: "MT",
        counties: [
          {
            name: "BEAVERHEAD",
            abbreviation: null,
            code: null,
          },
          {
            name: "BIG HORN",
            abbreviation: null,
            code: null,
          },
          {
            name: "BLAINE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BROADWATER",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARBON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "CASCADE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHOUTEAU",
            abbreviation: null,
            code: null,
          },
          {
            name: "CUSTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "DANIELS",
            abbreviation: null,
            code: null,
          },
          {
            name: "DAWSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "DEER LODGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "FALLON",
            abbreviation: null,
            code: null,
          },
          {
            name: "FERGUS",
            abbreviation: null,
            code: null,
          },
          {
            name: "FLATHEAD",
            abbreviation: null,
            code: null,
          },
          {
            name: "GALLATIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "GARFIELD",
            abbreviation: null,
            code: null,
          },
          {
            name: "GLACIER",
            abbreviation: null,
            code: null,
          },
          {
            name: "GOLDEN VALLEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRANITE",
            abbreviation: null,
            code: null,
          },
          {
            name: "HILL",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JUDITH BASIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEWIS AND CLARK",
            abbreviation: null,
            code: null,
          },
          {
            name: "LIBERTY",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINCOLN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MADISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCCONE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MEAGHER",
            abbreviation: null,
            code: null,
          },
          {
            name: "MINERAL",
            abbreviation: null,
            code: null,
          },
          {
            name: "MISSOULA",
            abbreviation: null,
            code: null,
          },
          {
            name: "MUSSELSHELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "PARK",
            abbreviation: null,
            code: null,
          },
          {
            name: "PETROLEUM",
            abbreviation: null,
            code: null,
          },
          {
            name: "PHILLIPS",
            abbreviation: null,
            code: null,
          },
          {
            name: "PONDERA",
            abbreviation: null,
            code: null,
          },
          {
            name: "POWDER RIVER",
            abbreviation: null,
            code: null,
          },
          {
            name: "POWELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "PRAIRIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "RAVALLI",
            abbreviation: null,
            code: null,
          },
          {
            name: "RICHLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROOSEVELT",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROSEBUD",
            abbreviation: null,
            code: null,
          },
          {
            name: "SANDERS",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHERIDAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "SILVER BOW",
            abbreviation: null,
            code: null,
          },
          {
            name: "STILLWATER",
            abbreviation: null,
            code: null,
          },
          {
            name: "SWEET GRASS",
            abbreviation: null,
            code: null,
          },
          {
            name: "TETON",
            abbreviation: null,
            code: null,
          },
          {
            name: "TOOLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "TREASURE",
            abbreviation: null,
            code: null,
          },
          {
            name: "VALLEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "WHEATLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "WIBAUX",
            abbreviation: null,
            code: null,
          },
          {
            name: "YELLOWSTONE",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "North Carolina",
        abbreviation: "NC",
        counties: [
          {
            name: "ALAMANCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ALEXANDER",
            abbreviation: null,
            code: null,
          },
          {
            name: "ALLEGHANY",
            abbreviation: null,
            code: null,
          },
          {
            name: "ANSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "ASHE",
            abbreviation: null,
            code: null,
          },
          {
            name: "AVERY",
            abbreviation: null,
            code: null,
          },
          {
            name: "BEAUFORT",
            abbreviation: null,
            code: null,
          },
          {
            name: "BERTIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BLADEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "BRUNSWICK",
            abbreviation: null,
            code: null,
          },
          {
            name: "BUNCOMBE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BURKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CABARRUS",
            abbreviation: null,
            code: null,
          },
          {
            name: "CALDWELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "CAMDEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARTERET",
            abbreviation: null,
            code: null,
          },
          {
            name: "CASWELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "CATAWBA",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHATHAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHEROKEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHOWAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLEVELAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "COLUMBUS",
            abbreviation: null,
            code: null,
          },
          {
            name: "CRAVEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CUMBERLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "CURRITUCK",
            abbreviation: null,
            code: null,
          },
          {
            name: "DARE",
            abbreviation: null,
            code: null,
          },
          {
            name: "DAVIDSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "DAVIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "DUPLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "DURHAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "EDGECOMBE",
            abbreviation: null,
            code: null,
          },
          {
            name: "FORSYTH",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRANKLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "GASTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "GATES",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRAHAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRANVILLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREENE",
            abbreviation: null,
            code: null,
          },
          {
            name: "GUILFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "HALIFAX",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARNETT",
            abbreviation: null,
            code: null,
          },
          {
            name: "HAYWOOD",
            abbreviation: null,
            code: null,
          },
          {
            name: "HENDERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HERTFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "HYDE",
            abbreviation: null,
            code: null,
          },
          {
            name: "IREDELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "JACKSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JOHNSTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JONES",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LENOIR",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINCOLN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MACON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MADISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARTIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCDOWELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "MECKLENBURG",
            abbreviation: null,
            code: null,
          },
          {
            name: "MITCHELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONTGOMERY",
            abbreviation: null,
            code: null,
          },
          {
            name: "MOORE",
            abbreviation: null,
            code: null,
          },
          {
            name: "NASH",
            abbreviation: null,
            code: null,
          },
          {
            name: "NEW HANOVER",
            abbreviation: null,
            code: null,
          },
          {
            name: "NORTHAMPTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "ONSLOW",
            abbreviation: null,
            code: null,
          },
          {
            name: "ORANGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PAMLICO",
            abbreviation: null,
            code: null,
          },
          {
            name: "PASQUOTANK",
            abbreviation: null,
            code: null,
          },
          {
            name: "PENDER",
            abbreviation: null,
            code: null,
          },
          {
            name: "PERQUIMANS",
            abbreviation: null,
            code: null,
          },
          {
            name: "PERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "PITT",
            abbreviation: null,
            code: null,
          },
          {
            name: "POLK",
            abbreviation: null,
            code: null,
          },
          {
            name: "RANDOLPH",
            abbreviation: null,
            code: null,
          },
          {
            name: "RICHMOND",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROBESON",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROCKINGHAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROWAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "RUTHERFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "SAMPSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "SCOTLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "STANLY",
            abbreviation: null,
            code: null,
          },
          {
            name: "STOKES",
            abbreviation: null,
            code: null,
          },
          {
            name: "SURRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "SWAIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "TRANSYLVANIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "TYRRELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "UNION",
            abbreviation: null,
            code: null,
          },
          {
            name: "VANCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WAKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WARREN",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WATAUGA",
            abbreviation: null,
            code: null,
          },
          {
            name: "WAYNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WILKES",
            abbreviation: null,
            code: null,
          },
          {
            name: "WILSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "YADKIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "YANCEY",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "North Dakota",
        abbreviation: "ND",
        counties: [
          {
            name: "ADAMS",
            abbreviation: null,
            code: null,
          },
          {
            name: "BARNES",
            abbreviation: null,
            code: null,
          },
          {
            name: "BENSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "BILLINGS",
            abbreviation: null,
            code: null,
          },
          {
            name: "BOTTINEAU",
            abbreviation: null,
            code: null,
          },
          {
            name: "BOWMAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "BURKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BURLEIGH",
            abbreviation: null,
            code: null,
          },
          {
            name: "CASS",
            abbreviation: null,
            code: null,
          },
          {
            name: "CAVALIER",
            abbreviation: null,
            code: null,
          },
          {
            name: "DICKEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "DIVIDE",
            abbreviation: null,
            code: null,
          },
          {
            name: "DUNN",
            abbreviation: null,
            code: null,
          },
          {
            name: "EDDY",
            abbreviation: null,
            code: null,
          },
          {
            name: "EMMONS",
            abbreviation: null,
            code: null,
          },
          {
            name: "FOSTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "GOLDEN VALLEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRAND FORKS",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRANT",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRIGGS",
            abbreviation: null,
            code: null,
          },
          {
            name: "HETTINGER",
            abbreviation: null,
            code: null,
          },
          {
            name: "KIDDER",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAMOURE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LOGAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCHENRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCINTOSH",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCKENZIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCLEAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MERCER",
            abbreviation: null,
            code: null,
          },
          {
            name: "MORTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MOUNTRAIL",
            abbreviation: null,
            code: null,
          },
          {
            name: "NELSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "OLIVER",
            abbreviation: null,
            code: null,
          },
          {
            name: "PEMBINA",
            abbreviation: null,
            code: null,
          },
          {
            name: "PIERCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "RAMSEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "RANSOM",
            abbreviation: null,
            code: null,
          },
          {
            name: "RENVILLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "RICHLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROLETTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SARGENT",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHERIDAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "SIOUX",
            abbreviation: null,
            code: null,
          },
          {
            name: "SLOPE",
            abbreviation: null,
            code: null,
          },
          {
            name: "STARK",
            abbreviation: null,
            code: null,
          },
          {
            name: "STEELE",
            abbreviation: null,
            code: null,
          },
          {
            name: "STUTSMAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "TOWNER",
            abbreviation: null,
            code: null,
          },
          {
            name: "TRAILL",
            abbreviation: null,
            code: null,
          },
          {
            name: "WALSH",
            abbreviation: null,
            code: null,
          },
          {
            name: "WARD",
            abbreviation: null,
            code: null,
          },
          {
            name: "WELLS",
            abbreviation: null,
            code: null,
          },
          {
            name: "WILLIAMS",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Nebraska",
        abbreviation: "NE",
        counties: [
          {
            name: "ADAMS",
            abbreviation: null,
            code: null,
          },
          {
            name: "ANTELOPE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ARTHUR",
            abbreviation: null,
            code: null,
          },
          {
            name: "BANNER",
            abbreviation: null,
            code: null,
          },
          {
            name: "BLAINE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BOONE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BOX BUTTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BOYD",
            abbreviation: null,
            code: null,
          },
          {
            name: "BROWN",
            abbreviation: null,
            code: null,
          },
          {
            name: "BUFFALO",
            abbreviation: null,
            code: null,
          },
          {
            name: "BURT",
            abbreviation: null,
            code: null,
          },
          {
            name: "BUTLER",
            abbreviation: null,
            code: null,
          },
          {
            name: "CASS",
            abbreviation: null,
            code: null,
          },
          {
            name: "CEDAR",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHASE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHERRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHEYENNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "COLFAX",
            abbreviation: null,
            code: null,
          },
          {
            name: "CUMING",
            abbreviation: null,
            code: null,
          },
          {
            name: "CUSTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "DAKOTA",
            abbreviation: null,
            code: null,
          },
          {
            name: "DAWES",
            abbreviation: null,
            code: null,
          },
          {
            name: "DAWSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "DEUEL",
            abbreviation: null,
            code: null,
          },
          {
            name: "DIXON",
            abbreviation: null,
            code: null,
          },
          {
            name: "DODGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "DOUGLAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "DUNDY",
            abbreviation: null,
            code: null,
          },
          {
            name: "FILLMORE",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRANKLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRONTIER",
            abbreviation: null,
            code: null,
          },
          {
            name: "FURNAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "GAGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "GARDEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "GARFIELD",
            abbreviation: null,
            code: null,
          },
          {
            name: "GOSPER",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRANT",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREELEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "HALL",
            abbreviation: null,
            code: null,
          },
          {
            name: "HAMILTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARLAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "HAYES",
            abbreviation: null,
            code: null,
          },
          {
            name: "HITCHCOCK",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOLT",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOOKER",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOWARD",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JOHNSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "KEARNEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "KEITH",
            abbreviation: null,
            code: null,
          },
          {
            name: "KEYA PAHA",
            abbreviation: null,
            code: null,
          },
          {
            name: "KIMBALL",
            abbreviation: null,
            code: null,
          },
          {
            name: "KNOX",
            abbreviation: null,
            code: null,
          },
          {
            name: "LANCASTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINCOLN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LOGAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LOUP",
            abbreviation: null,
            code: null,
          },
          {
            name: "MADISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCPHERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MERRICK",
            abbreviation: null,
            code: null,
          },
          {
            name: "MORRILL",
            abbreviation: null,
            code: null,
          },
          {
            name: "NANCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "NEMAHA",
            abbreviation: null,
            code: null,
          },
          {
            name: "NUCKOLLS",
            abbreviation: null,
            code: null,
          },
          {
            name: "OTOE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PAWNEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PERKINS",
            abbreviation: null,
            code: null,
          },
          {
            name: "PHELPS",
            abbreviation: null,
            code: null,
          },
          {
            name: "PIERCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PLATTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "POLK",
            abbreviation: null,
            code: null,
          },
          {
            name: "RED WILLOW",
            abbreviation: null,
            code: null,
          },
          {
            name: "RICHARDSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROCK",
            abbreviation: null,
            code: null,
          },
          {
            name: "SALINE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SARPY",
            abbreviation: null,
            code: null,
          },
          {
            name: "SAUNDERS",
            abbreviation: null,
            code: null,
          },
          {
            name: "SCOTTS BLUFF",
            abbreviation: null,
            code: null,
          },
          {
            name: "SEWARD",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHERIDAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHERMAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "SIOUX",
            abbreviation: null,
            code: null,
          },
          {
            name: "STANTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "THAYER",
            abbreviation: null,
            code: null,
          },
          {
            name: "THOMAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "THURSTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "VALLEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WAYNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WEBSTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "WHEELER",
            abbreviation: null,
            code: null,
          },
          {
            name: "YORK",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "New Hampshire",
        abbreviation: "NH",
        counties: [
          {
            name: "BELKNAP",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARROLL",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHESHIRE",
            abbreviation: null,
            code: null,
          },
          {
            name: "COOS",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRAFTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HILLSBOROUGH",
            abbreviation: null,
            code: null,
          },
          {
            name: "MERRIMACK",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROCKINGHAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "STRAFFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "SULLIVAN",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "New Jersey",
        abbreviation: "NJ",
        counties: [
          {
            name: "ATLANTIC",
            abbreviation: null,
            code: null,
          },
          {
            name: "BERGEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "BURLINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CAMDEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CAPE MAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CUMBERLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "ESSEX",
            abbreviation: null,
            code: null,
          },
          {
            name: "GLOUCESTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "HUDSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HUNTERDON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MERCER",
            abbreviation: null,
            code: null,
          },
          {
            name: "MIDDLESEX",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONMOUTH",
            abbreviation: null,
            code: null,
          },
          {
            name: "MORRIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "OCEAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "PASSAIC",
            abbreviation: null,
            code: null,
          },
          {
            name: "SALEM",
            abbreviation: null,
            code: null,
          },
          {
            name: "SOMERSET",
            abbreviation: null,
            code: null,
          },
          {
            name: "SUSSEX",
            abbreviation: null,
            code: null,
          },
          {
            name: "UNION",
            abbreviation: null,
            code: null,
          },
          {
            name: "WARREN",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "New Mexico",
        abbreviation: "NM",
        counties: [
          {
            name: "BERNALILLO",
            abbreviation: null,
            code: null,
          },
          {
            name: "CATRON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHAVES",
            abbreviation: null,
            code: null,
          },
          {
            name: "CIBOLA",
            abbreviation: null,
            code: null,
          },
          {
            name: "COLFAX",
            abbreviation: null,
            code: null,
          },
          {
            name: "CURRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "DE BACA",
            abbreviation: null,
            code: null,
          },
          {
            name: "DONA ANA",
            abbreviation: null,
            code: null,
          },
          {
            name: "EDDY",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRANT",
            abbreviation: null,
            code: null,
          },
          {
            name: "GUADALUPE",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARDING",
            abbreviation: null,
            code: null,
          },
          {
            name: "HIDALGO",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEA",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINCOLN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LOS ALAMOS",
            abbreviation: null,
            code: null,
          },
          {
            name: "LUNA",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCKINLEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "MORA",
            abbreviation: null,
            code: null,
          },
          {
            name: "OTERO",
            abbreviation: null,
            code: null,
          },
          {
            name: "QUAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "RIO ARRIBA",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROOSEVELT",
            abbreviation: null,
            code: null,
          },
          {
            name: "SAN JUAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "SAN MIGUEL",
            abbreviation: null,
            code: null,
          },
          {
            name: "SANDOVAL",
            abbreviation: null,
            code: null,
          },
          {
            name: "SANTA FE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SIERRA",
            abbreviation: null,
            code: null,
          },
          {
            name: "SOCORRO",
            abbreviation: null,
            code: null,
          },
          {
            name: "TAOS",
            abbreviation: null,
            code: null,
          },
          {
            name: "TORRANCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "UNION",
            abbreviation: null,
            code: null,
          },
          {
            name: "VALENCIA",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Nevada",
        abbreviation: "NV",
        counties: [
          {
            name: "CARSON CITY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHURCHILL",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLARK",
            abbreviation: null,
            code: null,
          },
          {
            name: "DOUGLAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "ELKO",
            abbreviation: null,
            code: null,
          },
          {
            name: "ESMERALDA",
            abbreviation: null,
            code: null,
          },
          {
            name: "EUREKA",
            abbreviation: null,
            code: null,
          },
          {
            name: "HUMBOLDT",
            abbreviation: null,
            code: null,
          },
          {
            name: "LANDER",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINCOLN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LYON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MINERAL",
            abbreviation: null,
            code: null,
          },
          {
            name: "NYE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PERSHING",
            abbreviation: null,
            code: null,
          },
          {
            name: "STOREY",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHOE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WHITE PINE",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "New York",
        abbreviation: "NY",
        counties: [
          {
            name: "ALBANY",
            abbreviation: null,
            code: null,
          },
          {
            name: "ALLEGANY",
            abbreviation: null,
            code: null,
          },
          {
            name: "BRONX",
            abbreviation: null,
            code: null,
          },
          {
            name: "BROOME",
            abbreviation: null,
            code: null,
          },
          {
            name: "CATTARAUGUS",
            abbreviation: null,
            code: null,
          },
          {
            name: "CAYUGA",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHAUTAUQUA",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHEMUNG",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHENANGO",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLINTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "COLUMBIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "CORTLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "DELAWARE",
            abbreviation: null,
            code: null,
          },
          {
            name: "DUTCHESS",
            abbreviation: null,
            code: null,
          },
          {
            name: "ERIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ESSEX",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRANKLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "FULTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "GENESEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREENE",
            abbreviation: null,
            code: null,
          },
          {
            name: "HAMILTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HERKIMER",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "KINGS",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEWIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "LIVINGSTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MADISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONROE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONTGOMERY",
            abbreviation: null,
            code: null,
          },
          {
            name: "NASSAU",
            abbreviation: null,
            code: null,
          },
          {
            name: "NEW YORK",
            abbreviation: null,
            code: null,
          },
          {
            name: "NIAGARA",
            abbreviation: null,
            code: null,
          },
          {
            name: "ONEIDA",
            abbreviation: null,
            code: null,
          },
          {
            name: "ONONDAGA",
            abbreviation: null,
            code: null,
          },
          {
            name: "ONTARIO",
            abbreviation: null,
            code: null,
          },
          {
            name: "ORANGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ORLEANS",
            abbreviation: null,
            code: null,
          },
          {
            name: "OSWEGO",
            abbreviation: null,
            code: null,
          },
          {
            name: "OTSEGO",
            abbreviation: null,
            code: null,
          },
          {
            name: "PUTNAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "QUEENS",
            abbreviation: null,
            code: null,
          },
          {
            name: "RENSSELAER",
            abbreviation: null,
            code: null,
          },
          {
            name: "RICHMOND",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROCKLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "SARATOGA",
            abbreviation: null,
            code: null,
          },
          {
            name: "SCHENECTADY",
            abbreviation: null,
            code: null,
          },
          {
            name: "SCHOHARIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SCHUYLER",
            abbreviation: null,
            code: null,
          },
          {
            name: "SENECA",
            abbreviation: null,
            code: null,
          },
          {
            name: "ST LAWRENCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "STEUBEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "SUFFOLK",
            abbreviation: null,
            code: null,
          },
          {
            name: "SULLIVAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "TIOGA",
            abbreviation: null,
            code: null,
          },
          {
            name: "TOMPKINS",
            abbreviation: null,
            code: null,
          },
          {
            name: "ULSTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "WARREN",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WAYNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WESTCHESTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "WYOMING",
            abbreviation: null,
            code: null,
          },
          {
            name: "YATES",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Ohio",
        abbreviation: "OH",
        counties: [
          {
            name: "ADAMS",
            abbreviation: null,
            code: null,
          },
          {
            name: "ALLEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "ASHLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "ASHTABULA",
            abbreviation: null,
            code: null,
          },
          {
            name: "ATHENS",
            abbreviation: null,
            code: null,
          },
          {
            name: "AUGLAIZE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BELMONT",
            abbreviation: null,
            code: null,
          },
          {
            name: "BROWN",
            abbreviation: null,
            code: null,
          },
          {
            name: "BUTLER",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARROLL",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHAMPAIGN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLARK",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLERMONT",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLINTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "COLUMBIANA",
            abbreviation: null,
            code: null,
          },
          {
            name: "COSHOCTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CRAWFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "CUYAHOGA",
            abbreviation: null,
            code: null,
          },
          {
            name: "DARKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "DEFIANCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "DELAWARE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ERIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "FAIRFIELD",
            abbreviation: null,
            code: null,
          },
          {
            name: "FAYETTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRANKLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "FULTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "GALLIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "GEAUGA",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREENE",
            abbreviation: null,
            code: null,
          },
          {
            name: "GUERNSEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "HAMILTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HANCOCK",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARDIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARRISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HENRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "HIGHLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOCKING",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOLMES",
            abbreviation: null,
            code: null,
          },
          {
            name: "HURON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JACKSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "KNOX",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAWRENCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LICKING",
            abbreviation: null,
            code: null,
          },
          {
            name: "LOGAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LORAIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LUCAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "MADISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MAHONING",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARION",
            abbreviation: null,
            code: null,
          },
          {
            name: "MEDINA",
            abbreviation: null,
            code: null,
          },
          {
            name: "MEIGS",
            abbreviation: null,
            code: null,
          },
          {
            name: "MERCER",
            abbreviation: null,
            code: null,
          },
          {
            name: "MIAMI",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONROE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONTGOMERY",
            abbreviation: null,
            code: null,
          },
          {
            name: "MORGAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MORROW",
            abbreviation: null,
            code: null,
          },
          {
            name: "MUSKINGUM",
            abbreviation: null,
            code: null,
          },
          {
            name: "NOBLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "OTTAWA",
            abbreviation: null,
            code: null,
          },
          {
            name: "PAULDING",
            abbreviation: null,
            code: null,
          },
          {
            name: "PERRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "PICKAWAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "PIKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PORTAGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PREBLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PUTNAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "RICHLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROSS",
            abbreviation: null,
            code: null,
          },
          {
            name: "SANDUSKY",
            abbreviation: null,
            code: null,
          },
          {
            name: "SCIOTO",
            abbreviation: null,
            code: null,
          },
          {
            name: "SENECA",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHELBY",
            abbreviation: null,
            code: null,
          },
          {
            name: "STARK",
            abbreviation: null,
            code: null,
          },
          {
            name: "SUMMIT",
            abbreviation: null,
            code: null,
          },
          {
            name: "TRUMBULL",
            abbreviation: null,
            code: null,
          },
          {
            name: "TUSCARAWAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "UNION",
            abbreviation: null,
            code: null,
          },
          {
            name: "VAN WERT",
            abbreviation: null,
            code: null,
          },
          {
            name: "VINTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WARREN",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WAYNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WILLIAMS",
            abbreviation: null,
            code: null,
          },
          {
            name: "WOOD",
            abbreviation: null,
            code: null,
          },
          {
            name: "WYANDOT",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Oklahoma",
        abbreviation: "OK",
        counties: [
          {
            name: "ADAIR",
            abbreviation: null,
            code: null,
          },
          {
            name: "ALFALFA",
            abbreviation: null,
            code: null,
          },
          {
            name: "ATOKA",
            abbreviation: null,
            code: null,
          },
          {
            name: "BEAVER",
            abbreviation: null,
            code: null,
          },
          {
            name: "BECKHAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "BLAINE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BRYAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CADDO",
            abbreviation: null,
            code: null,
          },
          {
            name: "CANADIAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHEROKEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHOCTAW",
            abbreviation: null,
            code: null,
          },
          {
            name: "CIMARRON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLEVELAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "COAL",
            abbreviation: null,
            code: null,
          },
          {
            name: "COMANCHE",
            abbreviation: null,
            code: null,
          },
          {
            name: "COTTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CRAIG",
            abbreviation: null,
            code: null,
          },
          {
            name: "CREEK",
            abbreviation: null,
            code: null,
          },
          {
            name: "CUSTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "DELAWARE",
            abbreviation: null,
            code: null,
          },
          {
            name: "DEWEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "ELLIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "GARFIELD",
            abbreviation: null,
            code: null,
          },
          {
            name: "GARVIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRADY",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRANT",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREER",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARMON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARPER",
            abbreviation: null,
            code: null,
          },
          {
            name: "HASKELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "HUGHES",
            abbreviation: null,
            code: null,
          },
          {
            name: "JACKSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JOHNSTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "KAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "KINGFISHER",
            abbreviation: null,
            code: null,
          },
          {
            name: "KIOWA",
            abbreviation: null,
            code: null,
          },
          {
            name: "LATIMER",
            abbreviation: null,
            code: null,
          },
          {
            name: "LE FLORE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINCOLN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LOGAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LOVE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MAJOR",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARSHALL",
            abbreviation: null,
            code: null,
          },
          {
            name: "MAYES",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCCLAIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCCURTAIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCINTOSH",
            abbreviation: null,
            code: null,
          },
          {
            name: "MURRAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "MUSKOGEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "NOBLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "NOWATA",
            abbreviation: null,
            code: null,
          },
          {
            name: "OKFUSKEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "OKLAHOMA",
            abbreviation: null,
            code: null,
          },
          {
            name: "OKMULGEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "OSAGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "OTTAWA",
            abbreviation: null,
            code: null,
          },
          {
            name: "PAWNEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PAYNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PITTSBURG",
            abbreviation: null,
            code: null,
          },
          {
            name: "PONTOTOC",
            abbreviation: null,
            code: null,
          },
          {
            name: "POTTAWATOMIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PUSHMATAHA",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROGER MILLS",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROGERS",
            abbreviation: null,
            code: null,
          },
          {
            name: "SEMINOLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SEQUOYAH",
            abbreviation: null,
            code: null,
          },
          {
            name: "STEPHENS",
            abbreviation: null,
            code: null,
          },
          {
            name: "TEXAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "TILLMAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "TULSA",
            abbreviation: null,
            code: null,
          },
          {
            name: "WAGONER",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHITA",
            abbreviation: null,
            code: null,
          },
          {
            name: "WOODS",
            abbreviation: null,
            code: null,
          },
          {
            name: "WOODWARD",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Oregon",
        abbreviation: "OR",
        counties: [
          {
            name: "BAKER",
            abbreviation: null,
            code: null,
          },
          {
            name: "BENTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLACKAMAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLATSOP",
            abbreviation: null,
            code: null,
          },
          {
            name: "COLUMBIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "COOS",
            abbreviation: null,
            code: null,
          },
          {
            name: "CROOK",
            abbreviation: null,
            code: null,
          },
          {
            name: "CURRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "DESCHUTES",
            abbreviation: null,
            code: null,
          },
          {
            name: "DOUGLAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "GILLIAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRANT",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARNEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOOD RIVER",
            abbreviation: null,
            code: null,
          },
          {
            name: "JACKSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JOSEPHINE",
            abbreviation: null,
            code: null,
          },
          {
            name: "KLAMATH",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LANE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINCOLN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MALHEUR",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARION",
            abbreviation: null,
            code: null,
          },
          {
            name: "MORROW",
            abbreviation: null,
            code: null,
          },
          {
            name: "MULTNOMAH",
            abbreviation: null,
            code: null,
          },
          {
            name: "POLK",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHERMAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "TILLAMOOK",
            abbreviation: null,
            code: null,
          },
          {
            name: "UMATILLA",
            abbreviation: null,
            code: null,
          },
          {
            name: "UNION",
            abbreviation: null,
            code: null,
          },
          {
            name: "WALLOWA",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASCO",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WHEELER",
            abbreviation: null,
            code: null,
          },
          {
            name: "YAMHILL",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Pennsylvania",
        abbreviation: "PA",
        counties: [
          {
            name: "ADAMS",
            abbreviation: null,
            code: null,
          },
          {
            name: "ALLEGHENY",
            abbreviation: null,
            code: null,
          },
          {
            name: "ARMSTRONG",
            abbreviation: null,
            code: null,
          },
          {
            name: "BEAVER",
            abbreviation: null,
            code: null,
          },
          {
            name: "BEDFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "BERKS",
            abbreviation: null,
            code: null,
          },
          {
            name: "BLAIR",
            abbreviation: null,
            code: null,
          },
          {
            name: "BRADFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "BUCKS",
            abbreviation: null,
            code: null,
          },
          {
            name: "BUTLER",
            abbreviation: null,
            code: null,
          },
          {
            name: "CAMBRIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "CAMERON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARBON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CENTRE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHESTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLARION",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLEARFIELD",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLINTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "COLUMBIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "CRAWFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "CUMBERLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "DAUPHIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "DELAWARE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ELK",
            abbreviation: null,
            code: null,
          },
          {
            name: "ERIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "FAYETTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "FOREST",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRANKLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "FULTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREENE",
            abbreviation: null,
            code: null,
          },
          {
            name: "HUNTINGDON",
            abbreviation: null,
            code: null,
          },
          {
            name: "INDIANA",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JUNIATA",
            abbreviation: null,
            code: null,
          },
          {
            name: "LACKAWANNA",
            abbreviation: null,
            code: null,
          },
          {
            name: "LANCASTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAWRENCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEBANON",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEHIGH",
            abbreviation: null,
            code: null,
          },
          {
            name: "LUZERNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LYCOMING",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCKEAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MERCER",
            abbreviation: null,
            code: null,
          },
          {
            name: "MIFFLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONROE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONTGOMERY",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONTOUR",
            abbreviation: null,
            code: null,
          },
          {
            name: "NORTHAMPTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "NORTHUMBERLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "PERRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "PHILADELPHIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "PIKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "POTTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "SCHUYLKILL",
            abbreviation: null,
            code: null,
          },
          {
            name: "SNYDER",
            abbreviation: null,
            code: null,
          },
          {
            name: "SOMERSET",
            abbreviation: null,
            code: null,
          },
          {
            name: "SULLIVAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "SUSQUEHANNA",
            abbreviation: null,
            code: null,
          },
          {
            name: "TIOGA",
            abbreviation: null,
            code: null,
          },
          {
            name: "UNION",
            abbreviation: null,
            code: null,
          },
          {
            name: "VENANGO",
            abbreviation: null,
            code: null,
          },
          {
            name: "WARREN",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WAYNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WESTMORELAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "WYOMING",
            abbreviation: null,
            code: null,
          },
          {
            name: "YORK",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Rhode Island",
        abbreviation: "RI",
        counties: [
          {
            name: "BRISTOL",
            abbreviation: null,
            code: null,
          },
          {
            name: "KENT",
            abbreviation: null,
            code: null,
          },
          {
            name: "NEWPORT",
            abbreviation: null,
            code: null,
          },
          {
            name: "PROVIDENCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "South Carolina",
        abbreviation: "SC",
        counties: [
          {
            name: "ABBEVILLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "AIKEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "ALLENDALE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ANDERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "BAMBERG",
            abbreviation: null,
            code: null,
          },
          {
            name: "BARNWELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "BEAUFORT",
            abbreviation: null,
            code: null,
          },
          {
            name: "BERKELEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CALHOUN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHARLESTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHEROKEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHESTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHESTERFIELD",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLARENDON",
            abbreviation: null,
            code: null,
          },
          {
            name: "COLLETON",
            abbreviation: null,
            code: null,
          },
          {
            name: "DARLINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "DILLON",
            abbreviation: null,
            code: null,
          },
          {
            name: "DORCHESTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "EDGEFIELD",
            abbreviation: null,
            code: null,
          },
          {
            name: "FAIRFIELD",
            abbreviation: null,
            code: null,
          },
          {
            name: "FLORENCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "GEORGETOWN",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREENVILLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREENWOOD",
            abbreviation: null,
            code: null,
          },
          {
            name: "HAMPTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HORRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "JASPER",
            abbreviation: null,
            code: null,
          },
          {
            name: "KERSHAW",
            abbreviation: null,
            code: null,
          },
          {
            name: "LANCASTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAURENS",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEXINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARION",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARLBORO",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCCORMICK",
            abbreviation: null,
            code: null,
          },
          {
            name: "NEWBERRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "OCONEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ORANGEBURG",
            abbreviation: null,
            code: null,
          },
          {
            name: "PICKENS",
            abbreviation: null,
            code: null,
          },
          {
            name: "RICHLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "SALUDA",
            abbreviation: null,
            code: null,
          },
          {
            name: "SPARTANBURG",
            abbreviation: null,
            code: null,
          },
          {
            name: "SUMTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "UNION",
            abbreviation: null,
            code: null,
          },
          {
            name: "WILLIAMSBURG",
            abbreviation: null,
            code: null,
          },
          {
            name: "YORK",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "South Dakota",
        abbreviation: "SD",
        counties: [
          {
            name: "AURORA",
            abbreviation: null,
            code: null,
          },
          {
            name: "BEADLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BENNETT",
            abbreviation: null,
            code: null,
          },
          {
            name: "BON HOMME",
            abbreviation: null,
            code: null,
          },
          {
            name: "BROOKINGS",
            abbreviation: null,
            code: null,
          },
          {
            name: "BROWN",
            abbreviation: null,
            code: null,
          },
          {
            name: "BRULE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BUFFALO",
            abbreviation: null,
            code: null,
          },
          {
            name: "BUTTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CAMPBELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHARLES MIX",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLARK",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CODINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CORSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CUSTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "DAVISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "DAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "DEUEL",
            abbreviation: null,
            code: null,
          },
          {
            name: "DEWEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "DOUGLAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "EDMUNDS",
            abbreviation: null,
            code: null,
          },
          {
            name: "FALL RIVER",
            abbreviation: null,
            code: null,
          },
          {
            name: "FAULK",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRANT",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREGORY",
            abbreviation: null,
            code: null,
          },
          {
            name: "HAAKON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HAMLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "HAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "HANSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARDING",
            abbreviation: null,
            code: null,
          },
          {
            name: "HUGHES",
            abbreviation: null,
            code: null,
          },
          {
            name: "HUTCHINSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HYDE",
            abbreviation: null,
            code: null,
          },
          {
            name: "JACKSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JERAULD",
            abbreviation: null,
            code: null,
          },
          {
            name: "JONES",
            abbreviation: null,
            code: null,
          },
          {
            name: "KINGSBURY",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAWRENCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINCOLN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LYMAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARSHALL",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCCOOK",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCPHERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MEADE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MELLETTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MINER",
            abbreviation: null,
            code: null,
          },
          {
            name: "MINNEHAHA",
            abbreviation: null,
            code: null,
          },
          {
            name: "MOODY",
            abbreviation: null,
            code: null,
          },
          {
            name: "OGLALA LAKOTA",
            abbreviation: null,
            code: null,
          },
          {
            name: "PENNINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "PERKINS",
            abbreviation: null,
            code: null,
          },
          {
            name: "POTTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROBERTS",
            abbreviation: null,
            code: null,
          },
          {
            name: "SANBORN",
            abbreviation: null,
            code: null,
          },
          {
            name: "SPINK",
            abbreviation: null,
            code: null,
          },
          {
            name: "STANLEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "SULLY",
            abbreviation: null,
            code: null,
          },
          {
            name: "TODD",
            abbreviation: null,
            code: null,
          },
          {
            name: "TRIPP",
            abbreviation: null,
            code: null,
          },
          {
            name: "TURNER",
            abbreviation: null,
            code: null,
          },
          {
            name: "UNION",
            abbreviation: null,
            code: null,
          },
          {
            name: "WALWORTH",
            abbreviation: null,
            code: null,
          },
          {
            name: "YANKTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "ZIEBACH",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Tennessee",
        abbreviation: "TN",
        counties: [
          {
            name: "ANDERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "BEDFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "BENTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "BLEDSOE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BLOUNT",
            abbreviation: null,
            code: null,
          },
          {
            name: "BRADLEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CAMPBELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "CANNON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARROLL",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHEATHAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHESTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLAIBORNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "COCKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "COFFEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CROCKETT",
            abbreviation: null,
            code: null,
          },
          {
            name: "CUMBERLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "DAVIDSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "DECATUR",
            abbreviation: null,
            code: null,
          },
          {
            name: "DEKALB",
            abbreviation: null,
            code: null,
          },
          {
            name: "DICKSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "DYER",
            abbreviation: null,
            code: null,
          },
          {
            name: "FAYETTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "FENTRESS",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRANKLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "GIBSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "GILES",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRAINGER",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREENE",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRUNDY",
            abbreviation: null,
            code: null,
          },
          {
            name: "HAMBLEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "HAMILTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HANCOCK",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARDEMAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARDIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "HAWKINS",
            abbreviation: null,
            code: null,
          },
          {
            name: "HAYWOOD",
            abbreviation: null,
            code: null,
          },
          {
            name: "HENDERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HENRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "HICKMAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOUSTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HUMPHREYS",
            abbreviation: null,
            code: null,
          },
          {
            name: "JACKSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JOHNSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "KNOX",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAUDERDALE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAWRENCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEWIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINCOLN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LOUDON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MACON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MADISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARION",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARSHALL",
            abbreviation: null,
            code: null,
          },
          {
            name: "MAURY",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCMINN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCNAIRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "MEIGS",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONROE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONTGOMERY",
            abbreviation: null,
            code: null,
          },
          {
            name: "MOORE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MORGAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "OBION",
            abbreviation: null,
            code: null,
          },
          {
            name: "OVERTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "PERRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "PICKETT",
            abbreviation: null,
            code: null,
          },
          {
            name: "POLK",
            abbreviation: null,
            code: null,
          },
          {
            name: "PUTNAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "RHEA",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROANE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROBERTSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "RUTHERFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "SCOTT",
            abbreviation: null,
            code: null,
          },
          {
            name: "SEQUATCHIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SEVIER",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHELBY",
            abbreviation: null,
            code: null,
          },
          {
            name: "SMITH",
            abbreviation: null,
            code: null,
          },
          {
            name: "STEWART",
            abbreviation: null,
            code: null,
          },
          {
            name: "SULLIVAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "SUMNER",
            abbreviation: null,
            code: null,
          },
          {
            name: "TIPTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "TROUSDALE",
            abbreviation: null,
            code: null,
          },
          {
            name: "UNICOI",
            abbreviation: null,
            code: null,
          },
          {
            name: "UNION",
            abbreviation: null,
            code: null,
          },
          {
            name: "VAN BUREN",
            abbreviation: null,
            code: null,
          },
          {
            name: "WARREN",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WAYNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WEAKLEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "WHITE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WILLIAMSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WILSON",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Texas",
        abbreviation: "TX",
        counties: [
          {
            name: "ANDERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "ANDREWS",
            abbreviation: null,
            code: null,
          },
          {
            name: "ANGELINA",
            abbreviation: null,
            code: null,
          },
          {
            name: "ARANSAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "ARCHER",
            abbreviation: null,
            code: null,
          },
          {
            name: "ARMSTRONG",
            abbreviation: null,
            code: null,
          },
          {
            name: "ATASCOSA",
            abbreviation: null,
            code: null,
          },
          {
            name: "AUSTIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "BAILEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "BANDERA",
            abbreviation: null,
            code: null,
          },
          {
            name: "BASTROP",
            abbreviation: null,
            code: null,
          },
          {
            name: "BAYLOR",
            abbreviation: null,
            code: null,
          },
          {
            name: "BEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "BEXAR",
            abbreviation: null,
            code: null,
          },
          {
            name: "BLANCO",
            abbreviation: null,
            code: null,
          },
          {
            name: "BORDEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "BOSQUE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BOWIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BRAZORIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "BRAZOS",
            abbreviation: null,
            code: null,
          },
          {
            name: "BREWSTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "BRISCOE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BROOKS",
            abbreviation: null,
            code: null,
          },
          {
            name: "BROWN",
            abbreviation: null,
            code: null,
          },
          {
            name: "BURLESON",
            abbreviation: null,
            code: null,
          },
          {
            name: "BURNET",
            abbreviation: null,
            code: null,
          },
          {
            name: "CALDWELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "CALHOUN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CALLAHAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CAMERON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CAMP",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CASS",
            abbreviation: null,
            code: null,
          },
          {
            name: "CASTRO",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHAMBERS",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHEROKEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHILDRESS",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "COCHRAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "COKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "COLEMAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "COLLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "COLLINGSWORTH",
            abbreviation: null,
            code: null,
          },
          {
            name: "COLORADO",
            abbreviation: null,
            code: null,
          },
          {
            name: "COMAL",
            abbreviation: null,
            code: null,
          },
          {
            name: "COMANCHE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CONCHO",
            abbreviation: null,
            code: null,
          },
          {
            name: "COOKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CORYELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "COTTLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CRANE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CROCKETT",
            abbreviation: null,
            code: null,
          },
          {
            name: "CROSBY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CULBERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "DALLAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "DALLAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "DAWSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "DEAF SMITH",
            abbreviation: null,
            code: null,
          },
          {
            name: "DELTA",
            abbreviation: null,
            code: null,
          },
          {
            name: "DENTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "DEWITT",
            abbreviation: null,
            code: null,
          },
          {
            name: "DICKENS",
            abbreviation: null,
            code: null,
          },
          {
            name: "DIMMIT",
            abbreviation: null,
            code: null,
          },
          {
            name: "DONLEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "DUVAL",
            abbreviation: null,
            code: null,
          },
          {
            name: "EASTLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "ECTOR",
            abbreviation: null,
            code: null,
          },
          {
            name: "EDWARDS",
            abbreviation: null,
            code: null,
          },
          {
            name: "EL PASO",
            abbreviation: null,
            code: null,
          },
          {
            name: "ELLIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "ERATH",
            abbreviation: null,
            code: null,
          },
          {
            name: "FALLS",
            abbreviation: null,
            code: null,
          },
          {
            name: "FANNIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "FAYETTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "FISHER",
            abbreviation: null,
            code: null,
          },
          {
            name: "FLOYD",
            abbreviation: null,
            code: null,
          },
          {
            name: "FOARD",
            abbreviation: null,
            code: null,
          },
          {
            name: "FORT BEND",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRANKLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "FREESTONE",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRIO",
            abbreviation: null,
            code: null,
          },
          {
            name: "GAINES",
            abbreviation: null,
            code: null,
          },
          {
            name: "GALVESTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "GARZA",
            abbreviation: null,
            code: null,
          },
          {
            name: "GILLESPIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "GLASSCOCK",
            abbreviation: null,
            code: null,
          },
          {
            name: "GOLIAD",
            abbreviation: null,
            code: null,
          },
          {
            name: "GONZALES",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRAYSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREGG",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRIMES",
            abbreviation: null,
            code: null,
          },
          {
            name: "GUADALUPE",
            abbreviation: null,
            code: null,
          },
          {
            name: "HALE",
            abbreviation: null,
            code: null,
          },
          {
            name: "HALL",
            abbreviation: null,
            code: null,
          },
          {
            name: "HAMILTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HANSFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARDEMAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARDIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARRIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARRISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARTLEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "HASKELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "HAYS",
            abbreviation: null,
            code: null,
          },
          {
            name: "HEMPHILL",
            abbreviation: null,
            code: null,
          },
          {
            name: "HENDERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HIDALGO",
            abbreviation: null,
            code: null,
          },
          {
            name: "HILL",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOCKLEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOOD",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOPKINS",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOUSTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOWARD",
            abbreviation: null,
            code: null,
          },
          {
            name: "HUDSPETH",
            abbreviation: null,
            code: null,
          },
          {
            name: "HUNT",
            abbreviation: null,
            code: null,
          },
          {
            name: "HUTCHINSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "IRION",
            abbreviation: null,
            code: null,
          },
          {
            name: "JACK",
            abbreviation: null,
            code: null,
          },
          {
            name: "JACKSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JASPER",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFF DAVIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JIM HOGG",
            abbreviation: null,
            code: null,
          },
          {
            name: "JIM WELLS",
            abbreviation: null,
            code: null,
          },
          {
            name: "JOHNSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JONES",
            abbreviation: null,
            code: null,
          },
          {
            name: "KARNES",
            abbreviation: null,
            code: null,
          },
          {
            name: "KAUFMAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "KENDALL",
            abbreviation: null,
            code: null,
          },
          {
            name: "KENEDY",
            abbreviation: null,
            code: null,
          },
          {
            name: "KENT",
            abbreviation: null,
            code: null,
          },
          {
            name: "KERR",
            abbreviation: null,
            code: null,
          },
          {
            name: "KIMBLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "KING",
            abbreviation: null,
            code: null,
          },
          {
            name: "KINNEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "KLEBERG",
            abbreviation: null,
            code: null,
          },
          {
            name: "KNOX",
            abbreviation: null,
            code: null,
          },
          {
            name: "LA SALLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAMAR",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAMB",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAMPASAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAVACA",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEON",
            abbreviation: null,
            code: null,
          },
          {
            name: "LIBERTY",
            abbreviation: null,
            code: null,
          },
          {
            name: "LIMESTONE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LIPSCOMB",
            abbreviation: null,
            code: null,
          },
          {
            name: "LIVE OAK",
            abbreviation: null,
            code: null,
          },
          {
            name: "LLANO",
            abbreviation: null,
            code: null,
          },
          {
            name: "LOVING",
            abbreviation: null,
            code: null,
          },
          {
            name: "LUBBOCK",
            abbreviation: null,
            code: null,
          },
          {
            name: "LYNN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MADISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARION",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARTIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MASON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MATAGORDA",
            abbreviation: null,
            code: null,
          },
          {
            name: "MAVERICK",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCCULLOCH",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCLENNAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCMULLEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MEDINA",
            abbreviation: null,
            code: null,
          },
          {
            name: "MENARD",
            abbreviation: null,
            code: null,
          },
          {
            name: "MIDLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "MILAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "MILLS",
            abbreviation: null,
            code: null,
          },
          {
            name: "MITCHELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONTAGUE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONTGOMERY",
            abbreviation: null,
            code: null,
          },
          {
            name: "MOORE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MORRIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "MOTLEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "NACOGDOCHES",
            abbreviation: null,
            code: null,
          },
          {
            name: "NAVARRO",
            abbreviation: null,
            code: null,
          },
          {
            name: "NEWTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "NOLAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "NUECES",
            abbreviation: null,
            code: null,
          },
          {
            name: "OCHILTREE",
            abbreviation: null,
            code: null,
          },
          {
            name: "OLDHAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "ORANGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PALO PINTO",
            abbreviation: null,
            code: null,
          },
          {
            name: "PANOLA",
            abbreviation: null,
            code: null,
          },
          {
            name: "PARKER",
            abbreviation: null,
            code: null,
          },
          {
            name: "PARMER",
            abbreviation: null,
            code: null,
          },
          {
            name: "PECOS",
            abbreviation: null,
            code: null,
          },
          {
            name: "POLK",
            abbreviation: null,
            code: null,
          },
          {
            name: "POTTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "PRESIDIO",
            abbreviation: null,
            code: null,
          },
          {
            name: "RAINS",
            abbreviation: null,
            code: null,
          },
          {
            name: "RANDALL",
            abbreviation: null,
            code: null,
          },
          {
            name: "REAGAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "REAL",
            abbreviation: null,
            code: null,
          },
          {
            name: "RED RIVER",
            abbreviation: null,
            code: null,
          },
          {
            name: "REEVES",
            abbreviation: null,
            code: null,
          },
          {
            name: "REFUGIO",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROBERTS",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROBERTSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROCKWALL",
            abbreviation: null,
            code: null,
          },
          {
            name: "RUNNELS",
            abbreviation: null,
            code: null,
          },
          {
            name: "RUSK",
            abbreviation: null,
            code: null,
          },
          {
            name: "SABINE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SAN AUGUSTINE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SAN JACINTO",
            abbreviation: null,
            code: null,
          },
          {
            name: "SAN PATRICIO",
            abbreviation: null,
            code: null,
          },
          {
            name: "SAN SABA",
            abbreviation: null,
            code: null,
          },
          {
            name: "SCHLEICHER",
            abbreviation: null,
            code: null,
          },
          {
            name: "SCURRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHACKELFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHELBY",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHERMAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "SMITH",
            abbreviation: null,
            code: null,
          },
          {
            name: "SOMERVELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "STARR",
            abbreviation: null,
            code: null,
          },
          {
            name: "STEPHENS",
            abbreviation: null,
            code: null,
          },
          {
            name: "STERLING",
            abbreviation: null,
            code: null,
          },
          {
            name: "STONEWALL",
            abbreviation: null,
            code: null,
          },
          {
            name: "SUTTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "SWISHER",
            abbreviation: null,
            code: null,
          },
          {
            name: "TARRANT",
            abbreviation: null,
            code: null,
          },
          {
            name: "TAYLOR",
            abbreviation: null,
            code: null,
          },
          {
            name: "TERRELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "TERRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "THROCKMORTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "TITUS",
            abbreviation: null,
            code: null,
          },
          {
            name: "TOM GREEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "TRAVIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "TRINITY",
            abbreviation: null,
            code: null,
          },
          {
            name: "TYLER",
            abbreviation: null,
            code: null,
          },
          {
            name: "UPSHUR",
            abbreviation: null,
            code: null,
          },
          {
            name: "UPTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "UVALDE",
            abbreviation: null,
            code: null,
          },
          {
            name: "VAL VERDE",
            abbreviation: null,
            code: null,
          },
          {
            name: "VAN ZANDT",
            abbreviation: null,
            code: null,
          },
          {
            name: "VICTORIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "WALKER",
            abbreviation: null,
            code: null,
          },
          {
            name: "WALLER",
            abbreviation: null,
            code: null,
          },
          {
            name: "WARD",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WEBB",
            abbreviation: null,
            code: null,
          },
          {
            name: "WHARTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WHEELER",
            abbreviation: null,
            code: null,
          },
          {
            name: "WICHITA",
            abbreviation: null,
            code: null,
          },
          {
            name: "WILBARGER",
            abbreviation: null,
            code: null,
          },
          {
            name: "WILLACY",
            abbreviation: null,
            code: null,
          },
          {
            name: "WILLIAMSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WILSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WINKLER",
            abbreviation: null,
            code: null,
          },
          {
            name: "WISE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WOOD",
            abbreviation: null,
            code: null,
          },
          {
            name: "YOAKUM",
            abbreviation: null,
            code: null,
          },
          {
            name: "YOUNG",
            abbreviation: null,
            code: null,
          },
          {
            name: "ZAPATA",
            abbreviation: null,
            code: null,
          },
          {
            name: "ZAVALA",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Utah",
        abbreviation: "UT",
        counties: [
          {
            name: "BEAVER",
            abbreviation: null,
            code: null,
          },
          {
            name: "BOX ELDER",
            abbreviation: null,
            code: null,
          },
          {
            name: "CACHE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARBON",
            abbreviation: null,
            code: null,
          },
          {
            name: "DAGGETT",
            abbreviation: null,
            code: null,
          },
          {
            name: "DAVIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "DUCHESNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "EMERY",
            abbreviation: null,
            code: null,
          },
          {
            name: "GARFIELD",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "IRON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JUAB",
            abbreviation: null,
            code: null,
          },
          {
            name: "KANE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MILLARD",
            abbreviation: null,
            code: null,
          },
          {
            name: "MORGAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "PIUTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "RICH",
            abbreviation: null,
            code: null,
          },
          {
            name: "SALT LAKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SAN JUAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "SANPETE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SEVIER",
            abbreviation: null,
            code: null,
          },
          {
            name: "SUMMIT",
            abbreviation: null,
            code: null,
          },
          {
            name: "TOOELE",
            abbreviation: null,
            code: null,
          },
          {
            name: "UINTAH",
            abbreviation: null,
            code: null,
          },
          {
            name: "UTAH",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASATCH",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WAYNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WEBER",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Virginia",
        abbreviation: "VA",
        counties: [
          {
            name: "ACCOMACK",
            abbreviation: null,
            code: null,
          },
          {
            name: "ALBEMARLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ALEXANDRIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "ALLEGHANY",
            abbreviation: null,
            code: null,
          },
          {
            name: "AMELIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "AMHERST",
            abbreviation: null,
            code: null,
          },
          {
            name: "APPOMATTOX",
            abbreviation: null,
            code: null,
          },
          {
            name: "ARLINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "AUGUSTA",
            abbreviation: null,
            code: null,
          },
          {
            name: "BATH",
            abbreviation: null,
            code: null,
          },
          {
            name: "BEDFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "BLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "BOTETOURT",
            abbreviation: null,
            code: null,
          },
          {
            name: "BRISTOL",
            abbreviation: null,
            code: null,
          },
          {
            name: "BRUNSWICK",
            abbreviation: null,
            code: null,
          },
          {
            name: "BUCHANAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "BUCKINGHAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "BUENA VISTA",
            abbreviation: null,
            code: null,
          },
          {
            name: "CAMPBELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "CAROLINE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARROLL",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHARLES CITY",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHARLOTTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHARLOTTESVILLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHESAPEAKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHESTERFIELD",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLARKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "COLONIAL HEIGHTS",
            abbreviation: null,
            code: null,
          },
          {
            name: "COVINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CRAIG",
            abbreviation: null,
            code: null,
          },
          {
            name: "CULPEPER",
            abbreviation: null,
            code: null,
          },
          {
            name: "CUMBERLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "DANVILLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "DICKENSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "DINWIDDIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "EMPORIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "ESSEX",
            abbreviation: null,
            code: null,
          },
          {
            name: "FAIRFAX",
            abbreviation: null,
            code: null,
          },
          {
            name: "FAIRFAX",
            abbreviation: null,
            code: null,
          },
          {
            name: "FALLS CHURCH",
            abbreviation: null,
            code: null,
          },
          {
            name: "FAUQUIER",
            abbreviation: null,
            code: null,
          },
          {
            name: "FLOYD",
            abbreviation: null,
            code: null,
          },
          {
            name: "FLUVANNA",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRANKLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRANKLIN CITY",
            abbreviation: null,
            code: null,
          },
          {
            name: "FREDERICK",
            abbreviation: null,
            code: null,
          },
          {
            name: "FREDERICKSBURG",
            abbreviation: null,
            code: null,
          },
          {
            name: "GALAX",
            abbreviation: null,
            code: null,
          },
          {
            name: "GILES",
            abbreviation: null,
            code: null,
          },
          {
            name: "GLOUCESTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "GOOCHLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRAYSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREENE",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREENSVILLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "HALIFAX",
            abbreviation: null,
            code: null,
          },
          {
            name: "HAMPTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "HANOVER",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARRISONBURG",
            abbreviation: null,
            code: null,
          },
          {
            name: "HENRICO",
            abbreviation: null,
            code: null,
          },
          {
            name: "HENRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "HIGHLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOPEWELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "ISLE OF WIGHT",
            abbreviation: null,
            code: null,
          },
          {
            name: "JAMES CITY",
            abbreviation: null,
            code: null,
          },
          {
            name: "KING AND QUEEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "KING GEORGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "KING WILLIAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "LANCASTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEXINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "LOUDOUN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LOUISA",
            abbreviation: null,
            code: null,
          },
          {
            name: "LUNENBURG",
            abbreviation: null,
            code: null,
          },
          {
            name: "LYNCHBURG",
            abbreviation: null,
            code: null,
          },
          {
            name: "MADISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MANASSAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "MANASSAS PARK",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARTINSVILLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MATHEWS",
            abbreviation: null,
            code: null,
          },
          {
            name: "MECKLENBURG",
            abbreviation: null,
            code: null,
          },
          {
            name: "MIDDLESEX",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONTGOMERY",
            abbreviation: null,
            code: null,
          },
          {
            name: "NELSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "NEW KENT",
            abbreviation: null,
            code: null,
          },
          {
            name: "NEWPORT NEWS",
            abbreviation: null,
            code: null,
          },
          {
            name: "NORFOLK",
            abbreviation: null,
            code: null,
          },
          {
            name: "NORTHAMPTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "NORTHUMBERLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "NORTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "NOTTOWAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "ORANGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PAGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PATRICK",
            abbreviation: null,
            code: null,
          },
          {
            name: "PETERSBURG",
            abbreviation: null,
            code: null,
          },
          {
            name: "PITTSYLVANIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "POQUOSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "PORTSMOUTH",
            abbreviation: null,
            code: null,
          },
          {
            name: "POWHATAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "PRINCE EDWARD",
            abbreviation: null,
            code: null,
          },
          {
            name: "PRINCE GEORGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PRINCE WILLIAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "PULASKI",
            abbreviation: null,
            code: null,
          },
          {
            name: "RADFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "RAPPAHANNOCK",
            abbreviation: null,
            code: null,
          },
          {
            name: "RICHMOND",
            abbreviation: null,
            code: null,
          },
          {
            name: "RICHMOND",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROANOKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROANOKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROCKBRIDGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROCKINGHAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "RUSSELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "SALEM",
            abbreviation: null,
            code: null,
          },
          {
            name: "SCOTT",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHENANDOAH",
            abbreviation: null,
            code: null,
          },
          {
            name: "SMYTH",
            abbreviation: null,
            code: null,
          },
          {
            name: "SOUTHAMPTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "SPOTSYLVANIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "STAFFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "STAUNTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "SUFFOLK",
            abbreviation: null,
            code: null,
          },
          {
            name: "SURRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "SUSSEX",
            abbreviation: null,
            code: null,
          },
          {
            name: "TAZEWELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "VIRGINIA BEACH",
            abbreviation: null,
            code: null,
          },
          {
            name: "WARREN",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WAYNESBORO",
            abbreviation: null,
            code: null,
          },
          {
            name: "WESTMORELAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "WILLIAMSBURG",
            abbreviation: null,
            code: null,
          },
          {
            name: "WINCHESTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "WISE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WYTHE",
            abbreviation: null,
            code: null,
          },
          {
            name: "YORK",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Vermont",
        abbreviation: "VT",
        counties: [
          {
            name: "ADDISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "BENNINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CALEDONIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHITTENDEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "ESSEX",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRANKLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRAND ISLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAMOILLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ORANGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ORLEANS",
            abbreviation: null,
            code: null,
          },
          {
            name: "RUTLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WINDHAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "WINDSOR",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Washington",
        abbreviation: "WA",
        counties: [
          {
            name: "ADAMS",
            abbreviation: null,
            code: null,
          },
          {
            name: "ASOTIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "BENTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHELAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLALLAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLARK",
            abbreviation: null,
            code: null,
          },
          {
            name: "COLUMBIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "COWLITZ",
            abbreviation: null,
            code: null,
          },
          {
            name: "DOUGLAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "FERRY",
            abbreviation: null,
            code: null,
          },
          {
            name: "FRANKLIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "GARFIELD",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRANT",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRAYS HARBOR",
            abbreviation: null,
            code: null,
          },
          {
            name: "ISLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "KING",
            abbreviation: null,
            code: null,
          },
          {
            name: "KITSAP",
            abbreviation: null,
            code: null,
          },
          {
            name: "KITTITAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "KLICKITAT",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEWIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINCOLN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MASON",
            abbreviation: null,
            code: null,
          },
          {
            name: "OKANOGAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "PACIFIC",
            abbreviation: null,
            code: null,
          },
          {
            name: "PEND OREILLE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PIERCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SAN JUAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "SKAGIT",
            abbreviation: null,
            code: null,
          },
          {
            name: "SKAMANIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "SNOHOMISH",
            abbreviation: null,
            code: null,
          },
          {
            name: "SPOKANE",
            abbreviation: null,
            code: null,
          },
          {
            name: "STEVENS",
            abbreviation: null,
            code: null,
          },
          {
            name: "THURSTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WAHKIAKUM",
            abbreviation: null,
            code: null,
          },
          {
            name: "WALLA WALLA",
            abbreviation: null,
            code: null,
          },
          {
            name: "WHATCOM",
            abbreviation: null,
            code: null,
          },
          {
            name: "WHITMAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "YAKIMA",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Wisconsin",
        abbreviation: "WI",
        counties: [
          {
            name: "ADAMS",
            abbreviation: null,
            code: null,
          },
          {
            name: "ASHLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "BARRON",
            abbreviation: null,
            code: null,
          },
          {
            name: "BAYFIELD",
            abbreviation: null,
            code: null,
          },
          {
            name: "BROWN",
            abbreviation: null,
            code: null,
          },
          {
            name: "BUFFALO",
            abbreviation: null,
            code: null,
          },
          {
            name: "BURNETT",
            abbreviation: null,
            code: null,
          },
          {
            name: "CALUMET",
            abbreviation: null,
            code: null,
          },
          {
            name: "CHIPPEWA",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLARK",
            abbreviation: null,
            code: null,
          },
          {
            name: "COLUMBIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "CRAWFORD",
            abbreviation: null,
            code: null,
          },
          {
            name: "DANE",
            abbreviation: null,
            code: null,
          },
          {
            name: "DODGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "DOOR",
            abbreviation: null,
            code: null,
          },
          {
            name: "DOUGLAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "DUNN",
            abbreviation: null,
            code: null,
          },
          {
            name: "EAU CLAIRE",
            abbreviation: null,
            code: null,
          },
          {
            name: "FLORENCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "FOND DU LAC",
            abbreviation: null,
            code: null,
          },
          {
            name: "FOREST",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRANT",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREEN LAKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "IOWA",
            abbreviation: null,
            code: null,
          },
          {
            name: "IRON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JACKSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JUNEAU",
            abbreviation: null,
            code: null,
          },
          {
            name: "KENOSHA",
            abbreviation: null,
            code: null,
          },
          {
            name: "KEWAUNEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LA CROSSE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LAFAYETTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LANGLADE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINCOLN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MANITOWOC",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARATHON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARINETTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARQUETTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MENOMINEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MILWAUKEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONROE",
            abbreviation: null,
            code: null,
          },
          {
            name: "OCONTO",
            abbreviation: null,
            code: null,
          },
          {
            name: "ONEIDA",
            abbreviation: null,
            code: null,
          },
          {
            name: "OUTAGAMIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "OZAUKEE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PEPIN",
            abbreviation: null,
            code: null,
          },
          {
            name: "PIERCE",
            abbreviation: null,
            code: null,
          },
          {
            name: "POLK",
            abbreviation: null,
            code: null,
          },
          {
            name: "PORTAGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "PRICE",
            abbreviation: null,
            code: null,
          },
          {
            name: "RACINE",
            abbreviation: null,
            code: null,
          },
          {
            name: "RICHLAND",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROCK",
            abbreviation: null,
            code: null,
          },
          {
            name: "RUSK",
            abbreviation: null,
            code: null,
          },
          {
            name: "SAUK",
            abbreviation: null,
            code: null,
          },
          {
            name: "SAWYER",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHAWANO",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHEBOYGAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "ST CROIX",
            abbreviation: null,
            code: null,
          },
          {
            name: "TAYLOR",
            abbreviation: null,
            code: null,
          },
          {
            name: "TREMPEALEAU",
            abbreviation: null,
            code: null,
          },
          {
            name: "VERNON",
            abbreviation: null,
            code: null,
          },
          {
            name: "VILAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "WALWORTH",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHBURN",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHINGTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "WAUKESHA",
            abbreviation: null,
            code: null,
          },
          {
            name: "WAUPACA",
            abbreviation: null,
            code: null,
          },
          {
            name: "WAUSHARA",
            abbreviation: null,
            code: null,
          },
          {
            name: "WINNEBAGO",
            abbreviation: null,
            code: null,
          },
          {
            name: "WOOD",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "West Virginia",
        abbreviation: "WV",
        counties: [
          {
            name: "BARBOUR",
            abbreviation: null,
            code: null,
          },
          {
            name: "BERKELEY",
            abbreviation: null,
            code: null,
          },
          {
            name: "BOONE",
            abbreviation: null,
            code: null,
          },
          {
            name: "BRAXTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "BROOKE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CABELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "CALHOUN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CLAY",
            abbreviation: null,
            code: null,
          },
          {
            name: "DODDRIDGE",
            abbreviation: null,
            code: null,
          },
          {
            name: "FAYETTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "GILMER",
            abbreviation: null,
            code: null,
          },
          {
            name: "GRANT",
            abbreviation: null,
            code: null,
          },
          {
            name: "GREENBRIER",
            abbreviation: null,
            code: null,
          },
          {
            name: "HAMPSHIRE",
            abbreviation: null,
            code: null,
          },
          {
            name: "HANCOCK",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARDY",
            abbreviation: null,
            code: null,
          },
          {
            name: "HARRISON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JACKSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "JEFFERSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "KANAWHA",
            abbreviation: null,
            code: null,
          },
          {
            name: "LEWIS",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINCOLN",
            abbreviation: null,
            code: null,
          },
          {
            name: "LOGAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARION",
            abbreviation: null,
            code: null,
          },
          {
            name: "MARSHALL",
            abbreviation: null,
            code: null,
          },
          {
            name: "MASON",
            abbreviation: null,
            code: null,
          },
          {
            name: "MCDOWELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "MERCER",
            abbreviation: null,
            code: null,
          },
          {
            name: "MINERAL",
            abbreviation: null,
            code: null,
          },
          {
            name: "MINGO",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONONGALIA",
            abbreviation: null,
            code: null,
          },
          {
            name: "MONROE",
            abbreviation: null,
            code: null,
          },
          {
            name: "MORGAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "NICHOLAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "OHIO",
            abbreviation: null,
            code: null,
          },
          {
            name: "PENDLETON",
            abbreviation: null,
            code: null,
          },
          {
            name: "PLEASANTS",
            abbreviation: null,
            code: null,
          },
          {
            name: "POCAHONTAS",
            abbreviation: null,
            code: null,
          },
          {
            name: "PRESTON",
            abbreviation: null,
            code: null,
          },
          {
            name: "PUTNAM",
            abbreviation: null,
            code: null,
          },
          {
            name: "RALEIGH",
            abbreviation: null,
            code: null,
          },
          {
            name: "RANDOLPH",
            abbreviation: null,
            code: null,
          },
          {
            name: "RITCHIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "ROANE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SUMMERS",
            abbreviation: null,
            code: null,
          },
          {
            name: "TAYLOR",
            abbreviation: null,
            code: null,
          },
          {
            name: "TUCKER",
            abbreviation: null,
            code: null,
          },
          {
            name: "TYLER",
            abbreviation: null,
            code: null,
          },
          {
            name: "UPSHUR",
            abbreviation: null,
            code: null,
          },
          {
            name: "WAYNE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WEBSTER",
            abbreviation: null,
            code: null,
          },
          {
            name: "WETZEL",
            abbreviation: null,
            code: null,
          },
          {
            name: "WIRT",
            abbreviation: null,
            code: null,
          },
          {
            name: "WOOD",
            abbreviation: null,
            code: null,
          },
          {
            name: "WYOMING",
            abbreviation: null,
            code: null,
          },
        ],
      },
      {
        name: "Wyoming",
        abbreviation: "WY",
        counties: [
          {
            name: "ALBANY",
            abbreviation: null,
            code: null,
          },
          {
            name: "BIG HORN",
            abbreviation: null,
            code: null,
          },
          {
            name: "CAMPBELL",
            abbreviation: null,
            code: null,
          },
          {
            name: "CARBON",
            abbreviation: null,
            code: null,
          },
          {
            name: "CONVERSE",
            abbreviation: null,
            code: null,
          },
          {
            name: "CROOK",
            abbreviation: null,
            code: null,
          },
          {
            name: "FREMONT",
            abbreviation: null,
            code: null,
          },
          {
            name: "GOSHEN",
            abbreviation: null,
            code: null,
          },
          {
            name: "HOT SPRINGS",
            abbreviation: null,
            code: null,
          },
          {
            name: "JOHNSON",
            abbreviation: null,
            code: null,
          },
          {
            name: "LARAMIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "LINCOLN",
            abbreviation: null,
            code: null,
          },
          {
            name: "NATRONA",
            abbreviation: null,
            code: null,
          },
          {
            name: "NIOBRARA",
            abbreviation: null,
            code: null,
          },
          {
            name: "PARK",
            abbreviation: null,
            code: null,
          },
          {
            name: "PLATTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SHERIDAN",
            abbreviation: null,
            code: null,
          },
          {
            name: "SUBLETTE",
            abbreviation: null,
            code: null,
          },
          {
            name: "SWEETWATER",
            abbreviation: null,
            code: null,
          },
          {
            name: "TETON",
            abbreviation: null,
            code: null,
          },
          {
            name: "UINTA",
            abbreviation: null,
            code: null,
          },
          {
            name: "WASHAKIE",
            abbreviation: null,
            code: null,
          },
          {
            name: "WESTON",
            abbreviation: null,
            code: null,
          },
        ],
      },
    ],
    region: "usa",
    name: "United States",
  },
  {
    code: null,
    states: null,
    region: null,
    name: "United States Minor Outlying Islands",
  },
  {
    code: null,
    states: null,
    region: "southAmerica",
    name: "Uruguay",
  },
  {
    code: null,
    states: null,
    region: "asia",
    name: "Uzbekistan",
  },
  {
    code: null,
    states: null,
    region: "oceania",
    name: "Vanuatu",
  },
  {
    code: null,
    states: null,
    region: "southAmerica",
    name: "Venezuela",
  },
  {
    code: null,
    states: null,
    region: "asia",
    name: "Vietnam",
  },
  {
    code: null,
    states: null,
    region: "caribbean",
    name: "Virgin Islands, British",
  },
  {
    code: null,
    states: null,
    region: "caribbean",
    name: "Virgin Islands, U.S.",
  },
  {
    code: null,
    states: null,
    region: "oceania",
    name: "Wallis and Futuna",
  },
  {
    code: null,
    states: null,
    region: "africa",
    name: "Western Sahara",
  },
  {
    code: null,
    states: null,
    region: "middleEast",
    name: "Yemen",
  },
  {
    code: null,
    states: null,
    region: "africa",
    name: "Zambia",
  },
  {
    code: null,
    states: null,
    region: "africa",
    name: "Zimbabwe",
  },
];

export const jobTitles = [
  "Architect",
  "Contractor",
  "Distributor",
  "Engineer",
  "Government",
  "Homeowner",
  "Cultec Employee",
];
export const preferredUnitOptions = [
  { name: "Metric", code: "metric" },
  { name: "Imperial", code: "imperial" },
];

export const companyBrand = [
  "ADS",
  "Cultec",
  "IDEAL PIPE",
  "BaySaver",
  "GLP",
  "Foltz",
  "Inserta Tee",
  "DPLY",
  "ADSM",
  "Piedmont",
  "Hancor",
  "Century",
  "Advanced Drainage Structures",
];

export const market = ["Residential/Commercial", "Agriculture"];



// WEBPACK FOOTER //
// ./src/components/SignUp/signup.constant.js